export type Json =
  | string
  | number
  | boolean
  | null
  | { [key: string]: Json | undefined }
  | Json[]

export type Database = {
  graphql_public: {
    Tables: {
      [_ in never]: never
    }
    Views: {
      [_ in never]: never
    }
    Functions: {
      graphql: {
        Args: {
          extensions?: Json
          operationName?: string
          query?: string
          variables?: Json
        }
        Returns: Json
      }
    }
    Enums: {
      [_ in never]: never
    }
    CompositeTypes: {
      [_ in never]: never
    }
  }
  public: {
    Tables: {
      administration_routes: {
        Row: {
          created_at: string | null
          id: string
          is_active: boolean | null
          name: string
        }
        Insert: {
          created_at?: string | null
          id?: string
          is_active?: boolean | null
          name: string
        }
        Update: {
          created_at?: string | null
          id?: string
          is_active?: boolean | null
          name?: string
        }
        Relationships: []
      }
      application_follow_up_tracking: {
        Row: {
          blocked_reason: string | null
          clinic_id: string
          created_at: string
          due_date: string
          id: string
          last_contact_at: string | null
          last_contact_by: string | null
          last_contact_channel: string | null
          last_contact_result: string | null
          last_contact_source: string | null
          notes: string | null
          operational_status: string
          pet_application_id: string | null
          pet_application_plan_id: string | null
          updated_at: string
        }
        Insert: {
          blocked_reason?: string | null
          clinic_id: string
          created_at?: string
          due_date: string
          id?: string
          last_contact_at?: string | null
          last_contact_by?: string | null
          last_contact_channel?: string | null
          last_contact_result?: string | null
          last_contact_source?: string | null
          notes?: string | null
          operational_status?: string
          pet_application_id?: string | null
          pet_application_plan_id?: string | null
          updated_at?: string
        }
        Update: {
          blocked_reason?: string | null
          clinic_id?: string
          created_at?: string
          due_date?: string
          id?: string
          last_contact_at?: string | null
          last_contact_by?: string | null
          last_contact_channel?: string | null
          last_contact_result?: string | null
          last_contact_source?: string | null
          notes?: string | null
          operational_status?: string
          pet_application_id?: string | null
          pet_application_plan_id?: string | null
          updated_at?: string
        }
        Relationships: [
          {
            foreignKeyName: "application_follow_up_tracking_clinic_id_fkey"
            columns: ["clinic_id"]
            isOneToOne: false
            referencedRelation: "clinics"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "application_follow_up_tracking_last_contact_by_fkey"
            columns: ["last_contact_by"]
            isOneToOne: false
            referencedRelation: "profiles"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "application_follow_up_tracking_pet_application_id_fkey"
            columns: ["pet_application_id"]
            isOneToOne: false
            referencedRelation: "pet_applications"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "application_follow_up_tracking_pet_application_plan_id_fkey"
            columns: ["pet_application_plan_id"]
            isOneToOne: false
            referencedRelation: "pet_application_plans"
            referencedColumns: ["id"]
          },
        ]
      }
      appointment_belongings: {
        Row: {
          appointment_id: string
          created_at: string
          created_by: string
          id: string
          name: string
          returned: boolean
          returned_at: string | null
          returned_by: string | null
        }
        Insert: {
          appointment_id: string
          created_at?: string
          created_by: string
          id?: string
          name: string
          returned?: boolean
          returned_at?: string | null
          returned_by?: string | null
        }
        Update: {
          appointment_id?: string
          created_at?: string
          created_by?: string
          id?: string
          name?: string
          returned?: boolean
          returned_at?: string | null
          returned_by?: string | null
        }
        Relationships: [
          {
            foreignKeyName: "appointment_belongings_appointment_id_fkey"
            columns: ["appointment_id"]
            isOneToOne: false
            referencedRelation: "appointments"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "appointment_belongings_created_by_fkey"
            columns: ["created_by"]
            isOneToOne: false
            referencedRelation: "profiles"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "appointment_belongings_returned_by_fkey"
            columns: ["returned_by"]
            isOneToOne: false
            referencedRelation: "profiles"
            referencedColumns: ["id"]
          },
        ]
      }
      appointment_financials: {
        Row: {
          appointment_id: string
          created_at: string
          is_covered_by_package: boolean
          owner_package_id: string | null
          sale_id: string | null
          source: Database["public"]["Enums"]["appointment_financial_source"]
          status: Database["public"]["Enums"]["appointment_financial_status"]
          updated_at: string
          updated_by: string | null
        }
        Insert: {
          appointment_id: string
          created_at?: string
          is_covered_by_package?: boolean
          owner_package_id?: string | null
          sale_id?: string | null
          source?: Database["public"]["Enums"]["appointment_financial_source"]
          status?: Database["public"]["Enums"]["appointment_financial_status"]
          updated_at?: string
          updated_by?: string | null
        }
        Update: {
          appointment_id?: string
          created_at?: string
          is_covered_by_package?: boolean
          owner_package_id?: string | null
          sale_id?: string | null
          source?: Database["public"]["Enums"]["appointment_financial_source"]
          status?: Database["public"]["Enums"]["appointment_financial_status"]
          updated_at?: string
          updated_by?: string | null
        }
        Relationships: [
          {
            foreignKeyName: "appointment_financials_appointment_id_fkey"
            columns: ["appointment_id"]
            isOneToOne: true
            referencedRelation: "appointments"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "appointment_financials_owner_package_id_fkey"
            columns: ["owner_package_id"]
            isOneToOne: false
            referencedRelation: "owner_packages"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "appointment_financials_sale_id_fkey"
            columns: ["sale_id"]
            isOneToOne: false
            referencedRelation: "sales"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "appointment_financials_updated_by_fkey"
            columns: ["updated_by"]
            isOneToOne: false
            referencedRelation: "profiles"
            referencedColumns: ["id"]
          },
        ]
      }
      appointment_items: {
        Row: {
          appointment_id: string
          created_at: string | null
          id: string
          item_id: string
          qty: number
          title_snapshot: string
          updated_at: string | null
        }
        Insert: {
          appointment_id: string
          created_at?: string | null
          id?: string
          item_id: string
          qty?: number
          title_snapshot?: string
          updated_at?: string | null
        }
        Update: {
          appointment_id?: string
          created_at?: string | null
          id?: string
          item_id?: string
          qty?: number
          title_snapshot?: string
          updated_at?: string | null
        }
        Relationships: [
          {
            foreignKeyName: "appointment_items_appointment_id_fkey"
            columns: ["appointment_id"]
            isOneToOne: false
            referencedRelation: "appointments"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "appointment_items_item_id_fkey"
            columns: ["item_id"]
            isOneToOne: false
            referencedRelation: "grooming_services_view"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "appointment_items_item_id_fkey"
            columns: ["item_id"]
            isOneToOne: false
            referencedRelation: "items"
            referencedColumns: ["id"]
          },
        ]
      }
      appointment_patient_packages: {
        Row: {
          appointment_id: string
          billing_intent: string
          catalog_package_id: string | null
          clinic_id: string
          consumed_at: string | null
          consumption_status: Database["public"]["Enums"]["appointment_package_consumption_status"]
          created_at: string
          id: string
          mode: Database["public"]["Enums"]["appointment_package_mode"]
          patient_package_id: string | null
          pet_id: string
          sessions_to_consume: number
          suggested_charge_amount: number
          updated_at: string
        }
        Insert: {
          appointment_id: string
          billing_intent?: string
          catalog_package_id?: string | null
          clinic_id: string
          consumed_at?: string | null
          consumption_status?: Database["public"]["Enums"]["appointment_package_consumption_status"]
          created_at?: string
          id?: string
          mode: Database["public"]["Enums"]["appointment_package_mode"]
          patient_package_id?: string | null
          pet_id: string
          sessions_to_consume?: number
          suggested_charge_amount?: number
          updated_at?: string
        }
        Update: {
          appointment_id?: string
          billing_intent?: string
          catalog_package_id?: string | null
          clinic_id?: string
          consumed_at?: string | null
          consumption_status?: Database["public"]["Enums"]["appointment_package_consumption_status"]
          created_at?: string
          id?: string
          mode?: Database["public"]["Enums"]["appointment_package_mode"]
          patient_package_id?: string | null
          pet_id?: string
          sessions_to_consume?: number
          suggested_charge_amount?: number
          updated_at?: string
        }
        Relationships: [
          {
            foreignKeyName: "appointment_patient_packages_appointment_id_fkey"
            columns: ["appointment_id"]
            isOneToOne: false
            referencedRelation: "appointments"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "appointment_patient_packages_catalog_package_id_fkey"
            columns: ["catalog_package_id"]
            isOneToOne: false
            referencedRelation: "catalog_packages"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "appointment_patient_packages_clinic_id_fkey"
            columns: ["clinic_id"]
            isOneToOne: false
            referencedRelation: "clinics"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "appointment_patient_packages_patient_package_id_fkey"
            columns: ["patient_package_id"]
            isOneToOne: false
            referencedRelation: "patient_packages"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "appointment_patient_packages_pet_id_fkey"
            columns: ["pet_id"]
            isOneToOne: false
            referencedRelation: "pets"
            referencedColumns: ["id"]
          },
        ]
      }
      appointment_pets: {
        Row: {
          appointment_id: string
          created_at: string
          pet_id: string
        }
        Insert: {
          appointment_id: string
          created_at?: string
          pet_id: string
        }
        Update: {
          appointment_id?: string
          created_at?: string
          pet_id?: string
        }
        Relationships: [
          {
            foreignKeyName: "appointment_pets_appointment_id_fkey"
            columns: ["appointment_id"]
            isOneToOne: false
            referencedRelation: "appointments"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "appointment_pets_pet_id_fkey"
            columns: ["pet_id"]
            isOneToOne: false
            referencedRelation: "pets"
            referencedColumns: ["id"]
          },
        ]
      }
      appointment_statuses: {
        Row: {
          created_at: string | null
          description: string | null
          display_name: string
          is_active: boolean | null
          name: string
          sort_order: number | null
          updated_at: string | null
        }
        Insert: {
          created_at?: string | null
          description?: string | null
          display_name: string
          is_active?: boolean | null
          name: string
          sort_order?: number | null
          updated_at?: string | null
        }
        Update: {
          created_at?: string | null
          description?: string | null
          display_name?: string
          is_active?: boolean | null
          name?: string
          sort_order?: number | null
          updated_at?: string | null
        }
        Relationships: []
      }
      appointments: {
        Row: {
          boarding_space_id: string | null
          check_in_at: string | null
          check_out_at: string | null
          clinic_id: string
          created_at: string | null
          created_by_user_id: string
          deleted_at: string | null
          deleted_by: string | null
          ends_at: string
          id: string
          is_all_day: boolean
          is_recurrence_exception: boolean
          is_taxi_dog: boolean
          notes: string | null
          owner_id: string
          pet_id: string
          recurrence_id: string | null
          recurrence_occurrence_date: string | null
          starts_at: string
          status: string
          taxi_dog_type: string | null
          type: string | null
          updated_at: string | null
          vet_user_id: string | null
        }
        Insert: {
          boarding_space_id?: string | null
          check_in_at?: string | null
          check_out_at?: string | null
          clinic_id: string
          created_at?: string | null
          created_by_user_id: string
          deleted_at?: string | null
          deleted_by?: string | null
          ends_at: string
          id?: string
          is_all_day?: boolean
          is_recurrence_exception?: boolean
          is_taxi_dog?: boolean
          notes?: string | null
          owner_id: string
          pet_id: string
          recurrence_id?: string | null
          recurrence_occurrence_date?: string | null
          starts_at: string
          status?: string
          taxi_dog_type?: string | null
          type?: string | null
          updated_at?: string | null
          vet_user_id?: string | null
        }
        Update: {
          boarding_space_id?: string | null
          check_in_at?: string | null
          check_out_at?: string | null
          clinic_id?: string
          created_at?: string | null
          created_by_user_id?: string
          deleted_at?: string | null
          deleted_by?: string | null
          ends_at?: string
          id?: string
          is_all_day?: boolean
          is_recurrence_exception?: boolean
          is_taxi_dog?: boolean
          notes?: string | null
          owner_id?: string
          pet_id?: string
          recurrence_id?: string | null
          recurrence_occurrence_date?: string | null
          starts_at?: string
          status?: string
          taxi_dog_type?: string | null
          type?: string | null
          updated_at?: string | null
          vet_user_id?: string | null
        }
        Relationships: [
          {
            foreignKeyName: "appointments_appointment_type_id_fkey"
            columns: ["type"]
            isOneToOne: false
            referencedRelation: "clinic_appointment_types"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "appointments_clinic_id_fkey"
            columns: ["clinic_id"]
            isOneToOne: false
            referencedRelation: "clinics"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "appointments_created_by_user_id_fkey"
            columns: ["created_by_user_id"]
            isOneToOne: false
            referencedRelation: "profiles"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "appointments_owner_id_fkey"
            columns: ["owner_id"]
            isOneToOne: false
            referencedRelation: "owners"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "appointments_pet_id_fkey"
            columns: ["pet_id"]
            isOneToOne: false
            referencedRelation: "pets"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "appointments_recurrence_id_fkey"
            columns: ["recurrence_id"]
            isOneToOne: false
            referencedRelation: "recurrence"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "appointments_vet_user_id_fkey"
            columns: ["vet_user_id"]
            isOneToOne: false
            referencedRelation: "profiles"
            referencedColumns: ["id"]
          },
        ]
      }
      audit_log: {
        Row: {
          action: string
          changed_fields: string[] | null
          created_at: string
          id: string
          ip_address: unknown
          metadata: Json | null
          new_values: Json | null
          old_values: Json | null
          record_id: string
          source: string
          table_name: string
          user_agent: string | null
          user_id: string | null
        }
        Insert: {
          action: string
          changed_fields?: string[] | null
          created_at?: string
          id?: string
          ip_address?: unknown
          metadata?: Json | null
          new_values?: Json | null
          old_values?: Json | null
          record_id: string
          source?: string
          table_name: string
          user_agent?: string | null
          user_id?: string | null
        }
        Update: {
          action?: string
          changed_fields?: string[] | null
          created_at?: string
          id?: string
          ip_address?: unknown
          metadata?: Json | null
          new_values?: Json | null
          old_values?: Json | null
          record_id?: string
          source?: string
          table_name?: string
          user_agent?: string | null
          user_id?: string | null
        }
        Relationships: []
      }
      brands: {
        Row: {
          created_at: string | null
          id: string
          is_active: boolean | null
          name: string
        }
        Insert: {
          created_at?: string | null
          id?: string
          is_active?: boolean | null
          name: string
        }
        Update: {
          created_at?: string | null
          id?: string
          is_active?: boolean | null
          name?: string
        }
        Relationships: []
      }
      breeds: {
        Row: {
          created_at: string | null
          customer_id: string | null
          id: string
          name: string
          species_id: string
        }
        Insert: {
          created_at?: string | null
          customer_id?: string | null
          id?: string
          name: string
          species_id: string
        }
        Update: {
          created_at?: string | null
          customer_id?: string | null
          id?: string
          name?: string
          species_id?: string
        }
        Relationships: [
          {
            foreignKeyName: "breeds_customer_id_fkey"
            columns: ["customer_id"]
            isOneToOne: false
            referencedRelation: "customers"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "breeds_species_id_fkey"
            columns: ["species_id"]
            isOneToOne: false
            referencedRelation: "species"
            referencedColumns: ["id"]
          },
        ]
      }
      calendar_blocks: {
        Row: {
          clinic_id: string
          created_at: string | null
          ends_at: string
          id: string
          reason: string | null
          starts_at: string
          updated_at: string | null
          vet_user_id: string | null
        }
        Insert: {
          clinic_id: string
          created_at?: string | null
          ends_at: string
          id?: string
          reason?: string | null
          starts_at: string
          updated_at?: string | null
          vet_user_id?: string | null
        }
        Update: {
          clinic_id?: string
          created_at?: string | null
          ends_at?: string
          id?: string
          reason?: string | null
          starts_at?: string
          updated_at?: string | null
          vet_user_id?: string | null
        }
        Relationships: [
          {
            foreignKeyName: "calendar_blocks_clinic_id_fkey"
            columns: ["clinic_id"]
            isOneToOne: false
            referencedRelation: "clinics"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "calendar_blocks_vet_user_id_fkey"
            columns: ["vet_user_id"]
            isOneToOne: false
            referencedRelation: "profiles"
            referencedColumns: ["id"]
          },
        ]
      }
      campaign_attribution: {
        Row: {
          appointment_id: string | null
          attributed_revenue: number
          campaign_id: string
          clinic_id: string
          created_at: string
          days_to_conversion: number | null
          id: string
          owner_id: string
          sale_id: string | null
        }
        Insert: {
          appointment_id?: string | null
          attributed_revenue?: number
          campaign_id: string
          clinic_id: string
          created_at?: string
          days_to_conversion?: number | null
          id?: string
          owner_id: string
          sale_id?: string | null
        }
        Update: {
          appointment_id?: string | null
          attributed_revenue?: number
          campaign_id?: string
          clinic_id?: string
          created_at?: string
          days_to_conversion?: number | null
          id?: string
          owner_id?: string
          sale_id?: string | null
        }
        Relationships: [
          {
            foreignKeyName: "campaign_attribution_appointment_id_fkey"
            columns: ["appointment_id"]
            isOneToOne: false
            referencedRelation: "appointments"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "campaign_attribution_campaign_id_fkey"
            columns: ["campaign_id"]
            isOneToOne: false
            referencedRelation: "campaigns"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "campaign_attribution_owner_id_fkey"
            columns: ["owner_id"]
            isOneToOne: false
            referencedRelation: "owners"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "campaign_attribution_sale_id_fkey"
            columns: ["sale_id"]
            isOneToOne: false
            referencedRelation: "sales"
            referencedColumns: ["id"]
          },
        ]
      }
      campaign_recipients: {
        Row: {
          campaign_id: string
          clinic_id: string
          created_at: string
          delivered_at: string | null
          error_code: string | null
          error_message: string | null
          failed_at: string | null
          id: string
          meta_message_id: string | null
          owner_id: string
          phone_number: string | null
          read_at: string | null
          resolved_variables: Json
          sent_at: string | null
          skip_reason: string | null
          status: string
          updated_at: string
        }
        Insert: {
          campaign_id: string
          clinic_id: string
          created_at?: string
          delivered_at?: string | null
          error_code?: string | null
          error_message?: string | null
          failed_at?: string | null
          id?: string
          meta_message_id?: string | null
          owner_id: string
          phone_number?: string | null
          read_at?: string | null
          resolved_variables?: Json
          sent_at?: string | null
          skip_reason?: string | null
          status?: string
          updated_at?: string
        }
        Update: {
          campaign_id?: string
          clinic_id?: string
          created_at?: string
          delivered_at?: string | null
          error_code?: string | null
          error_message?: string | null
          failed_at?: string | null
          id?: string
          meta_message_id?: string | null
          owner_id?: string
          phone_number?: string | null
          read_at?: string | null
          resolved_variables?: Json
          sent_at?: string | null
          skip_reason?: string | null
          status?: string
          updated_at?: string
        }
        Relationships: [
          {
            foreignKeyName: "campaign_recipients_campaign_id_fkey"
            columns: ["campaign_id"]
            isOneToOne: false
            referencedRelation: "campaigns"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "campaign_recipients_owner_id_fkey"
            columns: ["owner_id"]
            isOneToOne: false
            referencedRelation: "owners"
            referencedColumns: ["id"]
          },
        ]
      }
      campaigns: {
        Row: {
          audience_filter: Json
          clinic_id: string
          created_at: string
          created_by: string | null
          deleted_at: string | null
          description: string | null
          dispatched_at: string | null
          estimated_cost_brl: number | null
          estimated_recipients: number | null
          failure_reason: string | null
          id: string
          name: string
          scheduled_at: string | null
          status: string
          template_id: string
          total_delivered: number
          total_failed: number
          total_read: number
          total_sent: number
          updated_at: string
          updated_by: string | null
        }
        Insert: {
          audience_filter?: Json
          clinic_id: string
          created_at?: string
          created_by?: string | null
          deleted_at?: string | null
          description?: string | null
          dispatched_at?: string | null
          estimated_cost_brl?: number | null
          estimated_recipients?: number | null
          failure_reason?: string | null
          id?: string
          name: string
          scheduled_at?: string | null
          status?: string
          template_id: string
          total_delivered?: number
          total_failed?: number
          total_read?: number
          total_sent?: number
          updated_at?: string
          updated_by?: string | null
        }
        Update: {
          audience_filter?: Json
          clinic_id?: string
          created_at?: string
          created_by?: string | null
          deleted_at?: string | null
          description?: string | null
          dispatched_at?: string | null
          estimated_cost_brl?: number | null
          estimated_recipients?: number | null
          failure_reason?: string | null
          id?: string
          name?: string
          scheduled_at?: string | null
          status?: string
          template_id?: string
          total_delivered?: number
          total_failed?: number
          total_read?: number
          total_sent?: number
          updated_at?: string
          updated_by?: string | null
        }
        Relationships: [
          {
            foreignKeyName: "campaigns_clinic_id_fkey"
            columns: ["clinic_id"]
            isOneToOne: false
            referencedRelation: "clinics"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "campaigns_created_by_fkey"
            columns: ["created_by"]
            isOneToOne: false
            referencedRelation: "profiles"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "campaigns_template_id_fkey"
            columns: ["template_id"]
            isOneToOne: false
            referencedRelation: "whatsapp_message_templates"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "campaigns_updated_by_fkey"
            columns: ["updated_by"]
            isOneToOne: false
            referencedRelation: "profiles"
            referencedColumns: ["id"]
          },
        ]
      }
      catalog_package_items: {
        Row: {
          catalog_package_id: string
          created_at: string
          id: string
          is_free_line: boolean
          item_id: string | null
          item_name_snapshot: string
          sessions_total: number
          sort_order: number
          unit_price_snapshot: number
          updated_at: string
        }
        Insert: {
          catalog_package_id: string
          created_at?: string
          id?: string
          is_free_line?: boolean
          item_id?: string | null
          item_name_snapshot: string
          sessions_total?: number
          sort_order?: number
          unit_price_snapshot?: number
          updated_at?: string
        }
        Update: {
          catalog_package_id?: string
          created_at?: string
          id?: string
          is_free_line?: boolean
          item_id?: string | null
          item_name_snapshot?: string
          sessions_total?: number
          sort_order?: number
          unit_price_snapshot?: number
          updated_at?: string
        }
        Relationships: [
          {
            foreignKeyName: "catalog_package_items_catalog_package_id_fkey"
            columns: ["catalog_package_id"]
            isOneToOne: false
            referencedRelation: "catalog_packages"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "catalog_package_items_item_id_fkey"
            columns: ["item_id"]
            isOneToOne: false
            referencedRelation: "grooming_services_view"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "catalog_package_items_item_id_fkey"
            columns: ["item_id"]
            isOneToOne: false
            referencedRelation: "items"
            referencedColumns: ["id"]
          },
        ]
      }
      catalog_packages: {
        Row: {
          charge_mode: Database["public"]["Enums"]["package_charge_mode"]
          controls_sessions: boolean
          created_at: string
          created_by: string | null
          customer_id: string
          default_sessions: number
          deleted_at: string | null
          deleted_by: string | null
          id: string
          item_id: string
          notes: string | null
          updated_at: string
        }
        Insert: {
          charge_mode?: Database["public"]["Enums"]["package_charge_mode"]
          controls_sessions?: boolean
          created_at?: string
          created_by?: string | null
          customer_id: string
          default_sessions?: number
          deleted_at?: string | null
          deleted_by?: string | null
          id?: string
          item_id: string
          notes?: string | null
          updated_at?: string
        }
        Update: {
          charge_mode?: Database["public"]["Enums"]["package_charge_mode"]
          controls_sessions?: boolean
          created_at?: string
          created_by?: string | null
          customer_id?: string
          default_sessions?: number
          deleted_at?: string | null
          deleted_by?: string | null
          id?: string
          item_id?: string
          notes?: string | null
          updated_at?: string
        }
        Relationships: [
          {
            foreignKeyName: "catalog_packages_created_by_fkey"
            columns: ["created_by"]
            isOneToOne: false
            referencedRelation: "profiles"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "catalog_packages_customer_id_fkey"
            columns: ["customer_id"]
            isOneToOne: false
            referencedRelation: "customers"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "catalog_packages_deleted_by_fkey"
            columns: ["deleted_by"]
            isOneToOne: false
            referencedRelation: "profiles"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "catalog_packages_item_id_fkey"
            columns: ["item_id"]
            isOneToOne: false
            referencedRelation: "grooming_services_view"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "catalog_packages_item_id_fkey"
            columns: ["item_id"]
            isOneToOne: false
            referencedRelation: "items"
            referencedColumns: ["id"]
          },
        ]
      }
      categories: {
        Row: {
          created_at: string | null
          description: string | null
          id: string
          is_active: boolean | null
          name: string
          parent_id: string | null
          updated_at: string | null
        }
        Insert: {
          created_at?: string | null
          description?: string | null
          id?: string
          is_active?: boolean | null
          name: string
          parent_id?: string | null
          updated_at?: string | null
        }
        Update: {
          created_at?: string | null
          description?: string | null
          id?: string
          is_active?: boolean | null
          name?: string
          parent_id?: string | null
          updated_at?: string | null
        }
        Relationships: [
          {
            foreignKeyName: "categories_parent_id_fkey"
            columns: ["parent_id"]
            isOneToOne: false
            referencedRelation: "categories"
            referencedColumns: ["id"]
          },
        ]
      }
      cities: {
        Row: {
          created_at: string | null
          ibge_code: string | null
          id: string
          name: string
          state_id: string
        }
        Insert: {
          created_at?: string | null
          ibge_code?: string | null
          id?: string
          name: string
          state_id: string
        }
        Update: {
          created_at?: string | null
          ibge_code?: string | null
          id?: string
          name?: string
          state_id?: string
        }
        Relationships: [
          {
            foreignKeyName: "cities_state_id_fkey"
            columns: ["state_id"]
            isOneToOne: false
            referencedRelation: "states"
            referencedColumns: ["id"]
          },
        ]
      }
      clinic_appointment_statuses: {
        Row: {
          behavior: string | null
          canonical_status: string
          clinic_id: string
          color: string
          created_at: string
          description: string | null
          display_name: string
          final_type: string
          id: string
          is_active: boolean
          is_system: boolean
          scope: string
          sort_order: number
          updated_at: string
        }
        Insert: {
          behavior?: string | null
          canonical_status: string
          clinic_id: string
          color?: string
          created_at?: string
          description?: string | null
          display_name: string
          final_type: string
          id?: string
          is_active?: boolean
          is_system?: boolean
          scope: string
          sort_order: number
          updated_at?: string
        }
        Update: {
          behavior?: string | null
          canonical_status?: string
          clinic_id?: string
          color?: string
          created_at?: string
          description?: string | null
          display_name?: string
          final_type?: string
          id?: string
          is_active?: boolean
          is_system?: boolean
          scope?: string
          sort_order?: number
          updated_at?: string
        }
        Relationships: [
          {
            foreignKeyName: "clinic_appointment_statuses_clinic_id_fkey"
            columns: ["clinic_id"]
            isOneToOne: false
            referencedRelation: "clinics"
            referencedColumns: ["id"]
          },
        ]
      }
      clinic_appointment_types: {
        Row: {
          active: boolean
          behavior: string
          clinic_id: string
          color: string
          created_at: string
          icon: string
          id: string
          name: string
          order: number
        }
        Insert: {
          active?: boolean
          behavior: string
          clinic_id: string
          color?: string
          created_at?: string
          icon?: string
          id?: string
          name: string
          order?: number
        }
        Update: {
          active?: boolean
          behavior?: string
          clinic_id?: string
          color?: string
          created_at?: string
          icon?: string
          id?: string
          name?: string
          order?: number
        }
        Relationships: [
          {
            foreignKeyName: "clinic_appointment_types_clinic_id_fkey"
            columns: ["clinic_id"]
            isOneToOne: false
            referencedRelation: "clinics"
            referencedColumns: ["id"]
          },
        ]
      }
      clinic_fiscal_settings: {
        Row: {
          address_neighborhood: string | null
          address_number: string | null
          address_street: string | null
          address_zip_code: string | null
          clinic_id: string
          cnpj: string | null
          codigo_municipio_emitente: string | null
          company_name: string | null
          complemento_emitente: string | null
          created_at: string
          customer_id: string
          default_nfce_operation_nature: string | null
          default_nfce_series: string | null
          default_nfse_cbs_aliquota: number | null
          default_nfse_cnae: string | null
          default_nfse_ibs_cbs_classificacao_tributaria: string | null
          default_nfse_ibs_cbs_situacao_tributaria: string | null
          default_nfse_ibs_mun_aliquota: number | null
          default_nfse_ibs_uf_aliquota: number | null
          default_nfse_iss_rate: number | null
          default_nfse_iss_retido: boolean | null
          default_nfse_natureza_operacao: string | null
          default_nfse_optante_simples_nacional: boolean | null
          default_nfse_regime_especial_tributacao: string | null
          default_nfse_series: string | null
          default_nfse_service_code: string | null
          default_nfse_service_list_item: string | null
          environment: string
          focus_api_token: string | null
          focus_empresa_id: string | null
          id: string
          municipal_code: string | null
          municipal_name: string | null
          municipal_registration: string | null
          regime_tributario_emitente: string | null
          state_registration: string | null
          tax_regime_code: string | null
          telefone_emitente: string | null
          trade_name: string | null
          uf: string | null
          updated_at: string
        }
        Insert: {
          address_neighborhood?: string | null
          address_number?: string | null
          address_street?: string | null
          address_zip_code?: string | null
          clinic_id: string
          cnpj?: string | null
          codigo_municipio_emitente?: string | null
          company_name?: string | null
          complemento_emitente?: string | null
          created_at?: string
          customer_id: string
          default_nfce_operation_nature?: string | null
          default_nfce_series?: string | null
          default_nfse_cbs_aliquota?: number | null
          default_nfse_cnae?: string | null
          default_nfse_ibs_cbs_classificacao_tributaria?: string | null
          default_nfse_ibs_cbs_situacao_tributaria?: string | null
          default_nfse_ibs_mun_aliquota?: number | null
          default_nfse_ibs_uf_aliquota?: number | null
          default_nfse_iss_rate?: number | null
          default_nfse_iss_retido?: boolean | null
          default_nfse_natureza_operacao?: string | null
          default_nfse_optante_simples_nacional?: boolean | null
          default_nfse_regime_especial_tributacao?: string | null
          default_nfse_series?: string | null
          default_nfse_service_code?: string | null
          default_nfse_service_list_item?: string | null
          environment?: string
          focus_api_token?: string | null
          focus_empresa_id?: string | null
          id?: string
          municipal_code?: string | null
          municipal_name?: string | null
          municipal_registration?: string | null
          regime_tributario_emitente?: string | null
          state_registration?: string | null
          tax_regime_code?: string | null
          telefone_emitente?: string | null
          trade_name?: string | null
          uf?: string | null
          updated_at?: string
        }
        Update: {
          address_neighborhood?: string | null
          address_number?: string | null
          address_street?: string | null
          address_zip_code?: string | null
          clinic_id?: string
          cnpj?: string | null
          codigo_municipio_emitente?: string | null
          company_name?: string | null
          complemento_emitente?: string | null
          created_at?: string
          customer_id?: string
          default_nfce_operation_nature?: string | null
          default_nfce_series?: string | null
          default_nfse_cbs_aliquota?: number | null
          default_nfse_cnae?: string | null
          default_nfse_ibs_cbs_classificacao_tributaria?: string | null
          default_nfse_ibs_cbs_situacao_tributaria?: string | null
          default_nfse_ibs_mun_aliquota?: number | null
          default_nfse_ibs_uf_aliquota?: number | null
          default_nfse_iss_rate?: number | null
          default_nfse_iss_retido?: boolean | null
          default_nfse_natureza_operacao?: string | null
          default_nfse_optante_simples_nacional?: boolean | null
          default_nfse_regime_especial_tributacao?: string | null
          default_nfse_series?: string | null
          default_nfse_service_code?: string | null
          default_nfse_service_list_item?: string | null
          environment?: string
          focus_api_token?: string | null
          focus_empresa_id?: string | null
          id?: string
          municipal_code?: string | null
          municipal_name?: string | null
          municipal_registration?: string | null
          regime_tributario_emitente?: string | null
          state_registration?: string | null
          tax_regime_code?: string | null
          telefone_emitente?: string | null
          trade_name?: string | null
          uf?: string | null
          updated_at?: string
        }
        Relationships: [
          {
            foreignKeyName: "clinic_fiscal_settings_clinic_id_fkey"
            columns: ["clinic_id"]
            isOneToOne: true
            referencedRelation: "clinics"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "clinic_fiscal_settings_customer_id_fkey"
            columns: ["customer_id"]
            isOneToOne: false
            referencedRelation: "customers"
            referencedColumns: ["id"]
          },
        ]
      }
      clinic_meta_connections: {
        Row: {
          access_token: string | null
          access_token_expires_at: string | null
          access_token_scopes: Json | null
          access_token_type: string | null
          catalog_ids: Json | null
          clinic_id: string
          connected_at: string
          connected_by: string | null
          created_at: string
          dataset_ids: Json | null
          embedded_signup_event: string | null
          embedded_signup_payload: Json | null
          embedded_signup_type: string | null
          instagram_account_ids: Json | null
          is_enabled: boolean
          last_error: string | null
          last_sync_at: string | null
          meta_business_id: string | null
          meta_token_updated_by: string | null
          page_ids: Json | null
          phone_number_id: string | null
          recipient_strategy: string
          send_mode: string
          status: string
          template_language: string
          template_name: string | null
          template_variable_mapping: Json
          updated_at: string
          waba_id: string | null
        }
        Insert: {
          access_token?: string | null
          access_token_expires_at?: string | null
          access_token_scopes?: Json | null
          access_token_type?: string | null
          catalog_ids?: Json | null
          clinic_id: string
          connected_at?: string
          connected_by?: string | null
          created_at?: string
          dataset_ids?: Json | null
          embedded_signup_event?: string | null
          embedded_signup_payload?: Json | null
          embedded_signup_type?: string | null
          instagram_account_ids?: Json | null
          is_enabled?: boolean
          last_error?: string | null
          last_sync_at?: string | null
          meta_business_id?: string | null
          meta_token_updated_by?: string | null
          page_ids?: Json | null
          phone_number_id?: string | null
          recipient_strategy?: string
          send_mode?: string
          status?: string
          template_language?: string
          template_name?: string | null
          template_variable_mapping?: Json
          updated_at?: string
          waba_id?: string | null
        }
        Update: {
          access_token?: string | null
          access_token_expires_at?: string | null
          access_token_scopes?: Json | null
          access_token_type?: string | null
          catalog_ids?: Json | null
          clinic_id?: string
          connected_at?: string
          connected_by?: string | null
          created_at?: string
          dataset_ids?: Json | null
          embedded_signup_event?: string | null
          embedded_signup_payload?: Json | null
          embedded_signup_type?: string | null
          instagram_account_ids?: Json | null
          is_enabled?: boolean
          last_error?: string | null
          last_sync_at?: string | null
          meta_business_id?: string | null
          meta_token_updated_by?: string | null
          page_ids?: Json | null
          phone_number_id?: string | null
          recipient_strategy?: string
          send_mode?: string
          status?: string
          template_language?: string
          template_name?: string | null
          template_variable_mapping?: Json
          updated_at?: string
          waba_id?: string | null
        }
        Relationships: [
          {
            foreignKeyName: "clinic_meta_connections_clinic_id_fkey"
            columns: ["clinic_id"]
            isOneToOne: true
            referencedRelation: "clinics"
            referencedColumns: ["id"]
          },
        ]
      }
      clinic_pet_record_counters: {
        Row: {
          clinic_id: string
          last_value: number
          updated_at: string | null
        }
        Insert: {
          clinic_id: string
          last_value?: number
          updated_at?: string | null
        }
        Update: {
          clinic_id?: string
          last_value?: number
          updated_at?: string | null
        }
        Relationships: [
          {
            foreignKeyName: "clinic_pet_record_counters_clinic_id_fkey"
            columns: ["clinic_id"]
            isOneToOne: true
            referencedRelation: "clinics"
            referencedColumns: ["id"]
          },
        ]
      }
      clinic_team_members: {
        Row: {
          base_salary: number | null
          clinic_id: string
          commission_model_id: string | null
          created_at: string
          employment_type: string | null
          hired_at: string | null
          id: string
          job_title: string | null
          salary_payday: number | null
          salary_period: string
          terminated_at: string | null
          updated_at: string
          user_id: string
        }
        Insert: {
          base_salary?: number | null
          clinic_id: string
          commission_model_id?: string | null
          created_at?: string
          employment_type?: string | null
          hired_at?: string | null
          id?: string
          job_title?: string | null
          salary_payday?: number | null
          salary_period?: string
          terminated_at?: string | null
          updated_at?: string
          user_id: string
        }
        Update: {
          base_salary?: number | null
          clinic_id?: string
          commission_model_id?: string | null
          created_at?: string
          employment_type?: string | null
          hired_at?: string | null
          id?: string
          job_title?: string | null
          salary_payday?: number | null
          salary_period?: string
          terminated_at?: string | null
          updated_at?: string
          user_id?: string
        }
        Relationships: [
          {
            foreignKeyName: "clinic_team_members_clinic_id_fkey"
            columns: ["clinic_id"]
            isOneToOne: false
            referencedRelation: "clinics"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "clinic_team_members_commission_model_id_fkey"
            columns: ["commission_model_id"]
            isOneToOne: false
            referencedRelation: "commission_models"
            referencedColumns: ["id"]
          },
        ]
      }
      clinic_team_salary_history: {
        Row: {
          amount: number
          created_at: string
          created_by: string | null
          effective_from: string
          id: string
          reason: string
          team_member_id: string
        }
        Insert: {
          amount: number
          created_at?: string
          created_by?: string | null
          effective_from?: string
          id?: string
          reason: string
          team_member_id: string
        }
        Update: {
          amount?: number
          created_at?: string
          created_by?: string | null
          effective_from?: string
          id?: string
          reason?: string
          team_member_id?: string
        }
        Relationships: [
          {
            foreignKeyName: "clinic_team_salary_history_team_member_id_fkey"
            columns: ["team_member_id"]
            isOneToOne: false
            referencedRelation: "clinic_team_members"
            referencedColumns: ["id"]
          },
        ]
      }
      clinic_user_permissions: {
        Row: {
          can_create: boolean | null
          can_delete: boolean | null
          can_update: boolean | null
          can_view: boolean | null
          clinic_id: string
          created_at: string | null
          feature_id: string
          id: string
          updated_at: string | null
          user_id: string
        }
        Insert: {
          can_create?: boolean | null
          can_delete?: boolean | null
          can_update?: boolean | null
          can_view?: boolean | null
          clinic_id: string
          created_at?: string | null
          feature_id: string
          id?: string
          updated_at?: string | null
          user_id: string
        }
        Update: {
          can_create?: boolean | null
          can_delete?: boolean | null
          can_update?: boolean | null
          can_view?: boolean | null
          clinic_id?: string
          created_at?: string | null
          feature_id?: string
          id?: string
          updated_at?: string | null
          user_id?: string
        }
        Relationships: [
          {
            foreignKeyName: "clinic_user_permissions_clinic_id_fkey"
            columns: ["clinic_id"]
            isOneToOne: false
            referencedRelation: "clinics"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "clinic_user_permissions_feature_id_fkey"
            columns: ["feature_id"]
            isOneToOne: false
            referencedRelation: "features"
            referencedColumns: ["id"]
          },
        ]
      }
      clinic_user_permissions_backup: {
        Row: {
          can_create: boolean | null
          can_delete: boolean | null
          can_update: boolean | null
          can_view: boolean | null
          clinic_id: string | null
          created_at: string | null
          feature_id: string | null
          id: string | null
          updated_at: string | null
          user_id: string | null
        }
        Insert: {
          can_create?: boolean | null
          can_delete?: boolean | null
          can_update?: boolean | null
          can_view?: boolean | null
          clinic_id?: string | null
          created_at?: string | null
          feature_id?: string | null
          id?: string | null
          updated_at?: string | null
          user_id?: string | null
        }
        Update: {
          can_create?: boolean | null
          can_delete?: boolean | null
          can_update?: boolean | null
          can_view?: boolean | null
          clinic_id?: string | null
          created_at?: string | null
          feature_id?: string | null
          id?: string | null
          updated_at?: string | null
          user_id?: string | null
        }
        Relationships: []
      }
      clinic_whatsapp_application_reminder_rules: {
        Row: {
          clinic_id: string
          created_at: string
          is_active: boolean
          offset_unit: string
          offset_value: number
          send_time: string
          timezone: string
          updated_at: string
          updated_by: string | null
        }
        Insert: {
          clinic_id: string
          created_at?: string
          is_active?: boolean
          offset_unit?: string
          offset_value?: number
          send_time?: string
          timezone?: string
          updated_at?: string
          updated_by?: string | null
        }
        Update: {
          clinic_id?: string
          created_at?: string
          is_active?: boolean
          offset_unit?: string
          offset_value?: number
          send_time?: string
          timezone?: string
          updated_at?: string
          updated_by?: string | null
        }
        Relationships: [
          {
            foreignKeyName: "clinic_whatsapp_vaccine_reminder_rules_clinic_id_fkey"
            columns: ["clinic_id"]
            isOneToOne: true
            referencedRelation: "clinics"
            referencedColumns: ["id"]
          },
        ]
      }
      clinic_whatsapp_templates: {
        Row: {
          clinic_id: string
          created_at: string
          updated_at: string
          updated_by: string | null
          vaccines_pending_template: string
        }
        Insert: {
          clinic_id: string
          created_at?: string
          updated_at?: string
          updated_by?: string | null
          vaccines_pending_template?: string
        }
        Update: {
          clinic_id?: string
          created_at?: string
          updated_at?: string
          updated_by?: string | null
          vaccines_pending_template?: string
        }
        Relationships: [
          {
            foreignKeyName: "clinic_whatsapp_templates_clinic_id_fkey"
            columns: ["clinic_id"]
            isOneToOne: true
            referencedRelation: "clinics"
            referencedColumns: ["id"]
          },
        ]
      }
      clinic_whatsapp_webhook_subscriptions: {
        Row: {
          app_secret_name: string
          callback_url: string | null
          clinic_id: string
          created_at: string
          is_active: boolean
          updated_at: string
          updated_by: string | null
          verify_token_name: string
          waba_id: string | null
        }
        Insert: {
          app_secret_name?: string
          callback_url?: string | null
          clinic_id: string
          created_at?: string
          is_active?: boolean
          updated_at?: string
          updated_by?: string | null
          verify_token_name?: string
          waba_id?: string | null
        }
        Update: {
          app_secret_name?: string
          callback_url?: string | null
          clinic_id?: string
          created_at?: string
          is_active?: boolean
          updated_at?: string
          updated_by?: string | null
          verify_token_name?: string
          waba_id?: string | null
        }
        Relationships: [
          {
            foreignKeyName: "clinic_whatsapp_webhook_subscriptions_clinic_id_fkey"
            columns: ["clinic_id"]
            isOneToOne: true
            referencedRelation: "clinics"
            referencedColumns: ["id"]
          },
        ]
      }
      clinics: {
        Row: {
          cnpj: string | null
          created_at: string | null
          created_by: string | null
          customer_id: string
          default_appointment_durations_minutes: Json
          enable_transcription_audio_archive: boolean
          id: string
          is_active: boolean | null
          name: string
          show_appointment_items_on_cards: boolean
          updated_at: string | null
        }
        Insert: {
          cnpj?: string | null
          created_at?: string | null
          created_by?: string | null
          customer_id: string
          default_appointment_durations_minutes?: Json
          enable_transcription_audio_archive?: boolean
          id?: string
          is_active?: boolean | null
          name: string
          show_appointment_items_on_cards?: boolean
          updated_at?: string | null
        }
        Update: {
          cnpj?: string | null
          created_at?: string | null
          created_by?: string | null
          customer_id?: string
          default_appointment_durations_minutes?: Json
          enable_transcription_audio_archive?: boolean
          id?: string
          is_active?: boolean | null
          name?: string
          show_appointment_items_on_cards?: boolean
          updated_at?: string | null
        }
        Relationships: [
          {
            foreignKeyName: "clinics_customer_id_fkey"
            columns: ["customer_id"]
            isOneToOne: false
            referencedRelation: "customers"
            referencedColumns: ["id"]
          },
        ]
      }
      coat_types: {
        Row: {
          created_at: string | null
          id: string
          name: string
        }
        Insert: {
          created_at?: string | null
          id?: string
          name: string
        }
        Update: {
          created_at?: string | null
          id?: string
          name?: string
        }
        Relationships: []
      }
      colors: {
        Row: {
          created_at: string | null
          id: string
          name: string
        }
        Insert: {
          created_at?: string | null
          id?: string
          name: string
        }
        Update: {
          created_at?: string | null
          id?: string
          name?: string
        }
        Relationships: []
      }
      commission_entries: {
        Row: {
          amount: number
          base_amount: number
          clinic_id: string
          created_at: string
          group_name_snapshot: string
          id: string
          item_kind: string | null
          item_name_snapshot: string
          kind: string
          occurred_at: string
          package_subtype_id: string | null
          percent: number
          product_subtype_id: string | null
          professional_id: string
          reversal_ref: string | null
          sale_id: string
          sale_item_id: string | null
          sale_item_ref: string
          service_group_id: string | null
        }
        Insert: {
          amount: number
          base_amount: number
          clinic_id: string
          created_at?: string
          group_name_snapshot: string
          id?: string
          item_kind?: string | null
          item_name_snapshot: string
          kind: string
          occurred_at?: string
          package_subtype_id?: string | null
          percent: number
          product_subtype_id?: string | null
          professional_id: string
          reversal_ref?: string | null
          sale_id: string
          sale_item_id?: string | null
          sale_item_ref: string
          service_group_id?: string | null
        }
        Update: {
          amount?: number
          base_amount?: number
          clinic_id?: string
          created_at?: string
          group_name_snapshot?: string
          id?: string
          item_kind?: string | null
          item_name_snapshot?: string
          kind?: string
          occurred_at?: string
          package_subtype_id?: string | null
          percent?: number
          product_subtype_id?: string | null
          professional_id?: string
          reversal_ref?: string | null
          sale_id?: string
          sale_item_id?: string | null
          sale_item_ref?: string
          service_group_id?: string | null
        }
        Relationships: [
          {
            foreignKeyName: "commission_entries_clinic_id_fkey"
            columns: ["clinic_id"]
            isOneToOne: false
            referencedRelation: "clinics"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "commission_entries_package_subtype_id_fkey"
            columns: ["package_subtype_id"]
            isOneToOne: false
            referencedRelation: "package_subtypes"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "commission_entries_product_subtype_id_fkey"
            columns: ["product_subtype_id"]
            isOneToOne: false
            referencedRelation: "product_subtypes"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "commission_entries_sale_id_fkey"
            columns: ["sale_id"]
            isOneToOne: false
            referencedRelation: "sales"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "commission_entries_sale_item_id_fkey"
            columns: ["sale_item_id"]
            isOneToOne: false
            referencedRelation: "sale_items"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "commission_entries_service_group_id_fkey"
            columns: ["service_group_id"]
            isOneToOne: false
            referencedRelation: "service_groups"
            referencedColumns: ["id"]
          },
        ]
      }
      commission_model_item_rates: {
        Row: {
          id: string
          item_id: string
          model_id: string
          percent: number
        }
        Insert: {
          id?: string
          item_id: string
          model_id: string
          percent: number
        }
        Update: {
          id?: string
          item_id?: string
          model_id?: string
          percent?: number
        }
        Relationships: [
          {
            foreignKeyName: "commission_model_item_rates_item_id_fkey"
            columns: ["item_id"]
            isOneToOne: false
            referencedRelation: "grooming_services_view"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "commission_model_item_rates_item_id_fkey"
            columns: ["item_id"]
            isOneToOne: false
            referencedRelation: "items"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "commission_model_item_rates_model_id_fkey"
            columns: ["model_id"]
            isOneToOne: false
            referencedRelation: "commission_models"
            referencedColumns: ["id"]
          },
        ]
      }
      commission_model_rates: {
        Row: {
          id: string
          model_id: string
          package_subtype_id: string | null
          percent: number
          product_subtype_id: string | null
          service_group_id: string | null
        }
        Insert: {
          id?: string
          model_id: string
          package_subtype_id?: string | null
          percent: number
          product_subtype_id?: string | null
          service_group_id?: string | null
        }
        Update: {
          id?: string
          model_id?: string
          package_subtype_id?: string | null
          percent?: number
          product_subtype_id?: string | null
          service_group_id?: string | null
        }
        Relationships: [
          {
            foreignKeyName: "commission_model_rates_model_id_fkey"
            columns: ["model_id"]
            isOneToOne: false
            referencedRelation: "commission_models"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "commission_model_rates_package_subtype_id_fkey"
            columns: ["package_subtype_id"]
            isOneToOne: false
            referencedRelation: "package_subtypes"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "commission_model_rates_product_subtype_id_fkey"
            columns: ["product_subtype_id"]
            isOneToOne: false
            referencedRelation: "product_subtypes"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "commission_model_rates_service_group_id_fkey"
            columns: ["service_group_id"]
            isOneToOne: false
            referencedRelation: "service_groups"
            referencedColumns: ["id"]
          },
        ]
      }
      commission_models: {
        Row: {
          calculation_basis: string
          created_at: string
          customer_id: string
          id: string
          is_active: boolean
          name: string
          updated_at: string
        }
        Insert: {
          calculation_basis?: string
          created_at?: string
          customer_id: string
          id?: string
          is_active?: boolean
          name: string
          updated_at?: string
        }
        Update: {
          calculation_basis?: string
          created_at?: string
          customer_id?: string
          id?: string
          is_active?: boolean
          name?: string
          updated_at?: string
        }
        Relationships: [
          {
            foreignKeyName: "commission_models_customer_id_fkey"
            columns: ["customer_id"]
            isOneToOne: false
            referencedRelation: "customers"
            referencedColumns: ["id"]
          },
        ]
      }
      condition_catalog_defaults: {
        Row: {
          created_at: string
          id: string
          name: string
          type: string
        }
        Insert: {
          created_at?: string
          id?: string
          name: string
          type: string
        }
        Update: {
          created_at?: string
          id?: string
          name?: string
          type?: string
        }
        Relationships: []
      }
      conditions: {
        Row: {
          clinic_id: string | null
          created_at: string | null
          id: string
          name: string
          type: string
        }
        Insert: {
          clinic_id?: string | null
          created_at?: string | null
          id?: string
          name: string
          type: string
        }
        Update: {
          clinic_id?: string | null
          created_at?: string | null
          id?: string
          name?: string
          type?: string
        }
        Relationships: [
          {
            foreignKeyName: "conditions_clinic_id_fkey"
            columns: ["clinic_id"]
            isOneToOne: false
            referencedRelation: "clinics"
            referencedColumns: ["id"]
          },
        ]
      }
      consultation_transcription_audio_archives: {
        Row: {
          clinic_id: string
          consultation_transcription_id: string
          created_at: string
          duration_seconds: number
          id: string
          last_error: string | null
          mime_type: string
          pet_id: string
          size_bytes: number
          storage_bucket: string
          storage_path: string
          updated_at: string
          upload_status: string
          uploaded_at: string | null
        }
        Insert: {
          clinic_id: string
          consultation_transcription_id: string
          created_at?: string
          duration_seconds?: number
          id?: string
          last_error?: string | null
          mime_type: string
          pet_id: string
          size_bytes?: number
          storage_bucket?: string
          storage_path: string
          updated_at?: string
          upload_status?: string
          uploaded_at?: string | null
        }
        Update: {
          clinic_id?: string
          consultation_transcription_id?: string
          created_at?: string
          duration_seconds?: number
          id?: string
          last_error?: string | null
          mime_type?: string
          pet_id?: string
          size_bytes?: number
          storage_bucket?: string
          storage_path?: string
          updated_at?: string
          upload_status?: string
          uploaded_at?: string | null
        }
        Relationships: [
          {
            foreignKeyName: "consultation_transcription_au_consultation_transcription_i_fkey"
            columns: ["consultation_transcription_id"]
            isOneToOne: false
            referencedRelation: "consultation_transcriptions"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "consultation_transcription_audio_archives_clinic_id_fkey"
            columns: ["clinic_id"]
            isOneToOne: false
            referencedRelation: "clinics"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "consultation_transcription_audio_archives_pet_id_fkey"
            columns: ["pet_id"]
            isOneToOne: false
            referencedRelation: "pets"
            referencedColumns: ["id"]
          },
        ]
      }
      consultation_transcriptions: {
        Row: {
          ai_attempts: number
          ai_finished_at: string | null
          ai_last_error: string | null
          ai_lease_token: string | null
          ai_started_at: string | null
          ai_status: string
          appointment_id: string | null
          auto_saved_at: string
          clinic_id: string
          created_at: string
          deleted_at: string | null
          detected_language: string
          diagnosis_suggestions: Json
          id: string
          last_error: string | null
          medical_record_id: string | null
          metadata: Json | null
          pet_id: string
          processing_attempts: number
          processing_finished_at: string | null
          processing_started_at: string | null
          status: string
          status_updated_at: string
          streaming_cursor: string | null
          structured: Json
          summary: string | null
          transcript: string
          transcript_finalized_at: string | null
          unknown_terms: Json
          updated_at: string
          vet_user_id: string
        }
        Insert: {
          ai_attempts?: number
          ai_finished_at?: string | null
          ai_last_error?: string | null
          ai_lease_token?: string | null
          ai_started_at?: string | null
          ai_status?: string
          appointment_id?: string | null
          auto_saved_at?: string
          clinic_id: string
          created_at?: string
          deleted_at?: string | null
          detected_language?: string
          diagnosis_suggestions?: Json
          id?: string
          last_error?: string | null
          medical_record_id?: string | null
          metadata?: Json | null
          pet_id: string
          processing_attempts?: number
          processing_finished_at?: string | null
          processing_started_at?: string | null
          status?: string
          status_updated_at?: string
          streaming_cursor?: string | null
          structured?: Json
          summary?: string | null
          transcript?: string
          transcript_finalized_at?: string | null
          unknown_terms?: Json
          updated_at?: string
          vet_user_id: string
        }
        Update: {
          ai_attempts?: number
          ai_finished_at?: string | null
          ai_last_error?: string | null
          ai_lease_token?: string | null
          ai_started_at?: string | null
          ai_status?: string
          appointment_id?: string | null
          auto_saved_at?: string
          clinic_id?: string
          created_at?: string
          deleted_at?: string | null
          detected_language?: string
          diagnosis_suggestions?: Json
          id?: string
          last_error?: string | null
          medical_record_id?: string | null
          metadata?: Json | null
          pet_id?: string
          processing_attempts?: number
          processing_finished_at?: string | null
          processing_started_at?: string | null
          status?: string
          status_updated_at?: string
          streaming_cursor?: string | null
          structured?: Json
          summary?: string | null
          transcript?: string
          transcript_finalized_at?: string | null
          unknown_terms?: Json
          updated_at?: string
          vet_user_id?: string
        }
        Relationships: [
          {
            foreignKeyName: "consultation_transcriptions_appointment_id_fkey"
            columns: ["appointment_id"]
            isOneToOne: false
            referencedRelation: "appointments"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "consultation_transcriptions_clinic_id_fkey"
            columns: ["clinic_id"]
            isOneToOne: false
            referencedRelation: "clinics"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "consultation_transcriptions_medical_record_id_fkey"
            columns: ["medical_record_id"]
            isOneToOne: false
            referencedRelation: "medical_records"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "consultation_transcriptions_pet_id_fkey"
            columns: ["pet_id"]
            isOneToOne: false
            referencedRelation: "pets"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "consultation_transcriptions_vet_user_id_fkey"
            columns: ["vet_user_id"]
            isOneToOne: false
            referencedRelation: "profiles"
            referencedColumns: ["id"]
          },
        ]
      }
      customer_modules: {
        Row: {
          created_at: string
          customer_id: string
          id: string
          is_active: boolean | null
          module_id: string
          updated_at: string | null
        }
        Insert: {
          created_at?: string
          customer_id: string
          id?: string
          is_active?: boolean | null
          module_id: string
          updated_at?: string | null
        }
        Update: {
          created_at?: string
          customer_id?: string
          id?: string
          is_active?: boolean | null
          module_id?: string
          updated_at?: string | null
        }
        Relationships: [
          {
            foreignKeyName: "customer_modules_customer_id_fkey"
            columns: ["customer_id"]
            isOneToOne: false
            referencedRelation: "customers"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "customer_modules_module_id_fkey"
            columns: ["module_id"]
            isOneToOne: false
            referencedRelation: "modules"
            referencedColumns: ["id"]
          },
        ]
      }
      customer_roles: {
        Row: {
          created_at: string | null
          id: string
          updated_at: string | null
          value: string
        }
        Insert: {
          created_at?: string | null
          id?: string
          updated_at?: string | null
          value: string
        }
        Update: {
          created_at?: string | null
          id?: string
          updated_at?: string | null
          value?: string
        }
        Relationships: []
      }
      customer_term_templates: {
        Row: {
          clinic_id: string | null
          config_json: Json
          content: string
          created_at: string
          created_by: string
          customer_id: string | null
          deleted_at: string | null
          deleted_by: string | null
          id: string
          is_active: boolean
          name: string
          owner_user_id: string
          updated_at: string
          version: number
        }
        Insert: {
          clinic_id?: string | null
          config_json?: Json
          content: string
          created_at?: string
          created_by: string
          customer_id?: string | null
          deleted_at?: string | null
          deleted_by?: string | null
          id?: string
          is_active?: boolean
          name: string
          owner_user_id: string
          updated_at?: string
          version?: number
        }
        Update: {
          clinic_id?: string | null
          config_json?: Json
          content?: string
          created_at?: string
          created_by?: string
          customer_id?: string | null
          deleted_at?: string | null
          deleted_by?: string | null
          id?: string
          is_active?: boolean
          name?: string
          owner_user_id?: string
          updated_at?: string
          version?: number
        }
        Relationships: [
          {
            foreignKeyName: "customer_term_templates_clinic_id_fkey"
            columns: ["clinic_id"]
            isOneToOne: false
            referencedRelation: "clinics"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "customer_term_templates_created_by_fkey"
            columns: ["created_by"]
            isOneToOne: false
            referencedRelation: "profiles"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "customer_term_templates_customer_id_fkey"
            columns: ["customer_id"]
            isOneToOne: false
            referencedRelation: "customers"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "customer_term_templates_deleted_by_fkey"
            columns: ["deleted_by"]
            isOneToOne: false
            referencedRelation: "profiles"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "customer_term_templates_owner_user_id_fkey"
            columns: ["owner_user_id"]
            isOneToOne: false
            referencedRelation: "profiles"
            referencedColumns: ["id"]
          },
        ]
      }
      customers: {
        Row: {
          created_at: string | null
          created_by: string | null
          id: string
          name: string
          updated_at: string | null
        }
        Insert: {
          created_at?: string | null
          created_by?: string | null
          id?: string
          name: string
          updated_at?: string | null
        }
        Update: {
          created_at?: string | null
          created_by?: string | null
          id?: string
          name?: string
          updated_at?: string | null
        }
        Relationships: []
      }
      daycare_capacity: {
        Row: {
          capacity_large: number | null
          capacity_medium: number | null
          capacity_small: number | null
          clinic_id: string
          created_at: string
          id: string
          limit_by_size: boolean
          total_capacity: number | null
          updated_at: string
        }
        Insert: {
          capacity_large?: number | null
          capacity_medium?: number | null
          capacity_small?: number | null
          clinic_id: string
          created_at?: string
          id?: string
          limit_by_size?: boolean
          total_capacity?: number | null
          updated_at?: string
        }
        Update: {
          capacity_large?: number | null
          capacity_medium?: number | null
          capacity_small?: number | null
          clinic_id?: string
          created_at?: string
          id?: string
          limit_by_size?: boolean
          total_capacity?: number | null
          updated_at?: string
        }
        Relationships: [
          {
            foreignKeyName: "daycare_capacity_clinic_id_fkey"
            columns: ["clinic_id"]
            isOneToOne: true
            referencedRelation: "clinics"
            referencedColumns: ["id"]
          },
        ]
      }
      daycare_hotel_sync_settings: {
        Row: {
          created_at: string
          customer_id: string
          enabled_at: string | null
          enabled_by: string | null
          is_enabled: boolean
          source_clinic_id: string | null
          updated_at: string
        }
        Insert: {
          created_at?: string
          customer_id: string
          enabled_at?: string | null
          enabled_by?: string | null
          is_enabled?: boolean
          source_clinic_id?: string | null
          updated_at?: string
        }
        Update: {
          created_at?: string
          customer_id?: string
          enabled_at?: string | null
          enabled_by?: string | null
          is_enabled?: boolean
          source_clinic_id?: string | null
          updated_at?: string
        }
        Relationships: [
          {
            foreignKeyName: "daycare_hotel_sync_settings_customer_id_fkey"
            columns: ["customer_id"]
            isOneToOne: true
            referencedRelation: "customers"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "daycare_hotel_sync_settings_enabled_by_fkey"
            columns: ["enabled_by"]
            isOneToOne: false
            referencedRelation: "profiles"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "daycare_hotel_sync_settings_source_clinic_id_fkey"
            columns: ["source_clinic_id"]
            isOneToOne: false
            referencedRelation: "clinics"
            referencedColumns: ["id"]
          },
        ]
      }
      daycare_plan_balance_adjustments: {
        Row: {
          cancelled_stay_reservation_day_id: string | null
          charge_amount: number | null
          charge_sale_item_id: string | null
          clinic_id: string
          contract_id: string
          created_at: string
          created_by: string
          cycle_ends_on: string | null
          cycle_starts_on: string | null
          delta: number
          id: string
          note: string | null
          reason: string
          reverses_adjustment_id: string | null
          target_week_starts_on: string | null
        }
        Insert: {
          cancelled_stay_reservation_day_id?: string | null
          charge_amount?: number | null
          charge_sale_item_id?: string | null
          clinic_id: string
          contract_id: string
          created_at?: string
          created_by: string
          cycle_ends_on?: string | null
          cycle_starts_on?: string | null
          delta: number
          id?: string
          note?: string | null
          reason: string
          reverses_adjustment_id?: string | null
          target_week_starts_on?: string | null
        }
        Update: {
          cancelled_stay_reservation_day_id?: string | null
          charge_amount?: number | null
          charge_sale_item_id?: string | null
          clinic_id?: string
          contract_id?: string
          created_at?: string
          created_by?: string
          cycle_ends_on?: string | null
          cycle_starts_on?: string | null
          delta?: number
          id?: string
          note?: string | null
          reason?: string
          reverses_adjustment_id?: string | null
          target_week_starts_on?: string | null
        }
        Relationships: [
          {
            foreignKeyName: "daycare_plan_balance_adjustme_cancelled_stay_reservation_d_fkey"
            columns: ["cancelled_stay_reservation_day_id"]
            isOneToOne: false
            referencedRelation: "stay_reservation_days"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "daycare_plan_balance_adjustments_charge_sale_item_id_fkey"
            columns: ["charge_sale_item_id"]
            isOneToOne: false
            referencedRelation: "sale_items"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "daycare_plan_balance_adjustments_clinic_id_fkey"
            columns: ["clinic_id"]
            isOneToOne: false
            referencedRelation: "clinics"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "daycare_plan_balance_adjustments_contract_id_fkey"
            columns: ["contract_id"]
            isOneToOne: false
            referencedRelation: "daycare_plan_contracts"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "daycare_plan_balance_adjustments_created_by_fkey"
            columns: ["created_by"]
            isOneToOne: false
            referencedRelation: "profiles"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "daycare_plan_balance_adjustments_reverses_adjustment_id_fkey"
            columns: ["reverses_adjustment_id"]
            isOneToOne: false
            referencedRelation: "daycare_plan_balance_adjustments"
            referencedColumns: ["id"]
          },
        ]
      }
      daycare_plan_charges: {
        Row: {
          contract_id: string
          created_at: string
          due_on: string
          id: string
          period_ends_on: string
          period_starts_on: string
          sale_id: string
        }
        Insert: {
          contract_id: string
          created_at?: string
          due_on: string
          id?: string
          period_ends_on: string
          period_starts_on: string
          sale_id: string
        }
        Update: {
          contract_id?: string
          created_at?: string
          due_on?: string
          id?: string
          period_ends_on?: string
          period_starts_on?: string
          sale_id?: string
        }
        Relationships: [
          {
            foreignKeyName: "daycare_plan_charges_contract_id_fkey"
            columns: ["contract_id"]
            isOneToOne: false
            referencedRelation: "daycare_plan_contracts"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "daycare_plan_charges_sale_id_fkey"
            columns: ["sale_id"]
            isOneToOne: true
            referencedRelation: "sales"
            referencedColumns: ["id"]
          },
        ]
      }
      daycare_plan_contract_days: {
        Row: {
          contract_id: string
          created_at: string
          id: string
          weekday: number
        }
        Insert: {
          contract_id: string
          created_at?: string
          id?: string
          weekday: number
        }
        Update: {
          contract_id?: string
          created_at?: string
          id?: string
          weekday?: number
        }
        Relationships: [
          {
            foreignKeyName: "daycare_plan_contract_days_contract_id_fkey"
            columns: ["contract_id"]
            isOneToOne: false
            referencedRelation: "daycare_plan_contracts"
            referencedColumns: ["id"]
          },
        ]
      }
      daycare_plan_contract_prorations: {
        Row: {
          amount: number
          contract_id: string
          created_at: string
          daily_value: number
          id: string
          next_contract_id: string | null
          sale_item_id: string | null
          used_units: number
        }
        Insert: {
          amount: number
          contract_id: string
          created_at?: string
          daily_value: number
          id?: string
          next_contract_id?: string | null
          sale_item_id?: string | null
          used_units: number
        }
        Update: {
          amount?: number
          contract_id?: string
          created_at?: string
          daily_value?: number
          id?: string
          next_contract_id?: string | null
          sale_item_id?: string | null
          used_units?: number
        }
        Relationships: [
          {
            foreignKeyName: "daycare_plan_contract_prorations_contract_id_fkey"
            columns: ["contract_id"]
            isOneToOne: false
            referencedRelation: "daycare_plan_contracts"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "daycare_plan_contract_prorations_next_contract_id_fkey"
            columns: ["next_contract_id"]
            isOneToOne: false
            referencedRelation: "daycare_plan_contracts"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "daycare_plan_contract_prorations_sale_item_id_fkey"
            columns: ["sale_item_id"]
            isOneToOne: false
            referencedRelation: "sale_items"
            referencedColumns: ["id"]
          },
        ]
      }
      daycare_plan_contracts: {
        Row: {
          billing_timing: string
          carryover_expires_on: string | null
          carryover_units: number
          clinic_id: string
          created_at: string
          days_review_needed: boolean
          first_due_on: string | null
          id: string
          materialized_through: string | null
          next_due_on: string | null
          owner_id: string | null
          pet_id: string
          plan_id: string
          remaining_days: number | null
          starts_on: string
          status: string
          terms_snapshot: Json
          updated_at: string
        }
        Insert: {
          billing_timing?: string
          carryover_expires_on?: string | null
          carryover_units?: number
          clinic_id: string
          created_at?: string
          days_review_needed?: boolean
          first_due_on?: string | null
          id?: string
          materialized_through?: string | null
          next_due_on?: string | null
          owner_id?: string | null
          pet_id: string
          plan_id: string
          remaining_days?: number | null
          starts_on: string
          status?: string
          terms_snapshot: Json
          updated_at?: string
        }
        Update: {
          billing_timing?: string
          carryover_expires_on?: string | null
          carryover_units?: number
          clinic_id?: string
          created_at?: string
          days_review_needed?: boolean
          first_due_on?: string | null
          id?: string
          materialized_through?: string | null
          next_due_on?: string | null
          owner_id?: string | null
          pet_id?: string
          plan_id?: string
          remaining_days?: number | null
          starts_on?: string
          status?: string
          terms_snapshot?: Json
          updated_at?: string
        }
        Relationships: [
          {
            foreignKeyName: "daycare_plan_contracts_clinic_id_fkey"
            columns: ["clinic_id"]
            isOneToOne: false
            referencedRelation: "clinics"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "daycare_plan_contracts_owner_id_fkey"
            columns: ["owner_id"]
            isOneToOne: false
            referencedRelation: "owners"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "daycare_plan_contracts_pet_id_fkey"
            columns: ["pet_id"]
            isOneToOne: false
            referencedRelation: "pets"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "daycare_plan_contracts_plan_id_fkey"
            columns: ["plan_id"]
            isOneToOne: false
            referencedRelation: "daycare_plans"
            referencedColumns: ["id"]
          },
        ]
      }
      daycare_plan_day_packages: {
        Row: {
          included_days: number
          plan_id: string
        }
        Insert: {
          included_days: number
          plan_id: string
        }
        Update: {
          included_days?: number
          plan_id?: string
        }
        Relationships: [
          {
            foreignKeyName: "daycare_plan_day_packages_plan_id_fkey"
            columns: ["plan_id"]
            isOneToOne: true
            referencedRelation: "daycare_plans"
            referencedColumns: ["id"]
          },
        ]
      }
      daycare_plan_recurring_rules: {
        Row: {
          plan_id: string
          usage_limit: number | null
          usage_rule: string
          week_interval: number
        }
        Insert: {
          plan_id: string
          usage_limit?: number | null
          usage_rule: string
          week_interval?: number
        }
        Update: {
          plan_id?: string
          usage_limit?: number | null
          usage_rule?: string
          week_interval?: number
        }
        Relationships: [
          {
            foreignKeyName: "daycare_plan_recurring_rules_plan_id_fkey"
            columns: ["plan_id"]
            isOneToOne: true
            referencedRelation: "daycare_plans"
            referencedColumns: ["id"]
          },
        ]
      }
      daycare_plans: {
        Row: {
          clinic_id: string
          created_at: string
          deleted_at: string | null
          id: string
          is_active: boolean
          kind: string
          mirror_group_id: string | null
          name: string
          price: number
          price_with_hotel_plan: number | null
          updated_at: string
        }
        Insert: {
          clinic_id: string
          created_at?: string
          deleted_at?: string | null
          id?: string
          is_active?: boolean
          kind: string
          mirror_group_id?: string | null
          name: string
          price: number
          price_with_hotel_plan?: number | null
          updated_at?: string
        }
        Update: {
          clinic_id?: string
          created_at?: string
          deleted_at?: string | null
          id?: string
          is_active?: boolean
          kind?: string
          mirror_group_id?: string | null
          name?: string
          price?: number
          price_with_hotel_plan?: number | null
          updated_at?: string
        }
        Relationships: [
          {
            foreignKeyName: "daycare_plans_clinic_id_fkey"
            columns: ["clinic_id"]
            isOneToOne: false
            referencedRelation: "clinics"
            referencedColumns: ["id"]
          },
        ]
      }
      doctor_profile: {
        Row: {
          created_at: string | null
          crm_vet: string | null
          id: string
          specialties: string[] | null
          updated_at: string | null
        }
        Insert: {
          created_at?: string | null
          crm_vet?: string | null
          id: string
          specialties?: string[] | null
          updated_at?: string | null
        }
        Update: {
          created_at?: string | null
          crm_vet?: string | null
          id?: string
          specialties?: string[] | null
          updated_at?: string | null
        }
        Relationships: [
          {
            foreignKeyName: "doctor_profile_id_fkey"
            columns: ["id"]
            isOneToOne: true
            referencedRelation: "profiles"
            referencedColumns: ["id"]
          },
        ]
      }
      document_types: {
        Row: {
          created_at: string | null
          id: string
          mask: string | null
          name: string
        }
        Insert: {
          created_at?: string | null
          id?: string
          mask?: string | null
          name: string
        }
        Update: {
          created_at?: string | null
          id?: string
          mask?: string | null
          name?: string
        }
        Relationships: []
      }
      exam_prescription_template_items: {
        Row: {
          created_at: string
          exam_name: string
          exam_type_id: string | null
          id: string
          instructions: string | null
          template_id: string
          updated_at: string
        }
        Insert: {
          created_at?: string
          exam_name: string
          exam_type_id?: string | null
          id?: string
          instructions?: string | null
          template_id: string
          updated_at?: string
        }
        Update: {
          created_at?: string
          exam_name?: string
          exam_type_id?: string | null
          id?: string
          instructions?: string | null
          template_id?: string
          updated_at?: string
        }
        Relationships: [
          {
            foreignKeyName: "exam_prescription_template_items_exam_type_id_fkey"
            columns: ["exam_type_id"]
            isOneToOne: false
            referencedRelation: "exam_types"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "exam_prescription_template_items_template_id_fkey"
            columns: ["template_id"]
            isOneToOne: false
            referencedRelation: "exam_prescription_templates"
            referencedColumns: ["id"]
          },
        ]
      }
      exam_prescription_templates: {
        Row: {
          clinic_id: string
          created_at: string
          created_by: string | null
          id: string
          observations: string | null
          owner_user_id: string
          title: string
          updated_at: string
        }
        Insert: {
          clinic_id?: string
          created_at?: string
          created_by?: string | null
          id?: string
          observations?: string | null
          owner_user_id: string
          title: string
          updated_at?: string
        }
        Update: {
          clinic_id?: string
          created_at?: string
          created_by?: string | null
          id?: string
          observations?: string | null
          owner_user_id?: string
          title?: string
          updated_at?: string
        }
        Relationships: [
          {
            foreignKeyName: "exam_prescription_templates_clinic_id_fkey"
            columns: ["clinic_id"]
            isOneToOne: false
            referencedRelation: "clinics"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "exam_prescription_templates_created_by_fkey"
            columns: ["created_by"]
            isOneToOne: false
            referencedRelation: "profiles"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "exam_prescription_templates_owner_user_id_fkey"
            columns: ["owner_user_id"]
            isOneToOne: false
            referencedRelation: "profiles"
            referencedColumns: ["id"]
          },
        ]
      }
      exam_results: {
        Row: {
          ai_insights: Json | null
          clinic_id: string
          created_at: string
          created_by: string
          deleted_at: string | null
          exam_type: string
          highlighted_parameters: Json
          id: string
          interpretation: string | null
          medical_record_id: string
          observations: string | null
          pet_id: string
          reference_values: Json | null
          results_json: Json
          template_key: string | null
          trend_data: Json | null
          updated_at: string
        }
        Insert: {
          ai_insights?: Json | null
          clinic_id: string
          created_at?: string
          created_by: string
          deleted_at?: string | null
          exam_type: string
          highlighted_parameters?: Json
          id?: string
          interpretation?: string | null
          medical_record_id: string
          observations?: string | null
          pet_id: string
          reference_values?: Json | null
          results_json?: Json
          template_key?: string | null
          trend_data?: Json | null
          updated_at?: string
        }
        Update: {
          ai_insights?: Json | null
          clinic_id?: string
          created_at?: string
          created_by?: string
          deleted_at?: string | null
          exam_type?: string
          highlighted_parameters?: Json
          id?: string
          interpretation?: string | null
          medical_record_id?: string
          observations?: string | null
          pet_id?: string
          reference_values?: Json | null
          results_json?: Json
          template_key?: string | null
          trend_data?: Json | null
          updated_at?: string
        }
        Relationships: [
          {
            foreignKeyName: "exam_results_clinic_id_fkey"
            columns: ["clinic_id"]
            isOneToOne: false
            referencedRelation: "clinics"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "exam_results_created_by_fkey"
            columns: ["created_by"]
            isOneToOne: false
            referencedRelation: "profiles"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "exam_results_medical_record_id_fkey"
            columns: ["medical_record_id"]
            isOneToOne: false
            referencedRelation: "medical_records"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "exam_results_pet_id_fkey"
            columns: ["pet_id"]
            isOneToOne: false
            referencedRelation: "pets"
            referencedColumns: ["id"]
          },
        ]
      }
      exam_types: {
        Row: {
          category: string | null
          created_at: string
          customer_id: string | null
          description: string | null
          id: string
          is_active: boolean
          name: string
          updated_at: string
        }
        Insert: {
          category?: string | null
          created_at?: string
          customer_id?: string | null
          description?: string | null
          id?: string
          is_active?: boolean
          name: string
          updated_at?: string
        }
        Update: {
          category?: string | null
          created_at?: string
          customer_id?: string | null
          description?: string | null
          id?: string
          is_active?: boolean
          name?: string
          updated_at?: string
        }
        Relationships: [
          {
            foreignKeyName: "exam_types_customer_id_fkey"
            columns: ["customer_id"]
            isOneToOne: false
            referencedRelation: "customers"
            referencedColumns: ["id"]
          },
        ]
      }
      features: {
        Row: {
          can_create: boolean | null
          can_delete: boolean | null
          can_update: boolean | null
          can_view: boolean | null
          created_at: string | null
          id: string
          module_id: string
          value: string
        }
        Insert: {
          can_create?: boolean | null
          can_delete?: boolean | null
          can_update?: boolean | null
          can_view?: boolean | null
          created_at?: string | null
          id?: string
          module_id: string
          value: string
        }
        Update: {
          can_create?: boolean | null
          can_delete?: boolean | null
          can_update?: boolean | null
          can_view?: boolean | null
          created_at?: string | null
          id?: string
          module_id?: string
          value?: string
        }
        Relationships: [
          {
            foreignKeyName: "features_module_id_fkey"
            columns: ["module_id"]
            isOneToOne: false
            referencedRelation: "modules"
            referencedColumns: ["id"]
          },
        ]
      }
      features_backup: {
        Row: {
          can_create: boolean | null
          can_delete: boolean | null
          can_update: boolean | null
          can_view: boolean | null
          created_at: string | null
          id: string | null
          module_id: string | null
          value: string | null
        }
        Insert: {
          can_create?: boolean | null
          can_delete?: boolean | null
          can_update?: boolean | null
          can_view?: boolean | null
          created_at?: string | null
          id?: string | null
          module_id?: string | null
          value?: string | null
        }
        Update: {
          can_create?: boolean | null
          can_delete?: boolean | null
          can_update?: boolean | null
          can_view?: boolean | null
          created_at?: string | null
          id?: string | null
          module_id?: string | null
          value?: string | null
        }
        Relationships: []
      }
      financial_accounts: {
        Row: {
          clinic_id: string
          created_at: string
          id: string
          is_active: boolean
          kind: string
          name: string
          opening_balance: number
          system_key: string | null
          updated_at: string
        }
        Insert: {
          clinic_id: string
          created_at?: string
          id?: string
          is_active?: boolean
          kind: string
          name: string
          opening_balance?: number
          system_key?: string | null
          updated_at?: string
        }
        Update: {
          clinic_id?: string
          created_at?: string
          id?: string
          is_active?: boolean
          kind?: string
          name?: string
          opening_balance?: number
          system_key?: string | null
          updated_at?: string
        }
        Relationships: [
          {
            foreignKeyName: "financial_accounts_clinic_id_fkey"
            columns: ["clinic_id"]
            isOneToOne: false
            referencedRelation: "clinics"
            referencedColumns: ["id"]
          },
        ]
      }
      financial_cash_sessions: {
        Row: {
          business_date: string
          clinic_id: string
          closed_at: string | null
          closed_by: string | null
          closed_by_name: string | null
          id: string
          opened_at: string
          opened_by: string | null
          opened_by_name: string | null
          opening_amount: number
        }
        Insert: {
          business_date: string
          clinic_id: string
          closed_at?: string | null
          closed_by?: string | null
          closed_by_name?: string | null
          id?: string
          opened_at?: string
          opened_by?: string | null
          opened_by_name?: string | null
          opening_amount?: number
        }
        Update: {
          business_date?: string
          clinic_id?: string
          closed_at?: string | null
          closed_by?: string | null
          closed_by_name?: string | null
          id?: string
          opened_at?: string
          opened_by?: string | null
          opened_by_name?: string | null
          opening_amount?: number
        }
        Relationships: [
          {
            foreignKeyName: "financial_cash_sessions_clinic_id_fkey"
            columns: ["clinic_id"]
            isOneToOne: false
            referencedRelation: "clinics"
            referencedColumns: ["id"]
          },
        ]
      }
      financial_categories: {
        Row: {
          clinic_id: string
          created_at: string
          direction: string
          dre_group: string
          id: string
          is_active: boolean
          name: string
          sort_order: number
          system_key: string | null
        }
        Insert: {
          clinic_id: string
          created_at?: string
          direction: string
          dre_group: string
          id?: string
          is_active?: boolean
          name: string
          sort_order?: number
          system_key?: string | null
        }
        Update: {
          clinic_id?: string
          created_at?: string
          direction?: string
          dre_group?: string
          id?: string
          is_active?: boolean
          name?: string
          sort_order?: number
          system_key?: string | null
        }
        Relationships: [
          {
            foreignKeyName: "financial_categories_clinic_id_fkey"
            columns: ["clinic_id"]
            isOneToOne: false
            referencedRelation: "clinics"
            referencedColumns: ["id"]
          },
        ]
      }
      financial_entries: {
        Row: {
          account_id: string
          amount: number
          cash_session_id: string | null
          category_id: string | null
          clinic_id: string
          competence_date: string
          created_at: string
          created_by: string | null
          description: string
          detail: string | null
          id: string
          occurred_at: string
          origin: string
          payment_method: string | null
          refund_payment_id: string | null
          reversal_of: string | null
          sale_id: string | null
          sale_payment_id: string | null
          sale_return_id: string | null
          title_id: string | null
          updated_at: string
          void_reason: string | null
          voided_at: string | null
          voided_by: string | null
        }
        Insert: {
          account_id: string
          amount: number
          cash_session_id?: string | null
          category_id?: string | null
          clinic_id: string
          competence_date?: string
          created_at?: string
          created_by?: string | null
          description?: string
          detail?: string | null
          id?: string
          occurred_at?: string
          origin?: string
          payment_method?: string | null
          refund_payment_id?: string | null
          reversal_of?: string | null
          sale_id?: string | null
          sale_payment_id?: string | null
          sale_return_id?: string | null
          title_id?: string | null
          updated_at?: string
          void_reason?: string | null
          voided_at?: string | null
          voided_by?: string | null
        }
        Update: {
          account_id?: string
          amount?: number
          cash_session_id?: string | null
          category_id?: string | null
          clinic_id?: string
          competence_date?: string
          created_at?: string
          created_by?: string | null
          description?: string
          detail?: string | null
          id?: string
          occurred_at?: string
          origin?: string
          payment_method?: string | null
          refund_payment_id?: string | null
          reversal_of?: string | null
          sale_id?: string | null
          sale_payment_id?: string | null
          sale_return_id?: string | null
          title_id?: string | null
          updated_at?: string
          void_reason?: string | null
          voided_at?: string | null
          voided_by?: string | null
        }
        Relationships: [
          {
            foreignKeyName: "financial_entries_account_id_fkey"
            columns: ["account_id"]
            isOneToOne: false
            referencedRelation: "financial_accounts"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "financial_entries_cash_session_id_fkey"
            columns: ["cash_session_id"]
            isOneToOne: false
            referencedRelation: "financial_cash_sessions"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "financial_entries_category_id_fkey"
            columns: ["category_id"]
            isOneToOne: false
            referencedRelation: "financial_categories"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "financial_entries_clinic_id_fkey"
            columns: ["clinic_id"]
            isOneToOne: false
            referencedRelation: "clinics"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "financial_entries_reversal_of_fkey"
            columns: ["reversal_of"]
            isOneToOne: false
            referencedRelation: "financial_entries"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "financial_entries_sale_id_fkey"
            columns: ["sale_id"]
            isOneToOne: false
            referencedRelation: "sales"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "financial_entries_sale_return_id_fkey"
            columns: ["sale_return_id"]
            isOneToOne: false
            referencedRelation: "sale_returns"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "financial_entries_title_id_fkey"
            columns: ["title_id"]
            isOneToOne: false
            referencedRelation: "financial_titles"
            referencedColumns: ["id"]
          },
        ]
      }
      financial_sales_sync: {
        Row: {
          clinic_id: string
          created_at: string
          start_date: string
        }
        Insert: {
          clinic_id: string
          created_at?: string
          start_date: string
        }
        Update: {
          clinic_id?: string
          created_at?: string
          start_date?: string
        }
        Relationships: [
          {
            foreignKeyName: "financial_sales_sync_clinic_id_fkey"
            columns: ["clinic_id"]
            isOneToOne: true
            referencedRelation: "clinics"
            referencedColumns: ["id"]
          },
        ]
      }
      financial_sync_errors: {
        Row: {
          clinic_id: string | null
          created_at: string
          id: string
          message: string
          sale_id: string | null
          sale_payment_id: string | null
          sqlstate: string | null
        }
        Insert: {
          clinic_id?: string | null
          created_at?: string
          id?: string
          message: string
          sale_id?: string | null
          sale_payment_id?: string | null
          sqlstate?: string | null
        }
        Update: {
          clinic_id?: string | null
          created_at?: string
          id?: string
          message?: string
          sale_id?: string | null
          sale_payment_id?: string | null
          sqlstate?: string | null
        }
        Relationships: []
      }
      financial_titles: {
        Row: {
          amount: number
          cancel_reason: string | null
          canceled_at: string | null
          canceled_by: string | null
          category_id: string | null
          clinic_id: string
          competence_date: string
          counterparty_detail: string | null
          counterparty_name: string
          created_at: string
          created_by: string | null
          description: string
          due_date: string
          id: string
          installment_count: number | null
          installment_group_id: string | null
          installment_number: number | null
          kind: string
          paid_at: string | null
          payment_method: string
          renegotiated_into: string | null
          sale_id: string | null
          sale_payment_id: string | null
          settlement_entry_id: string | null
          status: string
          updated_at: string
        }
        Insert: {
          amount: number
          cancel_reason?: string | null
          canceled_at?: string | null
          canceled_by?: string | null
          category_id?: string | null
          clinic_id: string
          competence_date?: string
          counterparty_detail?: string | null
          counterparty_name: string
          created_at?: string
          created_by?: string | null
          description?: string
          due_date: string
          id?: string
          installment_count?: number | null
          installment_group_id?: string | null
          installment_number?: number | null
          kind: string
          paid_at?: string | null
          payment_method: string
          renegotiated_into?: string | null
          sale_id?: string | null
          sale_payment_id?: string | null
          settlement_entry_id?: string | null
          status?: string
          updated_at?: string
        }
        Update: {
          amount?: number
          cancel_reason?: string | null
          canceled_at?: string | null
          canceled_by?: string | null
          category_id?: string | null
          clinic_id?: string
          competence_date?: string
          counterparty_detail?: string | null
          counterparty_name?: string
          created_at?: string
          created_by?: string | null
          description?: string
          due_date?: string
          id?: string
          installment_count?: number | null
          installment_group_id?: string | null
          installment_number?: number | null
          kind?: string
          paid_at?: string | null
          payment_method?: string
          renegotiated_into?: string | null
          sale_id?: string | null
          sale_payment_id?: string | null
          settlement_entry_id?: string | null
          status?: string
          updated_at?: string
        }
        Relationships: [
          {
            foreignKeyName: "financial_titles_category_id_fkey"
            columns: ["category_id"]
            isOneToOne: false
            referencedRelation: "financial_categories"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "financial_titles_clinic_id_fkey"
            columns: ["clinic_id"]
            isOneToOne: false
            referencedRelation: "clinics"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "financial_titles_sale_id_fkey"
            columns: ["sale_id"]
            isOneToOne: false
            referencedRelation: "sales"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "financial_titles_settlement_entry_fkey"
            columns: ["settlement_entry_id"]
            isOneToOne: false
            referencedRelation: "financial_entries"
            referencedColumns: ["id"]
          },
        ]
      }
      fiscal_document_events: {
        Row: {
          created_at: string
          created_by: string | null
          event_payload: Json
          event_source: string
          event_type: string
          fiscal_document_id: string
          id: string
        }
        Insert: {
          created_at?: string
          created_by?: string | null
          event_payload?: Json
          event_source?: string
          event_type: string
          fiscal_document_id: string
          id?: string
        }
        Update: {
          created_at?: string
          created_by?: string | null
          event_payload?: Json
          event_source?: string
          event_type?: string
          fiscal_document_id?: string
          id?: string
        }
        Relationships: [
          {
            foreignKeyName: "fiscal_document_events_fiscal_document_id_fkey"
            columns: ["fiscal_document_id"]
            isOneToOne: false
            referencedRelation: "fiscal_documents"
            referencedColumns: ["id"]
          },
        ]
      }
      fiscal_documents: {
        Row: {
          access_key: string | null
          cancelled_at: string | null
          clinic_id: string
          created_at: string
          created_by: string | null
          customer_id: string
          document_type: string
          fiscal_number: string | null
          fiscal_series: string | null
          focus_status: string | null
          id: string
          internal_status: string
          issued_at: string | null
          last_error: string | null
          print_url: string | null
          reference: string
          request_payload: Json
          response_payload: Json
          sale_id: string
          sale_return_id: string | null
          updated_at: string
          xml_url: string | null
        }
        Insert: {
          access_key?: string | null
          cancelled_at?: string | null
          clinic_id: string
          created_at?: string
          created_by?: string | null
          customer_id: string
          document_type: string
          fiscal_number?: string | null
          fiscal_series?: string | null
          focus_status?: string | null
          id?: string
          internal_status?: string
          issued_at?: string | null
          last_error?: string | null
          print_url?: string | null
          reference: string
          request_payload?: Json
          response_payload?: Json
          sale_id: string
          sale_return_id?: string | null
          updated_at?: string
          xml_url?: string | null
        }
        Update: {
          access_key?: string | null
          cancelled_at?: string | null
          clinic_id?: string
          created_at?: string
          created_by?: string | null
          customer_id?: string
          document_type?: string
          fiscal_number?: string | null
          fiscal_series?: string | null
          focus_status?: string | null
          id?: string
          internal_status?: string
          issued_at?: string | null
          last_error?: string | null
          print_url?: string | null
          reference?: string
          request_payload?: Json
          response_payload?: Json
          sale_id?: string
          sale_return_id?: string | null
          updated_at?: string
          xml_url?: string | null
        }
        Relationships: [
          {
            foreignKeyName: "fiscal_documents_clinic_id_fkey"
            columns: ["clinic_id"]
            isOneToOne: false
            referencedRelation: "clinics"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "fiscal_documents_customer_id_fkey"
            columns: ["customer_id"]
            isOneToOne: false
            referencedRelation: "customers"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "fiscal_documents_sale_id_fkey"
            columns: ["sale_id"]
            isOneToOne: false
            referencedRelation: "sales"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "fiscal_documents_sale_return_id_fkey"
            columns: ["sale_return_id"]
            isOneToOne: false
            referencedRelation: "sale_returns"
            referencedColumns: ["id"]
          },
        ]
      }
      genders: {
        Row: {
          created_at: string | null
          id: string
          name: string
        }
        Insert: {
          created_at?: string | null
          id?: string
          name: string
        }
        Update: {
          created_at?: string | null
          id?: string
          name?: string
        }
        Relationships: []
      }
      grooming_pricing: {
        Row: {
          breed_id: string | null
          created_at: string | null
          customer_id: string
          duration_minutes: number
          id: string
          is_active: boolean | null
          price: number
          service_id: string
          size_category_id: string | null
          updated_at: string | null
        }
        Insert: {
          breed_id?: string | null
          created_at?: string | null
          customer_id: string
          duration_minutes: number
          id?: string
          is_active?: boolean | null
          price: number
          service_id: string
          size_category_id?: string | null
          updated_at?: string | null
        }
        Update: {
          breed_id?: string | null
          created_at?: string | null
          customer_id?: string
          duration_minutes?: number
          id?: string
          is_active?: boolean | null
          price?: number
          service_id?: string
          size_category_id?: string | null
          updated_at?: string | null
        }
        Relationships: [
          {
            foreignKeyName: "grooming_pricing_breed_id_fkey"
            columns: ["breed_id"]
            isOneToOne: false
            referencedRelation: "breeds"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "grooming_pricing_customer_id_fkey"
            columns: ["customer_id"]
            isOneToOne: false
            referencedRelation: "customers"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "grooming_pricing_service_id_fkey"
            columns: ["service_id"]
            isOneToOne: false
            referencedRelation: "services"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "grooming_pricing_size_category_id_fkey"
            columns: ["size_category_id"]
            isOneToOne: false
            referencedRelation: "pet_size_categories"
            referencedColumns: ["id"]
          },
        ]
      }
      hospitalization_bays: {
        Row: {
          ativa: boolean
          created_at: string
          customer_id: string
          id: string
          nome: string
          ordem: number
          setor_id: string
          updated_at: string
        }
        Insert: {
          ativa?: boolean
          created_at?: string
          customer_id: string
          id?: string
          nome: string
          ordem?: number
          setor_id: string
          updated_at?: string
        }
        Update: {
          ativa?: boolean
          created_at?: string
          customer_id?: string
          id?: string
          nome?: string
          ordem?: number
          setor_id?: string
          updated_at?: string
        }
        Relationships: [
          {
            foreignKeyName: "hospitalization_bays_customer_id_fkey"
            columns: ["customer_id"]
            isOneToOne: false
            referencedRelation: "customers"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "hospitalization_bays_setor_id_fkey"
            columns: ["setor_id"]
            isOneToOne: false
            referencedRelation: "hospitalization_sectors"
            referencedColumns: ["id"]
          },
        ]
      }
      hospitalization_contatos_tutor: {
        Row: {
          autorizacao: string | null
          created_at: string
          customer_id: string
          hospitalization_id: string
          id: string
          registrado_at: string
          registrado_por: string | null
          resumo: string
          tipo: string
        }
        Insert: {
          autorizacao?: string | null
          created_at?: string
          customer_id: string
          hospitalization_id: string
          id?: string
          registrado_at?: string
          registrado_por?: string | null
          resumo: string
          tipo: string
        }
        Update: {
          autorizacao?: string | null
          created_at?: string
          customer_id?: string
          hospitalization_id?: string
          id?: string
          registrado_at?: string
          registrado_por?: string | null
          resumo?: string
          tipo?: string
        }
        Relationships: [
          {
            foreignKeyName: "hospitalization_contatos_tutor_customer_id_fkey"
            columns: ["customer_id"]
            isOneToOne: false
            referencedRelation: "customers"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "hospitalization_contatos_tutor_hospitalization_id_fkey"
            columns: ["hospitalization_id"]
            isOneToOne: false
            referencedRelation: "hospitalizations"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "hospitalization_contatos_tutor_registrado_por_fkey"
            columns: ["registrado_por"]
            isOneToOne: false
            referencedRelation: "profiles"
            referencedColumns: ["id"]
          },
        ]
      }
      hospitalization_diet: {
        Row: {
          created_at: string
          customer_id: string
          descricao: string
          hospitalization_id: string
          id: string
          observacoes: string | null
          quantidade_ml: number | null
          registrado_at: string
          registrado_por: string | null
          tipo: string
        }
        Insert: {
          created_at?: string
          customer_id: string
          descricao: string
          hospitalization_id: string
          id?: string
          observacoes?: string | null
          quantidade_ml?: number | null
          registrado_at?: string
          registrado_por?: string | null
          tipo: string
        }
        Update: {
          created_at?: string
          customer_id?: string
          descricao?: string
          hospitalization_id?: string
          id?: string
          observacoes?: string | null
          quantidade_ml?: number | null
          registrado_at?: string
          registrado_por?: string | null
          tipo?: string
        }
        Relationships: [
          {
            foreignKeyName: "hospitalization_diet_customer_id_fkey"
            columns: ["customer_id"]
            isOneToOne: false
            referencedRelation: "customers"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "hospitalization_diet_hospitalization_id_fkey"
            columns: ["hospitalization_id"]
            isOneToOne: false
            referencedRelation: "hospitalizations"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "hospitalization_diet_registrado_por_fkey"
            columns: ["registrado_por"]
            isOneToOne: false
            referencedRelation: "profiles"
            referencedColumns: ["id"]
          },
        ]
      }
      hospitalization_doses: {
        Row: {
          administrado_at: string
          administrado_por: string | null
          created_at: string
          customer_id: string
          hospitalization_id: string
          id: string
          observacoes: string | null
          prescricao_id: string
        }
        Insert: {
          administrado_at?: string
          administrado_por?: string | null
          created_at?: string
          customer_id: string
          hospitalization_id: string
          id?: string
          observacoes?: string | null
          prescricao_id: string
        }
        Update: {
          administrado_at?: string
          administrado_por?: string | null
          created_at?: string
          customer_id?: string
          hospitalization_id?: string
          id?: string
          observacoes?: string | null
          prescricao_id?: string
        }
        Relationships: [
          {
            foreignKeyName: "hospitalization_doses_administrado_por_fkey"
            columns: ["administrado_por"]
            isOneToOne: false
            referencedRelation: "profiles"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "hospitalization_doses_customer_id_fkey"
            columns: ["customer_id"]
            isOneToOne: false
            referencedRelation: "customers"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "hospitalization_doses_hospitalization_id_fkey"
            columns: ["hospitalization_id"]
            isOneToOne: false
            referencedRelation: "hospitalizations"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "hospitalization_doses_prescricao_id_fkey"
            columns: ["prescricao_id"]
            isOneToOne: false
            referencedRelation: "hospitalization_prescriptions"
            referencedColumns: ["id"]
          },
        ]
      }
      hospitalization_evolutions: {
        Row: {
          autor_id: string | null
          condicao_geral: number | null
          created_at: string
          customer_id: string
          fc_bpm: number | null
          fr_rpm: number | null
          hospitalization_id: string
          id: string
          observacoes: string | null
          peso_kg: number | null
          registrado_at: string
          temperatura_c: number | null
          tpc_s: number | null
        }
        Insert: {
          autor_id?: string | null
          condicao_geral?: number | null
          created_at?: string
          customer_id: string
          fc_bpm?: number | null
          fr_rpm?: number | null
          hospitalization_id: string
          id?: string
          observacoes?: string | null
          peso_kg?: number | null
          registrado_at?: string
          temperatura_c?: number | null
          tpc_s?: number | null
        }
        Update: {
          autor_id?: string | null
          condicao_geral?: number | null
          created_at?: string
          customer_id?: string
          fc_bpm?: number | null
          fr_rpm?: number | null
          hospitalization_id?: string
          id?: string
          observacoes?: string | null
          peso_kg?: number | null
          registrado_at?: string
          temperatura_c?: number | null
          tpc_s?: number | null
        }
        Relationships: [
          {
            foreignKeyName: "hospitalization_evolutions_autor_id_fkey"
            columns: ["autor_id"]
            isOneToOne: false
            referencedRelation: "profiles"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "hospitalization_evolutions_customer_id_fkey"
            columns: ["customer_id"]
            isOneToOne: false
            referencedRelation: "customers"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "hospitalization_evolutions_hospitalization_id_fkey"
            columns: ["hospitalization_id"]
            isOneToOne: false
            referencedRelation: "hospitalizations"
            referencedColumns: ["id"]
          },
        ]
      }
      hospitalization_exams: {
        Row: {
          created_at: string
          customer_id: string
          descricao: string
          hospitalization_id: string
          id: string
          resultado: string | null
          resultado_at: string | null
          solicitado_at: string
          solicitado_por: string | null
          status: string
          tipo: string
          updated_at: string
        }
        Insert: {
          created_at?: string
          customer_id: string
          descricao: string
          hospitalization_id: string
          id?: string
          resultado?: string | null
          resultado_at?: string | null
          solicitado_at?: string
          solicitado_por?: string | null
          status?: string
          tipo: string
          updated_at?: string
        }
        Update: {
          created_at?: string
          customer_id?: string
          descricao?: string
          hospitalization_id?: string
          id?: string
          resultado?: string | null
          resultado_at?: string | null
          solicitado_at?: string
          solicitado_por?: string | null
          status?: string
          tipo?: string
          updated_at?: string
        }
        Relationships: [
          {
            foreignKeyName: "hospitalization_exams_customer_id_fkey"
            columns: ["customer_id"]
            isOneToOne: false
            referencedRelation: "customers"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "hospitalization_exams_hospitalization_id_fkey"
            columns: ["hospitalization_id"]
            isOneToOne: false
            referencedRelation: "hospitalizations"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "hospitalization_exams_solicitado_por_fkey"
            columns: ["solicitado_por"]
            isOneToOne: false
            referencedRelation: "profiles"
            referencedColumns: ["id"]
          },
        ]
      }
      hospitalization_finance: {
        Row: {
          created_at: string
          customer_id: string
          descricao: string
          hospitalization_id: string
          id: string
          quantidade: number
          registrado_at: string
          registrado_por: string | null
          tipo: string
          updated_at: string
          valor_total: number | null
          valor_unitario: number
        }
        Insert: {
          created_at?: string
          customer_id: string
          descricao: string
          hospitalization_id: string
          id?: string
          quantidade?: number
          registrado_at?: string
          registrado_por?: string | null
          tipo: string
          updated_at?: string
          valor_total?: number | null
          valor_unitario: number
        }
        Update: {
          created_at?: string
          customer_id?: string
          descricao?: string
          hospitalization_id?: string
          id?: string
          quantidade?: number
          registrado_at?: string
          registrado_por?: string | null
          tipo?: string
          updated_at?: string
          valor_total?: number | null
          valor_unitario?: number
        }
        Relationships: [
          {
            foreignKeyName: "hospitalization_finance_customer_id_fkey"
            columns: ["customer_id"]
            isOneToOne: false
            referencedRelation: "customers"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "hospitalization_finance_hospitalization_id_fkey"
            columns: ["hospitalization_id"]
            isOneToOne: false
            referencedRelation: "hospitalizations"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "hospitalization_finance_registrado_por_fkey"
            columns: ["registrado_por"]
            isOneToOne: false
            referencedRelation: "profiles"
            referencedColumns: ["id"]
          },
        ]
      }
      hospitalization_prescriptions: {
        Row: {
          ativa: boolean
          created_at: string
          customer_id: string
          dose: string
          fim_at: string | null
          frequencia_h: number
          hospitalization_id: string
          id: string
          inicio_at: string
          medicamento: string
          observacoes: string | null
          prescrito_por: string | null
          updated_at: string
          via: string
        }
        Insert: {
          ativa?: boolean
          created_at?: string
          customer_id: string
          dose: string
          fim_at?: string | null
          frequencia_h: number
          hospitalization_id: string
          id?: string
          inicio_at?: string
          medicamento: string
          observacoes?: string | null
          prescrito_por?: string | null
          updated_at?: string
          via: string
        }
        Update: {
          ativa?: boolean
          created_at?: string
          customer_id?: string
          dose?: string
          fim_at?: string | null
          frequencia_h?: number
          hospitalization_id?: string
          id?: string
          inicio_at?: string
          medicamento?: string
          observacoes?: string | null
          prescrito_por?: string | null
          updated_at?: string
          via?: string
        }
        Relationships: [
          {
            foreignKeyName: "hospitalization_prescriptions_customer_id_fkey"
            columns: ["customer_id"]
            isOneToOne: false
            referencedRelation: "customers"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "hospitalization_prescriptions_hospitalization_id_fkey"
            columns: ["hospitalization_id"]
            isOneToOne: false
            referencedRelation: "hospitalizations"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "hospitalization_prescriptions_prescrito_por_fkey"
            columns: ["prescrito_por"]
            isOneToOne: false
            referencedRelation: "profiles"
            referencedColumns: ["id"]
          },
        ]
      }
      hospitalization_sectors: {
        Row: {
          ativo: boolean
          created_at: string
          customer_id: string
          descricao: string | null
          id: string
          nome: string
          ordem: number
          updated_at: string
        }
        Insert: {
          ativo?: boolean
          created_at?: string
          customer_id: string
          descricao?: string | null
          id?: string
          nome: string
          ordem?: number
          updated_at?: string
        }
        Update: {
          ativo?: boolean
          created_at?: string
          customer_id?: string
          descricao?: string | null
          id?: string
          nome?: string
          ordem?: number
          updated_at?: string
        }
        Relationships: [
          {
            foreignKeyName: "hospitalization_sectors_customer_id_fkey"
            columns: ["customer_id"]
            isOneToOne: false
            referencedRelation: "customers"
            referencedColumns: ["id"]
          },
        ]
      }
      hospitalizations: {
        Row: {
          alta_at: string | null
          alta_motivo: string | null
          baia_id: string | null
          created_at: string
          customer_id: string
          diagnostico_inicial: string | null
          entrada_at: string
          id: string
          motivo: string
          observacoes: string | null
          pet_id: string
          previsao_alta_at: string | null
          status: Database["public"]["Enums"]["hospitalization_status"]
          updated_at: string
          veterinario_id: string | null
        }
        Insert: {
          alta_at?: string | null
          alta_motivo?: string | null
          baia_id?: string | null
          created_at?: string
          customer_id: string
          diagnostico_inicial?: string | null
          entrada_at?: string
          id?: string
          motivo: string
          observacoes?: string | null
          pet_id: string
          previsao_alta_at?: string | null
          status?: Database["public"]["Enums"]["hospitalization_status"]
          updated_at?: string
          veterinario_id?: string | null
        }
        Update: {
          alta_at?: string | null
          alta_motivo?: string | null
          baia_id?: string | null
          created_at?: string
          customer_id?: string
          diagnostico_inicial?: string | null
          entrada_at?: string
          id?: string
          motivo?: string
          observacoes?: string | null
          pet_id?: string
          previsao_alta_at?: string | null
          status?: Database["public"]["Enums"]["hospitalization_status"]
          updated_at?: string
          veterinario_id?: string | null
        }
        Relationships: [
          {
            foreignKeyName: "hospitalizations_baia_id_fkey"
            columns: ["baia_id"]
            isOneToOne: false
            referencedRelation: "hospitalization_bays"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "hospitalizations_customer_id_fkey"
            columns: ["customer_id"]
            isOneToOne: false
            referencedRelation: "customers"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "hospitalizations_pet_id_fkey"
            columns: ["pet_id"]
            isOneToOne: false
            referencedRelation: "pets"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "hospitalizations_veterinario_id_fkey"
            columns: ["veterinario_id"]
            isOneToOne: false
            referencedRelation: "profiles"
            referencedColumns: ["id"]
          },
        ]
      }
      hotel_plan_balance_adjustments: {
        Row: {
          cancelled_stay_reservation_day_id: string | null
          charge_amount: number | null
          charge_sale_item_id: string | null
          clinic_id: string
          contract_id: string
          created_at: string
          created_by: string
          cycle_ends_on: string | null
          cycle_starts_on: string | null
          delta: number
          id: string
          note: string | null
          reason: string
          reverses_adjustment_id: string | null
          target_week_starts_on: string | null
        }
        Insert: {
          cancelled_stay_reservation_day_id?: string | null
          charge_amount?: number | null
          charge_sale_item_id?: string | null
          clinic_id: string
          contract_id: string
          created_at?: string
          created_by: string
          cycle_ends_on?: string | null
          cycle_starts_on?: string | null
          delta: number
          id?: string
          note?: string | null
          reason: string
          reverses_adjustment_id?: string | null
          target_week_starts_on?: string | null
        }
        Update: {
          cancelled_stay_reservation_day_id?: string | null
          charge_amount?: number | null
          charge_sale_item_id?: string | null
          clinic_id?: string
          contract_id?: string
          created_at?: string
          created_by?: string
          cycle_ends_on?: string | null
          cycle_starts_on?: string | null
          delta?: number
          id?: string
          note?: string | null
          reason?: string
          reverses_adjustment_id?: string | null
          target_week_starts_on?: string | null
        }
        Relationships: [
          {
            foreignKeyName: "hotel_plan_balance_adjustment_cancelled_stay_reservation_d_fkey"
            columns: ["cancelled_stay_reservation_day_id"]
            isOneToOne: false
            referencedRelation: "stay_reservation_days"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "hotel_plan_balance_adjustments_charge_sale_item_id_fkey"
            columns: ["charge_sale_item_id"]
            isOneToOne: false
            referencedRelation: "sale_items"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "hotel_plan_balance_adjustments_clinic_id_fkey"
            columns: ["clinic_id"]
            isOneToOne: false
            referencedRelation: "clinics"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "hotel_plan_balance_adjustments_contract_id_fkey"
            columns: ["contract_id"]
            isOneToOne: false
            referencedRelation: "hotel_plan_contracts"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "hotel_plan_balance_adjustments_created_by_fkey"
            columns: ["created_by"]
            isOneToOne: false
            referencedRelation: "profiles"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "hotel_plan_balance_adjustments_reverses_adjustment_id_fkey"
            columns: ["reverses_adjustment_id"]
            isOneToOne: false
            referencedRelation: "hotel_plan_balance_adjustments"
            referencedColumns: ["id"]
          },
        ]
      }
      hotel_plan_charges: {
        Row: {
          contract_id: string
          created_at: string
          due_on: string
          id: string
          period_ends_on: string
          period_starts_on: string
          sale_id: string
        }
        Insert: {
          contract_id: string
          created_at?: string
          due_on: string
          id?: string
          period_ends_on: string
          period_starts_on: string
          sale_id: string
        }
        Update: {
          contract_id?: string
          created_at?: string
          due_on?: string
          id?: string
          period_ends_on?: string
          period_starts_on?: string
          sale_id?: string
        }
        Relationships: [
          {
            foreignKeyName: "hotel_plan_charges_contract_id_fkey"
            columns: ["contract_id"]
            isOneToOne: false
            referencedRelation: "hotel_plan_contracts"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "hotel_plan_charges_sale_id_fkey"
            columns: ["sale_id"]
            isOneToOne: true
            referencedRelation: "sales"
            referencedColumns: ["id"]
          },
        ]
      }
      hotel_plan_contracts: {
        Row: {
          billing_timing: string
          carryover_expires_on: string | null
          carryover_units: number
          clinic_id: string
          created_at: string
          first_due_on: string | null
          id: string
          next_due_on: string | null
          owner_id: string | null
          pet_id: string
          plan_id: string
          remaining_days: number | null
          starts_on: string
          status: string
          terms_snapshot: Json
          updated_at: string
        }
        Insert: {
          billing_timing?: string
          carryover_expires_on?: string | null
          carryover_units?: number
          clinic_id: string
          created_at?: string
          first_due_on?: string | null
          id?: string
          next_due_on?: string | null
          owner_id?: string | null
          pet_id: string
          plan_id: string
          remaining_days?: number | null
          starts_on: string
          status?: string
          terms_snapshot: Json
          updated_at?: string
        }
        Update: {
          billing_timing?: string
          carryover_expires_on?: string | null
          carryover_units?: number
          clinic_id?: string
          created_at?: string
          first_due_on?: string | null
          id?: string
          next_due_on?: string | null
          owner_id?: string | null
          pet_id?: string
          plan_id?: string
          remaining_days?: number | null
          starts_on?: string
          status?: string
          terms_snapshot?: Json
          updated_at?: string
        }
        Relationships: [
          {
            foreignKeyName: "hotel_plan_contracts_clinic_id_fkey"
            columns: ["clinic_id"]
            isOneToOne: false
            referencedRelation: "clinics"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "hotel_plan_contracts_owner_id_fkey"
            columns: ["owner_id"]
            isOneToOne: false
            referencedRelation: "owners"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "hotel_plan_contracts_pet_id_fkey"
            columns: ["pet_id"]
            isOneToOne: false
            referencedRelation: "pets"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "hotel_plan_contracts_plan_id_fkey"
            columns: ["plan_id"]
            isOneToOne: false
            referencedRelation: "hotel_plans"
            referencedColumns: ["id"]
          },
        ]
      }
      hotel_plan_day_packages: {
        Row: {
          included_days: number
          plan_id: string
        }
        Insert: {
          included_days: number
          plan_id: string
        }
        Update: {
          included_days?: number
          plan_id?: string
        }
        Relationships: [
          {
            foreignKeyName: "hotel_plan_day_packages_plan_id_fkey"
            columns: ["plan_id"]
            isOneToOne: true
            referencedRelation: "hotel_plans"
            referencedColumns: ["id"]
          },
        ]
      }
      hotel_plan_recurring_rules: {
        Row: {
          plan_id: string
          usage_limit: number | null
          usage_rule: string
        }
        Insert: {
          plan_id: string
          usage_limit?: number | null
          usage_rule: string
        }
        Update: {
          plan_id?: string
          usage_limit?: number | null
          usage_rule?: string
        }
        Relationships: [
          {
            foreignKeyName: "hotel_plan_recurring_rules_plan_id_fkey"
            columns: ["plan_id"]
            isOneToOne: true
            referencedRelation: "hotel_plans"
            referencedColumns: ["id"]
          },
        ]
      }
      hotel_plans: {
        Row: {
          clinic_id: string
          created_at: string
          deleted_at: string | null
          id: string
          is_active: boolean
          kind: string
          mirror_group_id: string | null
          name: string
          price: number
          price_with_daycare_plan: number | null
          updated_at: string
        }
        Insert: {
          clinic_id: string
          created_at?: string
          deleted_at?: string | null
          id?: string
          is_active?: boolean
          kind: string
          mirror_group_id?: string | null
          name: string
          price: number
          price_with_daycare_plan?: number | null
          updated_at?: string
        }
        Update: {
          clinic_id?: string
          created_at?: string
          deleted_at?: string | null
          id?: string
          is_active?: boolean
          kind?: string
          mirror_group_id?: string | null
          name?: string
          price?: number
          price_with_daycare_plan?: number | null
          updated_at?: string
        }
        Relationships: [
          {
            foreignKeyName: "hotel_plans_clinic_id_fkey"
            columns: ["clinic_id"]
            isOneToOne: false
            referencedRelation: "clinics"
            referencedColumns: ["id"]
          },
        ]
      }
      hotel_room_beds: {
        Row: {
          created_at: string
          hotel_room_id: string
          id: string
          is_active: boolean
          name: string
          sort_order: number
          updated_at: string
        }
        Insert: {
          created_at?: string
          hotel_room_id: string
          id?: string
          is_active?: boolean
          name: string
          sort_order?: number
          updated_at?: string
        }
        Update: {
          created_at?: string
          hotel_room_id?: string
          id?: string
          is_active?: boolean
          name?: string
          sort_order?: number
          updated_at?: string
        }
        Relationships: [
          {
            foreignKeyName: "hotel_room_beds_hotel_room_id_fkey"
            columns: ["hotel_room_id"]
            isOneToOne: false
            referencedRelation: "hotel_rooms"
            referencedColumns: ["id"]
          },
        ]
      }
      hotel_rooms: {
        Row: {
          capacity: number | null
          clinic_id: string
          color: string | null
          created_at: string
          id: string
          is_active: boolean
          name: string
          sort_order: number
          space_type: string
          updated_at: string
        }
        Insert: {
          capacity?: number | null
          clinic_id: string
          color?: string | null
          created_at?: string
          id?: string
          is_active?: boolean
          name: string
          sort_order?: number
          space_type: string
          updated_at?: string
        }
        Update: {
          capacity?: number | null
          clinic_id?: string
          color?: string | null
          created_at?: string
          id?: string
          is_active?: boolean
          name?: string
          sort_order?: number
          space_type?: string
          updated_at?: string
        }
        Relationships: [
          {
            foreignKeyName: "hotel_rooms_clinic_id_fkey"
            columns: ["clinic_id"]
            isOneToOne: false
            referencedRelation: "clinics"
            referencedColumns: ["id"]
          },
        ]
      }
      item_allowed_appointment_types: {
        Row: {
          appointment_type: string
          created_at: string
          id: string
          item_id: string
        }
        Insert: {
          appointment_type: string
          created_at?: string
          id?: string
          item_id: string
        }
        Update: {
          appointment_type?: string
          created_at?: string
          id?: string
          item_id?: string
        }
        Relationships: [
          {
            foreignKeyName: "item_allowed_appointment_types_item_id_fkey"
            columns: ["item_id"]
            isOneToOne: false
            referencedRelation: "grooming_services_view"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "item_allowed_appointment_types_item_id_fkey"
            columns: ["item_id"]
            isOneToOne: false
            referencedRelation: "items"
            referencedColumns: ["id"]
          },
        ]
      }
      item_dose_intervals: {
        Row: {
          created_at: string
          dose_interval_unit: string | null
          dose_interval_value: number | null
          id: string
          item_id: string
          next_application_item_id: string | null
          sort_order: number
        }
        Insert: {
          created_at?: string
          dose_interval_unit?: string | null
          dose_interval_value?: number | null
          id?: string
          item_id: string
          next_application_item_id?: string | null
          sort_order?: number
        }
        Update: {
          created_at?: string
          dose_interval_unit?: string | null
          dose_interval_value?: number | null
          id?: string
          item_id?: string
          next_application_item_id?: string | null
          sort_order?: number
        }
        Relationships: [
          {
            foreignKeyName: "item_dose_intervals_item_id_fkey"
            columns: ["item_id"]
            isOneToOne: false
            referencedRelation: "grooming_services_view"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "item_dose_intervals_item_id_fkey"
            columns: ["item_id"]
            isOneToOne: false
            referencedRelation: "items"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "item_dose_intervals_next_application_item_id_fkey"
            columns: ["next_application_item_id"]
            isOneToOne: false
            referencedRelation: "grooming_services_view"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "item_dose_intervals_next_application_item_id_fkey"
            columns: ["next_application_item_id"]
            isOneToOne: false
            referencedRelation: "items"
            referencedColumns: ["id"]
          },
        ]
      }
      item_fiscal_profiles: {
        Row: {
          aliquota_aproximada_tributos: number | null
          cbs_aliquota: number | null
          cbs_valor: number | null
          cest: string | null
          cfop: string | null
          cfop_outside_state: string | null
          cofins_aliquota: number | null
          cofins_base_calculo: number | null
          cofins_tax_situation: string | null
          cofins_valor: number | null
          created_at: string
          customer_id: string
          fonte_valor_total_tributos: string | null
          gtin: string | null
          ibs_cbs_base_calculo: number | null
          ibs_cbs_classificacao_tributaria: string | null
          ibs_cbs_situacao_tributaria: string | null
          ibs_mun_aliquota: number | null
          ibs_mun_valor: number | null
          ibs_uf_aliquota: number | null
          ibs_uf_valor: number | null
          ibs_valor_total: number | null
          icms_aliquota: number | null
          icms_base_calculo: number | null
          icms_modalidade_base_calculo: string | null
          icms_tax_situation: string | null
          icms_valor: number | null
          id: string
          ipi_aliquota: number | null
          ipi_base_calculo: number | null
          ipi_enquadramento: string | null
          ipi_tax_situation: string | null
          ipi_valor: number | null
          is_valor: number | null
          item_id: string
          ncm: string | null
          nfse_base_calculo: number | null
          nfse_cbs_aliquota: number | null
          nfse_cbs_valor: number | null
          nfse_cnae: string | null
          nfse_desconto_condicionado: number | null
          nfse_desconto_incondicionado: number | null
          nfse_ibs_cbs_base_calculo: number | null
          nfse_ibs_cbs_classificacao_tributaria: string | null
          nfse_ibs_cbs_situacao_tributaria: string | null
          nfse_ibs_mun_aliquota: number | null
          nfse_ibs_mun_valor: number | null
          nfse_ibs_uf_aliquota: number | null
          nfse_ibs_uf_valor: number | null
          nfse_iss_rate: number | null
          nfse_iss_retido: boolean | null
          nfse_natureza_operacao: string | null
          nfse_optante_simples_nacional: boolean | null
          nfse_regime_especial_tributacao: string | null
          nfse_service_code: string | null
          nfse_service_description: string | null
          nfse_service_list_item: string | null
          nfse_valor_cofins: number | null
          nfse_valor_deducoes: number | null
          nfse_valor_iss: number | null
          nfse_valor_pis: number | null
          origin_code: string | null
          pis_aliquota: number | null
          pis_base_calculo: number | null
          pis_tax_situation: string | null
          pis_valor: number | null
          unidade_tributavel: string | null
          updated_at: string
          valor_total_tributos: number | null
        }
        Insert: {
          aliquota_aproximada_tributos?: number | null
          cbs_aliquota?: number | null
          cbs_valor?: number | null
          cest?: string | null
          cfop?: string | null
          cfop_outside_state?: string | null
          cofins_aliquota?: number | null
          cofins_base_calculo?: number | null
          cofins_tax_situation?: string | null
          cofins_valor?: number | null
          created_at?: string
          customer_id: string
          fonte_valor_total_tributos?: string | null
          gtin?: string | null
          ibs_cbs_base_calculo?: number | null
          ibs_cbs_classificacao_tributaria?: string | null
          ibs_cbs_situacao_tributaria?: string | null
          ibs_mun_aliquota?: number | null
          ibs_mun_valor?: number | null
          ibs_uf_aliquota?: number | null
          ibs_uf_valor?: number | null
          ibs_valor_total?: number | null
          icms_aliquota?: number | null
          icms_base_calculo?: number | null
          icms_modalidade_base_calculo?: string | null
          icms_tax_situation?: string | null
          icms_valor?: number | null
          id?: string
          ipi_aliquota?: number | null
          ipi_base_calculo?: number | null
          ipi_enquadramento?: string | null
          ipi_tax_situation?: string | null
          ipi_valor?: number | null
          is_valor?: number | null
          item_id: string
          ncm?: string | null
          nfse_base_calculo?: number | null
          nfse_cbs_aliquota?: number | null
          nfse_cbs_valor?: number | null
          nfse_cnae?: string | null
          nfse_desconto_condicionado?: number | null
          nfse_desconto_incondicionado?: number | null
          nfse_ibs_cbs_base_calculo?: number | null
          nfse_ibs_cbs_classificacao_tributaria?: string | null
          nfse_ibs_cbs_situacao_tributaria?: string | null
          nfse_ibs_mun_aliquota?: number | null
          nfse_ibs_mun_valor?: number | null
          nfse_ibs_uf_aliquota?: number | null
          nfse_ibs_uf_valor?: number | null
          nfse_iss_rate?: number | null
          nfse_iss_retido?: boolean | null
          nfse_natureza_operacao?: string | null
          nfse_optante_simples_nacional?: boolean | null
          nfse_regime_especial_tributacao?: string | null
          nfse_service_code?: string | null
          nfse_service_description?: string | null
          nfse_service_list_item?: string | null
          nfse_valor_cofins?: number | null
          nfse_valor_deducoes?: number | null
          nfse_valor_iss?: number | null
          nfse_valor_pis?: number | null
          origin_code?: string | null
          pis_aliquota?: number | null
          pis_base_calculo?: number | null
          pis_tax_situation?: string | null
          pis_valor?: number | null
          unidade_tributavel?: string | null
          updated_at?: string
          valor_total_tributos?: number | null
        }
        Update: {
          aliquota_aproximada_tributos?: number | null
          cbs_aliquota?: number | null
          cbs_valor?: number | null
          cest?: string | null
          cfop?: string | null
          cfop_outside_state?: string | null
          cofins_aliquota?: number | null
          cofins_base_calculo?: number | null
          cofins_tax_situation?: string | null
          cofins_valor?: number | null
          created_at?: string
          customer_id?: string
          fonte_valor_total_tributos?: string | null
          gtin?: string | null
          ibs_cbs_base_calculo?: number | null
          ibs_cbs_classificacao_tributaria?: string | null
          ibs_cbs_situacao_tributaria?: string | null
          ibs_mun_aliquota?: number | null
          ibs_mun_valor?: number | null
          ibs_uf_aliquota?: number | null
          ibs_uf_valor?: number | null
          ibs_valor_total?: number | null
          icms_aliquota?: number | null
          icms_base_calculo?: number | null
          icms_modalidade_base_calculo?: string | null
          icms_tax_situation?: string | null
          icms_valor?: number | null
          id?: string
          ipi_aliquota?: number | null
          ipi_base_calculo?: number | null
          ipi_enquadramento?: string | null
          ipi_tax_situation?: string | null
          ipi_valor?: number | null
          is_valor?: number | null
          item_id?: string
          ncm?: string | null
          nfse_base_calculo?: number | null
          nfse_cbs_aliquota?: number | null
          nfse_cbs_valor?: number | null
          nfse_cnae?: string | null
          nfse_desconto_condicionado?: number | null
          nfse_desconto_incondicionado?: number | null
          nfse_ibs_cbs_base_calculo?: number | null
          nfse_ibs_cbs_classificacao_tributaria?: string | null
          nfse_ibs_cbs_situacao_tributaria?: string | null
          nfse_ibs_mun_aliquota?: number | null
          nfse_ibs_mun_valor?: number | null
          nfse_ibs_uf_aliquota?: number | null
          nfse_ibs_uf_valor?: number | null
          nfse_iss_rate?: number | null
          nfse_iss_retido?: boolean | null
          nfse_natureza_operacao?: string | null
          nfse_optante_simples_nacional?: boolean | null
          nfse_regime_especial_tributacao?: string | null
          nfse_service_code?: string | null
          nfse_service_description?: string | null
          nfse_service_list_item?: string | null
          nfse_valor_cofins?: number | null
          nfse_valor_deducoes?: number | null
          nfse_valor_iss?: number | null
          nfse_valor_pis?: number | null
          origin_code?: string | null
          pis_aliquota?: number | null
          pis_base_calculo?: number | null
          pis_tax_situation?: string | null
          pis_valor?: number | null
          unidade_tributavel?: string | null
          updated_at?: string
          valor_total_tributos?: number | null
        }
        Relationships: [
          {
            foreignKeyName: "item_fiscal_profiles_customer_id_fkey"
            columns: ["customer_id"]
            isOneToOne: false
            referencedRelation: "customers"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "item_fiscal_profiles_item_id_fkey"
            columns: ["item_id"]
            isOneToOne: true
            referencedRelation: "grooming_services_view"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "item_fiscal_profiles_item_id_fkey"
            columns: ["item_id"]
            isOneToOne: true
            referencedRelation: "items"
            referencedColumns: ["id"]
          },
        ]
      }
      item_pricing: {
        Row: {
          breed_id: string | null
          created_at: string
          customer_id: string
          duration_minutes: number | null
          id: string
          is_active: boolean
          item_id: string
          price: number
          size_category_id: string | null
          updated_at: string
        }
        Insert: {
          breed_id?: string | null
          created_at?: string
          customer_id: string
          duration_minutes?: number | null
          id?: string
          is_active?: boolean
          item_id: string
          price: number
          size_category_id?: string | null
          updated_at?: string
        }
        Update: {
          breed_id?: string | null
          created_at?: string
          customer_id?: string
          duration_minutes?: number | null
          id?: string
          is_active?: boolean
          item_id?: string
          price?: number
          size_category_id?: string | null
          updated_at?: string
        }
        Relationships: [
          {
            foreignKeyName: "item_pricing_breed_id_fkey"
            columns: ["breed_id"]
            isOneToOne: false
            referencedRelation: "breeds"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "item_pricing_customer_id_fkey"
            columns: ["customer_id"]
            isOneToOne: false
            referencedRelation: "customers"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "item_pricing_item_id_fkey"
            columns: ["item_id"]
            isOneToOne: false
            referencedRelation: "grooming_services_view"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "item_pricing_item_id_fkey"
            columns: ["item_id"]
            isOneToOne: false
            referencedRelation: "items"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "item_pricing_size_category_id_fkey"
            columns: ["size_category_id"]
            isOneToOne: false
            referencedRelation: "pet_size_categories"
            referencedColumns: ["id"]
          },
        ]
      }
      item_variants: {
        Row: {
          attributes: Json
          barcode: string | null
          cost_price: number | null
          created_at: string | null
          id: string
          is_active: boolean | null
          item_id: string
          name: string
          sale_price: number | null
          sku: string
        }
        Insert: {
          attributes: Json
          barcode?: string | null
          cost_price?: number | null
          created_at?: string | null
          id?: string
          is_active?: boolean | null
          item_id: string
          name: string
          sale_price?: number | null
          sku: string
        }
        Update: {
          attributes?: Json
          barcode?: string | null
          cost_price?: number | null
          created_at?: string | null
          id?: string
          is_active?: boolean | null
          item_id?: string
          name?: string
          sale_price?: number | null
          sku?: string
        }
        Relationships: [
          {
            foreignKeyName: "item_variants_item_id_fkey"
            columns: ["item_id"]
            isOneToOne: false
            referencedRelation: "grooming_services_view"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "item_variants_item_id_fkey"
            columns: ["item_id"]
            isOneToOne: false
            referencedRelation: "items"
            referencedColumns: ["id"]
          },
        ]
      }
      item_xml_import_lines: {
        Row: {
          action: string
          cbs_aliquota: number | null
          cbs_valor: number | null
          cest: string | null
          cfop: string | null
          cofins_aliquota: number | null
          cofins_base_calculo: number | null
          cofins_tax_situation: string | null
          cofins_valor: number | null
          created_at: string
          description: string | null
          gtin: string | null
          gtin_tributavel: string | null
          ibs_cbs_base_calculo: number | null
          ibs_cbs_classificacao_tributaria: string | null
          ibs_cbs_situacao_tributaria: string | null
          ibs_mun_aliquota: number | null
          ibs_mun_valor: number | null
          ibs_uf_aliquota: number | null
          ibs_uf_valor: number | null
          ibs_valor_total: number | null
          icms_aliquota: number | null
          icms_base_calculo: number | null
          icms_modalidade_base_calculo: string | null
          icms_tax_situation: string | null
          icms_valor: number | null
          id: string
          ipi_aliquota: number | null
          ipi_base_calculo: number | null
          ipi_enquadramento: string | null
          ipi_tax_situation: string | null
          ipi_valor: number | null
          is_valor: number | null
          item_id: string | null
          line_code: string | null
          ncm: string | null
          origin_code: string | null
          pis_aliquota: number | null
          pis_base_calculo: number | null
          pis_tax_situation: string | null
          pis_valor: number | null
          quantidade_tributavel: number | null
          quantity: number | null
          total_value: number | null
          unidade_tributavel: string | null
          unit: string | null
          unit_value: number | null
          valor_desconto: number | null
          valor_frete: number | null
          valor_outras_despesas: number | null
          valor_seguro: number | null
          valor_total_tributos: number | null
          valor_unitario_tributavel: number | null
          xml_import_id: string
        }
        Insert: {
          action: string
          cbs_aliquota?: number | null
          cbs_valor?: number | null
          cest?: string | null
          cfop?: string | null
          cofins_aliquota?: number | null
          cofins_base_calculo?: number | null
          cofins_tax_situation?: string | null
          cofins_valor?: number | null
          created_at?: string
          description?: string | null
          gtin?: string | null
          gtin_tributavel?: string | null
          ibs_cbs_base_calculo?: number | null
          ibs_cbs_classificacao_tributaria?: string | null
          ibs_cbs_situacao_tributaria?: string | null
          ibs_mun_aliquota?: number | null
          ibs_mun_valor?: number | null
          ibs_uf_aliquota?: number | null
          ibs_uf_valor?: number | null
          ibs_valor_total?: number | null
          icms_aliquota?: number | null
          icms_base_calculo?: number | null
          icms_modalidade_base_calculo?: string | null
          icms_tax_situation?: string | null
          icms_valor?: number | null
          id?: string
          ipi_aliquota?: number | null
          ipi_base_calculo?: number | null
          ipi_enquadramento?: string | null
          ipi_tax_situation?: string | null
          ipi_valor?: number | null
          is_valor?: number | null
          item_id?: string | null
          line_code?: string | null
          ncm?: string | null
          origin_code?: string | null
          pis_aliquota?: number | null
          pis_base_calculo?: number | null
          pis_tax_situation?: string | null
          pis_valor?: number | null
          quantidade_tributavel?: number | null
          quantity?: number | null
          total_value?: number | null
          unidade_tributavel?: string | null
          unit?: string | null
          unit_value?: number | null
          valor_desconto?: number | null
          valor_frete?: number | null
          valor_outras_despesas?: number | null
          valor_seguro?: number | null
          valor_total_tributos?: number | null
          valor_unitario_tributavel?: number | null
          xml_import_id: string
        }
        Update: {
          action?: string
          cbs_aliquota?: number | null
          cbs_valor?: number | null
          cest?: string | null
          cfop?: string | null
          cofins_aliquota?: number | null
          cofins_base_calculo?: number | null
          cofins_tax_situation?: string | null
          cofins_valor?: number | null
          created_at?: string
          description?: string | null
          gtin?: string | null
          gtin_tributavel?: string | null
          ibs_cbs_base_calculo?: number | null
          ibs_cbs_classificacao_tributaria?: string | null
          ibs_cbs_situacao_tributaria?: string | null
          ibs_mun_aliquota?: number | null
          ibs_mun_valor?: number | null
          ibs_uf_aliquota?: number | null
          ibs_uf_valor?: number | null
          ibs_valor_total?: number | null
          icms_aliquota?: number | null
          icms_base_calculo?: number | null
          icms_modalidade_base_calculo?: string | null
          icms_tax_situation?: string | null
          icms_valor?: number | null
          id?: string
          ipi_aliquota?: number | null
          ipi_base_calculo?: number | null
          ipi_enquadramento?: string | null
          ipi_tax_situation?: string | null
          ipi_valor?: number | null
          is_valor?: number | null
          item_id?: string | null
          line_code?: string | null
          ncm?: string | null
          origin_code?: string | null
          pis_aliquota?: number | null
          pis_base_calculo?: number | null
          pis_tax_situation?: string | null
          pis_valor?: number | null
          quantidade_tributavel?: number | null
          quantity?: number | null
          total_value?: number | null
          unidade_tributavel?: string | null
          unit?: string | null
          unit_value?: number | null
          valor_desconto?: number | null
          valor_frete?: number | null
          valor_outras_despesas?: number | null
          valor_seguro?: number | null
          valor_total_tributos?: number | null
          valor_unitario_tributavel?: number | null
          xml_import_id?: string
        }
        Relationships: [
          {
            foreignKeyName: "item_xml_import_lines_item_id_fkey"
            columns: ["item_id"]
            isOneToOne: false
            referencedRelation: "grooming_services_view"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "item_xml_import_lines_item_id_fkey"
            columns: ["item_id"]
            isOneToOne: false
            referencedRelation: "items"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "item_xml_import_lines_xml_import_id_fkey"
            columns: ["xml_import_id"]
            isOneToOne: false
            referencedRelation: "item_xml_imports"
            referencedColumns: ["id"]
          },
        ]
      }
      item_xml_imports: {
        Row: {
          created_at: string
          customer_id: string
          id: string
          imported_at: string
          imported_by: string | null
          invoice_issued_at: string | null
          invoice_key: string | null
          invoice_number: string | null
          supplier_cnpj: string | null
          supplier_name: string | null
          updated_at: string
          xml_content: string
          xml_file_path: string | null
        }
        Insert: {
          created_at?: string
          customer_id: string
          id?: string
          imported_at?: string
          imported_by?: string | null
          invoice_issued_at?: string | null
          invoice_key?: string | null
          invoice_number?: string | null
          supplier_cnpj?: string | null
          supplier_name?: string | null
          updated_at?: string
          xml_content: string
          xml_file_path?: string | null
        }
        Update: {
          created_at?: string
          customer_id?: string
          id?: string
          imported_at?: string
          imported_by?: string | null
          invoice_issued_at?: string | null
          invoice_key?: string | null
          invoice_number?: string | null
          supplier_cnpj?: string | null
          supplier_name?: string | null
          updated_at?: string
          xml_content?: string
          xml_file_path?: string | null
        }
        Relationships: [
          {
            foreignKeyName: "item_xml_imports_customer_id_fkey"
            columns: ["customer_id"]
            isOneToOne: false
            referencedRelation: "customers"
            referencedColumns: ["id"]
          },
        ]
      }
      items: {
        Row: {
          barcode: string | null
          brand_id: string | null
          category_id: string | null
          cost_price: number | null
          created_at: string | null
          created_by: string | null
          customer_id: string
          deleted_at: string | null
          deleted_by: string | null
          description: string | null
          dose_ml: number | null
          id: string
          is_active: boolean | null
          is_perishable: boolean | null
          managed_clinic_id: string | null
          managed_entity_id: string | null
          manufacturer: string | null
          markup_percentage: number | null
          name: string
          next_application_defaults: Json | null
          package_subtype_id: string | null
          photos: Json | null
          product_subtype_id: string | null
          registration_number: string | null
          sale_price: number | null
          service_duration_minutes: number | null
          service_group_id: string | null
          sku: string | null
          storage_temp: string | null
          system_code: string | null
          tax_rate: number | null
          track_by_batch: boolean | null
          track_by_expiry: boolean | null
          type: Database["public"]["Enums"]["item_type"]
          unit: string | null
          unit_conversion: Json | null
          updated_at: string | null
          xml_import_id: string | null
        }
        Insert: {
          barcode?: string | null
          brand_id?: string | null
          category_id?: string | null
          cost_price?: number | null
          created_at?: string | null
          created_by?: string | null
          customer_id: string
          deleted_at?: string | null
          deleted_by?: string | null
          description?: string | null
          dose_ml?: number | null
          id?: string
          is_active?: boolean | null
          is_perishable?: boolean | null
          managed_clinic_id?: string | null
          managed_entity_id?: string | null
          manufacturer?: string | null
          markup_percentage?: number | null
          name: string
          next_application_defaults?: Json | null
          package_subtype_id?: string | null
          photos?: Json | null
          product_subtype_id?: string | null
          registration_number?: string | null
          sale_price?: number | null
          service_duration_minutes?: number | null
          service_group_id?: string | null
          sku?: string | null
          storage_temp?: string | null
          system_code?: string | null
          tax_rate?: number | null
          track_by_batch?: boolean | null
          track_by_expiry?: boolean | null
          type: Database["public"]["Enums"]["item_type"]
          unit?: string | null
          unit_conversion?: Json | null
          updated_at?: string | null
          xml_import_id?: string | null
        }
        Update: {
          barcode?: string | null
          brand_id?: string | null
          category_id?: string | null
          cost_price?: number | null
          created_at?: string | null
          created_by?: string | null
          customer_id?: string
          deleted_at?: string | null
          deleted_by?: string | null
          description?: string | null
          dose_ml?: number | null
          id?: string
          is_active?: boolean | null
          is_perishable?: boolean | null
          managed_clinic_id?: string | null
          managed_entity_id?: string | null
          manufacturer?: string | null
          markup_percentage?: number | null
          name?: string
          next_application_defaults?: Json | null
          package_subtype_id?: string | null
          photos?: Json | null
          product_subtype_id?: string | null
          registration_number?: string | null
          sale_price?: number | null
          service_duration_minutes?: number | null
          service_group_id?: string | null
          sku?: string | null
          storage_temp?: string | null
          system_code?: string | null
          tax_rate?: number | null
          track_by_batch?: boolean | null
          track_by_expiry?: boolean | null
          type?: Database["public"]["Enums"]["item_type"]
          unit?: string | null
          unit_conversion?: Json | null
          updated_at?: string | null
          xml_import_id?: string | null
        }
        Relationships: [
          {
            foreignKeyName: "items_brand_id_fkey"
            columns: ["brand_id"]
            isOneToOne: false
            referencedRelation: "brands"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "items_category_id_fkey"
            columns: ["category_id"]
            isOneToOne: false
            referencedRelation: "categories"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "items_customer_id_fkey"
            columns: ["customer_id"]
            isOneToOne: false
            referencedRelation: "customers"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "items_managed_clinic_id_fkey"
            columns: ["managed_clinic_id"]
            isOneToOne: false
            referencedRelation: "clinics"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "items_package_subtype_id_fkey"
            columns: ["package_subtype_id"]
            isOneToOne: false
            referencedRelation: "package_subtypes"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "items_product_subtype_id_fkey"
            columns: ["product_subtype_id"]
            isOneToOne: false
            referencedRelation: "product_subtypes"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "items_service_group_id_fkey"
            columns: ["service_group_id"]
            isOneToOne: false
            referencedRelation: "service_groups"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "items_xml_import_id_fkey"
            columns: ["xml_import_id"]
            isOneToOne: false
            referencedRelation: "item_xml_imports"
            referencedColumns: ["id"]
          },
        ]
      }
      lead_sources: {
        Row: {
          created_at: string | null
          id: string
          name: string
        }
        Insert: {
          created_at?: string | null
          id?: string
          name: string
        }
        Update: {
          created_at?: string | null
          id?: string
          name?: string
        }
        Relationships: []
      }
      medical_prescription_exam_items: {
        Row: {
          created_at: string
          exam_name: string
          exam_type_id: string | null
          id: string
          instructions: string | null
          prescription_id: string
          updated_at: string
        }
        Insert: {
          created_at?: string
          exam_name: string
          exam_type_id?: string | null
          id?: string
          instructions?: string | null
          prescription_id: string
          updated_at?: string
        }
        Update: {
          created_at?: string
          exam_name?: string
          exam_type_id?: string | null
          id?: string
          instructions?: string | null
          prescription_id?: string
          updated_at?: string
        }
        Relationships: [
          {
            foreignKeyName: "medical_prescription_exam_items_exam_type_id_fkey"
            columns: ["exam_type_id"]
            isOneToOne: false
            referencedRelation: "exam_types"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "medical_prescription_exam_items_prescription_id_fkey"
            columns: ["prescription_id"]
            isOneToOne: false
            referencedRelation: "medical_prescriptions"
            referencedColumns: ["id"]
          },
        ]
      }
      medical_prescription_items: {
        Row: {
          administration_route: string | null
          created_at: string | null
          deleted_at: string | null
          dose_amount: string | null
          dose_unit: string | null
          duration_unit: string | null
          duration_value: string | null
          free_text_posology: string | null
          frequency_unit: string | null
          frequency_value: string | null
          id: string
          medication_concentration: string | null
          medication_id: string | null
          medication_name: string
          pharmaceutical_form: string | null
          posology_mode: string
          prescription_id: string
          presentation: string | null
          quantity: string | null
          updated_at: string | null
        }
        Insert: {
          administration_route?: string | null
          created_at?: string | null
          deleted_at?: string | null
          dose_amount?: string | null
          dose_unit?: string | null
          duration_unit?: string | null
          duration_value?: string | null
          free_text_posology?: string | null
          frequency_unit?: string | null
          frequency_value?: string | null
          id?: string
          medication_concentration?: string | null
          medication_id?: string | null
          medication_name: string
          pharmaceutical_form?: string | null
          posology_mode: string
          prescription_id: string
          presentation?: string | null
          quantity?: string | null
          updated_at?: string | null
        }
        Update: {
          administration_route?: string | null
          created_at?: string | null
          deleted_at?: string | null
          dose_amount?: string | null
          dose_unit?: string | null
          duration_unit?: string | null
          duration_value?: string | null
          free_text_posology?: string | null
          frequency_unit?: string | null
          frequency_value?: string | null
          id?: string
          medication_concentration?: string | null
          medication_id?: string | null
          medication_name?: string
          pharmaceutical_form?: string | null
          posology_mode?: string
          prescription_id?: string
          presentation?: string | null
          quantity?: string | null
          updated_at?: string | null
        }
        Relationships: [
          {
            foreignKeyName: "medical_prescription_items_medication_id_fkey"
            columns: ["medication_id"]
            isOneToOne: false
            referencedRelation: "medications"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "medical_prescription_items_prescription_id_fkey"
            columns: ["prescription_id"]
            isOneToOne: false
            referencedRelation: "medical_prescriptions"
            referencedColumns: ["id"]
          },
        ]
      }
      medical_prescriptions: {
        Row: {
          access_code: string | null
          access_code_hint: string | null
          appointment_id: string | null
          buyer_mode: string
          buyer_snapshot: Json | null
          clinic_id: string
          control_identifier: string | null
          control_program: string | null
          control_regime: string
          created_at: string | null
          crmv: string | null
          deleted_at: string | null
          id: string
          issued_at: string | null
          issuer_address: string | null
          manipulated_payload: Json | null
          mapa_number: string | null
          mapa_prescription_identifier: string | null
          mapa_registration_snapshot: string | null
          medical_record_id: string | null
          observations: string | null
          pet_id: string
          signed_at: string | null
          signed_by_user_id: string | null
          signed_pdf_sha256: string | null
          signed_storage_bucket: string | null
          signed_storage_path: string | null
          type: string
          updated_at: string | null
          validity_in_days: number | null
          vet_user_id: string
        }
        Insert: {
          access_code?: string | null
          access_code_hint?: string | null
          appointment_id?: string | null
          buyer_mode?: string
          buyer_snapshot?: Json | null
          clinic_id: string
          control_identifier?: string | null
          control_program?: string | null
          control_regime?: string
          created_at?: string | null
          crmv?: string | null
          deleted_at?: string | null
          id?: string
          issued_at?: string | null
          issuer_address?: string | null
          manipulated_payload?: Json | null
          mapa_number?: string | null
          mapa_prescription_identifier?: string | null
          mapa_registration_snapshot?: string | null
          medical_record_id?: string | null
          observations?: string | null
          pet_id: string
          signed_at?: string | null
          signed_by_user_id?: string | null
          signed_pdf_sha256?: string | null
          signed_storage_bucket?: string | null
          signed_storage_path?: string | null
          type: string
          updated_at?: string | null
          validity_in_days?: number | null
          vet_user_id: string
        }
        Update: {
          access_code?: string | null
          access_code_hint?: string | null
          appointment_id?: string | null
          buyer_mode?: string
          buyer_snapshot?: Json | null
          clinic_id?: string
          control_identifier?: string | null
          control_program?: string | null
          control_regime?: string
          created_at?: string | null
          crmv?: string | null
          deleted_at?: string | null
          id?: string
          issued_at?: string | null
          issuer_address?: string | null
          manipulated_payload?: Json | null
          mapa_number?: string | null
          mapa_prescription_identifier?: string | null
          mapa_registration_snapshot?: string | null
          medical_record_id?: string | null
          observations?: string | null
          pet_id?: string
          signed_at?: string | null
          signed_by_user_id?: string | null
          signed_pdf_sha256?: string | null
          signed_storage_bucket?: string | null
          signed_storage_path?: string | null
          type?: string
          updated_at?: string | null
          validity_in_days?: number | null
          vet_user_id?: string
        }
        Relationships: [
          {
            foreignKeyName: "medical_prescriptions_appointment_id_fkey"
            columns: ["appointment_id"]
            isOneToOne: false
            referencedRelation: "appointments"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "medical_prescriptions_clinic_id_fkey"
            columns: ["clinic_id"]
            isOneToOne: false
            referencedRelation: "clinics"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "medical_prescriptions_medical_record_id_fkey"
            columns: ["medical_record_id"]
            isOneToOne: false
            referencedRelation: "medical_records"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "medical_prescriptions_pet_id_fkey"
            columns: ["pet_id"]
            isOneToOne: false
            referencedRelation: "pets"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "medical_prescriptions_vet_user_id_fkey"
            columns: ["vet_user_id"]
            isOneToOne: false
            referencedRelation: "profiles"
            referencedColumns: ["id"]
          },
        ]
      }
      medical_record_attachments: {
        Row: {
          annotations: Json
          category: string | null
          clinic_id: string
          created_at: string
          created_by: string
          deleted_at: string | null
          description: string | null
          exam_date: string | null
          file_name: string
          file_path: string
          file_size: number | null
          id: string
          medical_record_id: string | null
          metadata: Json | null
          mime_type: string | null
          ocr_status: string
          ocr_text: string | null
          pet_id: string
          storage_bucket: string
          tags: string[] | null
          type: string
          updated_at: string
        }
        Insert: {
          annotations?: Json
          category?: string | null
          clinic_id: string
          created_at?: string
          created_by: string
          deleted_at?: string | null
          description?: string | null
          exam_date?: string | null
          file_name: string
          file_path: string
          file_size?: number | null
          id?: string
          medical_record_id?: string | null
          metadata?: Json | null
          mime_type?: string | null
          ocr_status?: string
          ocr_text?: string | null
          pet_id: string
          storage_bucket?: string
          tags?: string[] | null
          type: string
          updated_at?: string
        }
        Update: {
          annotations?: Json
          category?: string | null
          clinic_id?: string
          created_at?: string
          created_by?: string
          deleted_at?: string | null
          description?: string | null
          exam_date?: string | null
          file_name?: string
          file_path?: string
          file_size?: number | null
          id?: string
          medical_record_id?: string | null
          metadata?: Json | null
          mime_type?: string | null
          ocr_status?: string
          ocr_text?: string | null
          pet_id?: string
          storage_bucket?: string
          tags?: string[] | null
          type?: string
          updated_at?: string
        }
        Relationships: [
          {
            foreignKeyName: "medical_record_attachments_clinic_id_fkey"
            columns: ["clinic_id"]
            isOneToOne: false
            referencedRelation: "clinics"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "medical_record_attachments_created_by_fkey"
            columns: ["created_by"]
            isOneToOne: false
            referencedRelation: "profiles"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "medical_record_attachments_medical_record_id_fkey"
            columns: ["medical_record_id"]
            isOneToOne: false
            referencedRelation: "medical_records"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "medical_record_attachments_pet_id_fkey"
            columns: ["pet_id"]
            isOneToOne: false
            referencedRelation: "pets"
            referencedColumns: ["id"]
          },
        ]
      }
      medical_records: {
        Row: {
          abdominal_palpation: string | null
          appointment_id: string | null
          behavior: string | null
          capillary_refill_time: string | null
          cardiac_auscultation: string | null
          chief_complaint: string | null
          clinic_id: string
          consultation_date: string
          created_at: string | null
          crmv: string | null
          definitive_diagnosis: string | null
          deleted_at: string | null
          diet: string | null
          environment: string | null
          follow_up_date: string | null
          follow_up_notes: string | null
          heart_rate: number | null
          history: string | null
          hydration_status: string | null
          id: string
          locomotor_system: string | null
          lymph_nodes: string | null
          mapa_number: string | null
          medications: string | null
          mucous_membranes: string | null
          other_systems: string | null
          pet_id: string
          presumptive_diagnosis: string | null
          procedures: string | null
          recommendations: string | null
          respiratory_auscultation: string | null
          respiratory_rate: number | null
          skin_coat: string | null
          temperature: number | null
          treatment: string | null
          updated_at: string | null
          vet_user_id: string
          weight: number | null
        }
        Insert: {
          abdominal_palpation?: string | null
          appointment_id?: string | null
          behavior?: string | null
          capillary_refill_time?: string | null
          cardiac_auscultation?: string | null
          chief_complaint?: string | null
          clinic_id: string
          consultation_date?: string
          created_at?: string | null
          crmv?: string | null
          definitive_diagnosis?: string | null
          deleted_at?: string | null
          diet?: string | null
          environment?: string | null
          follow_up_date?: string | null
          follow_up_notes?: string | null
          heart_rate?: number | null
          history?: string | null
          hydration_status?: string | null
          id?: string
          locomotor_system?: string | null
          lymph_nodes?: string | null
          mapa_number?: string | null
          medications?: string | null
          mucous_membranes?: string | null
          other_systems?: string | null
          pet_id: string
          presumptive_diagnosis?: string | null
          procedures?: string | null
          recommendations?: string | null
          respiratory_auscultation?: string | null
          respiratory_rate?: number | null
          skin_coat?: string | null
          temperature?: number | null
          treatment?: string | null
          updated_at?: string | null
          vet_user_id: string
          weight?: number | null
        }
        Update: {
          abdominal_palpation?: string | null
          appointment_id?: string | null
          behavior?: string | null
          capillary_refill_time?: string | null
          cardiac_auscultation?: string | null
          chief_complaint?: string | null
          clinic_id?: string
          consultation_date?: string
          created_at?: string | null
          crmv?: string | null
          definitive_diagnosis?: string | null
          deleted_at?: string | null
          diet?: string | null
          environment?: string | null
          follow_up_date?: string | null
          follow_up_notes?: string | null
          heart_rate?: number | null
          history?: string | null
          hydration_status?: string | null
          id?: string
          locomotor_system?: string | null
          lymph_nodes?: string | null
          mapa_number?: string | null
          medications?: string | null
          mucous_membranes?: string | null
          other_systems?: string | null
          pet_id?: string
          presumptive_diagnosis?: string | null
          procedures?: string | null
          recommendations?: string | null
          respiratory_auscultation?: string | null
          respiratory_rate?: number | null
          skin_coat?: string | null
          temperature?: number | null
          treatment?: string | null
          updated_at?: string | null
          vet_user_id?: string
          weight?: number | null
        }
        Relationships: [
          {
            foreignKeyName: "fk_appointment"
            columns: ["appointment_id"]
            isOneToOne: false
            referencedRelation: "appointments"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "fk_clinic"
            columns: ["clinic_id"]
            isOneToOne: false
            referencedRelation: "clinics"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "fk_pet"
            columns: ["pet_id"]
            isOneToOne: false
            referencedRelation: "pets"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "fk_vet_user"
            columns: ["vet_user_id"]
            isOneToOne: false
            referencedRelation: "profiles"
            referencedColumns: ["id"]
          },
        ]
      }
      medication_active_principles: {
        Row: {
          active_principle_id: string
          created_at: string | null
          id: string
          medication_id: string
        }
        Insert: {
          active_principle_id: string
          created_at?: string | null
          id?: string
          medication_id: string
        }
        Update: {
          active_principle_id?: string
          created_at?: string | null
          id?: string
          medication_id?: string
        }
        Relationships: [
          {
            foreignKeyName: "medication_active_principles_active_principle_id_fkey"
            columns: ["active_principle_id"]
            isOneToOne: false
            referencedRelation: "medications"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "medication_active_principles_medication_id_fkey"
            columns: ["medication_id"]
            isOneToOne: false
            referencedRelation: "medications"
            referencedColumns: ["id"]
          },
        ]
      }
      medication_dosages: {
        Row: {
          administration_route: string | null
          created_at: string | null
          dose_unit: string | null
          frequency_hint: string | null
          id: string
          max_dose: number | null
          medication_id: string
          min_dose: number | null
          notes: string | null
          species_id: string | null
          updated_at: string | null
          weight_basis: string | null
        }
        Insert: {
          administration_route?: string | null
          created_at?: string | null
          dose_unit?: string | null
          frequency_hint?: string | null
          id?: string
          max_dose?: number | null
          medication_id: string
          min_dose?: number | null
          notes?: string | null
          species_id?: string | null
          updated_at?: string | null
          weight_basis?: string | null
        }
        Update: {
          administration_route?: string | null
          created_at?: string | null
          dose_unit?: string | null
          frequency_hint?: string | null
          id?: string
          max_dose?: number | null
          medication_id?: string
          min_dose?: number | null
          notes?: string | null
          species_id?: string | null
          updated_at?: string | null
          weight_basis?: string | null
        }
        Relationships: [
          {
            foreignKeyName: "medication_dosages_medication_id_fkey"
            columns: ["medication_id"]
            isOneToOne: false
            referencedRelation: "medications"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "medication_dosages_species_id_fkey"
            columns: ["species_id"]
            isOneToOne: false
            referencedRelation: "species"
            referencedColumns: ["id"]
          },
        ]
      }
      medication_posology_models: {
        Row: {
          clinic_id: string
          created_at: string
          created_by: string
          id: string
          medication_id: string | null
          medication_name: string
          name: string
          payload: Json
          updated_at: string
        }
        Insert: {
          clinic_id?: string
          created_at?: string
          created_by?: string
          id?: string
          medication_id?: string | null
          medication_name: string
          name: string
          payload: Json
          updated_at?: string
        }
        Update: {
          clinic_id?: string
          created_at?: string
          created_by?: string
          id?: string
          medication_id?: string | null
          medication_name?: string
          name?: string
          payload?: Json
          updated_at?: string
        }
        Relationships: [
          {
            foreignKeyName: "medication_posology_models_clinic_id_fkey"
            columns: ["clinic_id"]
            isOneToOne: false
            referencedRelation: "clinics"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "medication_posology_models_medication_id_fkey"
            columns: ["medication_id"]
            isOneToOne: false
            referencedRelation: "medications"
            referencedColumns: ["id"]
          },
        ]
      }
      medication_species: {
        Row: {
          created_at: string | null
          id: string
          medication_id: string
          species_id: string
        }
        Insert: {
          created_at?: string | null
          id?: string
          medication_id: string
          species_id: string
        }
        Update: {
          created_at?: string | null
          id?: string
          medication_id?: string
          species_id?: string
        }
        Relationships: [
          {
            foreignKeyName: "medication_species_medication_id_fkey"
            columns: ["medication_id"]
            isOneToOne: false
            referencedRelation: "medications"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "medication_species_species_id_fkey"
            columns: ["species_id"]
            isOneToOne: false
            referencedRelation: "species"
            referencedColumns: ["id"]
          },
        ]
      }
      medications: {
        Row: {
          administration_route: string | null
          administration_route_id: string | null
          brand_id: string | null
          concentration: string | null
          created_at: string | null
          created_by: string | null
          customer_id: string | null
          dose_unit: string | null
          id: string
          indication: string | null
          is_controlled: boolean
          manufacturer: string | null
          name: string
          notes: string | null
          pharmaceutical_class_id: string | null
          pharmaceutical_form: string | null
          pharmaceutical_form_id: string | null
          presentations: Json | null
          registration_number: string | null
          registration_status:
            | Database["public"]["Enums"]["sipeagro_registration_status"]
            | null
          requires_map_notification: boolean
          search_vector: unknown
          shelf_life_months: number | null
          source: string | null
          type: string | null
          updated_at: string | null
          usage_instructions: string | null
          warnings: string | null
        }
        Insert: {
          administration_route?: string | null
          administration_route_id?: string | null
          brand_id?: string | null
          concentration?: string | null
          created_at?: string | null
          created_by?: string | null
          customer_id?: string | null
          dose_unit?: string | null
          id?: string
          indication?: string | null
          is_controlled?: boolean
          manufacturer?: string | null
          name: string
          notes?: string | null
          pharmaceutical_class_id?: string | null
          pharmaceutical_form?: string | null
          pharmaceutical_form_id?: string | null
          presentations?: Json | null
          registration_number?: string | null
          registration_status?:
            | Database["public"]["Enums"]["sipeagro_registration_status"]
            | null
          requires_map_notification?: boolean
          search_vector?: unknown
          shelf_life_months?: number | null
          source?: string | null
          type?: string | null
          updated_at?: string | null
          usage_instructions?: string | null
          warnings?: string | null
        }
        Update: {
          administration_route?: string | null
          administration_route_id?: string | null
          brand_id?: string | null
          concentration?: string | null
          created_at?: string | null
          created_by?: string | null
          customer_id?: string | null
          dose_unit?: string | null
          id?: string
          indication?: string | null
          is_controlled?: boolean
          manufacturer?: string | null
          name?: string
          notes?: string | null
          pharmaceutical_class_id?: string | null
          pharmaceutical_form?: string | null
          pharmaceutical_form_id?: string | null
          presentations?: Json | null
          registration_number?: string | null
          registration_status?:
            | Database["public"]["Enums"]["sipeagro_registration_status"]
            | null
          requires_map_notification?: boolean
          search_vector?: unknown
          shelf_life_months?: number | null
          source?: string | null
          type?: string | null
          updated_at?: string | null
          usage_instructions?: string | null
          warnings?: string | null
        }
        Relationships: [
          {
            foreignKeyName: "medications_administration_route_id_fkey"
            columns: ["administration_route_id"]
            isOneToOne: false
            referencedRelation: "administration_routes"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "medications_brand_id_fkey"
            columns: ["brand_id"]
            isOneToOne: false
            referencedRelation: "brands"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "medications_customer_id_fkey"
            columns: ["customer_id"]
            isOneToOne: false
            referencedRelation: "customers"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "medications_pharmaceutical_class_id_fkey"
            columns: ["pharmaceutical_class_id"]
            isOneToOne: false
            referencedRelation: "pharmaceutical_classes"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "medications_pharmaceutical_form_id_fkey"
            columns: ["pharmaceutical_form_id"]
            isOneToOne: false
            referencedRelation: "pharmaceutical_forms"
            referencedColumns: ["id"]
          },
        ]
      }
      modules: {
        Row: {
          created_at: string | null
          id: string
          is_paid: boolean
          value: string
        }
        Insert: {
          created_at?: string | null
          id?: string
          is_paid?: boolean
          value: string
        }
        Update: {
          created_at?: string | null
          id?: string
          is_paid?: boolean
          value?: string
        }
        Relationships: []
      }
      overnight_config: {
        Row: {
          checkout_time: string | null
          clinic_id: string
          created_at: string
          id: string
          is_enabled: boolean
          price: number | null
          updated_at: string
        }
        Insert: {
          checkout_time?: string | null
          clinic_id: string
          created_at?: string
          id?: string
          is_enabled?: boolean
          price?: number | null
          updated_at?: string
        }
        Update: {
          checkout_time?: string | null
          clinic_id?: string
          created_at?: string
          id?: string
          is_enabled?: boolean
          price?: number | null
          updated_at?: string
        }
        Relationships: [
          {
            foreignKeyName: "overnight_config_clinic_id_fkey"
            columns: ["clinic_id"]
            isOneToOne: true
            referencedRelation: "clinics"
            referencedColumns: ["id"]
          },
        ]
      }
      owner_contact_preferences: {
        Row: {
          clinic_id: string
          consent_at: string | null
          consent_source: string | null
          created_at: string
          id: string
          opt_out_at: string | null
          opt_out_reason: string | null
          owner_id: string
          updated_at: string
          whatsapp_opt_out: boolean
        }
        Insert: {
          clinic_id: string
          consent_at?: string | null
          consent_source?: string | null
          created_at?: string
          id?: string
          opt_out_at?: string | null
          opt_out_reason?: string | null
          owner_id: string
          updated_at?: string
          whatsapp_opt_out?: boolean
        }
        Update: {
          clinic_id?: string
          consent_at?: string | null
          consent_source?: string | null
          created_at?: string
          id?: string
          opt_out_at?: string | null
          opt_out_reason?: string | null
          owner_id?: string
          updated_at?: string
          whatsapp_opt_out?: boolean
        }
        Relationships: [
          {
            foreignKeyName: "owner_contact_preferences_clinic_id_fkey"
            columns: ["clinic_id"]
            isOneToOne: false
            referencedRelation: "clinics"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "owner_contact_preferences_owner_id_fkey"
            columns: ["owner_id"]
            isOneToOne: false
            referencedRelation: "owners"
            referencedColumns: ["id"]
          },
        ]
      }
      owner_package_consumptions: {
        Row: {
          appointment_id: string
          appointment_item_id: string | null
          consumed_at: string
          created_at: string
          created_by: string | null
          id: string
          owner_package_id: string
          owner_package_item_id: string
          reversal_reason: string | null
          reversed_at: string | null
          sessions_consumed: number
        }
        Insert: {
          appointment_id: string
          appointment_item_id?: string | null
          consumed_at?: string
          created_at?: string
          created_by?: string | null
          id?: string
          owner_package_id: string
          owner_package_item_id: string
          reversal_reason?: string | null
          reversed_at?: string | null
          sessions_consumed?: number
        }
        Update: {
          appointment_id?: string
          appointment_item_id?: string | null
          consumed_at?: string
          created_at?: string
          created_by?: string | null
          id?: string
          owner_package_id?: string
          owner_package_item_id?: string
          reversal_reason?: string | null
          reversed_at?: string | null
          sessions_consumed?: number
        }
        Relationships: [
          {
            foreignKeyName: "owner_package_consumptions_appointment_id_fkey"
            columns: ["appointment_id"]
            isOneToOne: false
            referencedRelation: "appointments"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "owner_package_consumptions_appointment_item_id_fkey"
            columns: ["appointment_item_id"]
            isOneToOne: false
            referencedRelation: "appointment_items"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "owner_package_consumptions_created_by_fkey"
            columns: ["created_by"]
            isOneToOne: false
            referencedRelation: "profiles"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "owner_package_consumptions_owner_package_id_fkey"
            columns: ["owner_package_id"]
            isOneToOne: false
            referencedRelation: "owner_packages"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "owner_package_consumptions_owner_package_item_id_fkey"
            columns: ["owner_package_item_id"]
            isOneToOne: false
            referencedRelation: "owner_package_items"
            referencedColumns: ["id"]
          },
        ]
      }
      owner_package_items: {
        Row: {
          created_at: string
          id: string
          item_id: string | null
          item_name_snapshot: string
          owner_package_id: string
          sessions_remaining: number | null
          sessions_total: number
          sessions_used: number
          sort_order: number
          updated_at: string
        }
        Insert: {
          created_at?: string
          id?: string
          item_id?: string | null
          item_name_snapshot: string
          owner_package_id: string
          sessions_remaining?: number | null
          sessions_total: number
          sessions_used?: number
          sort_order?: number
          updated_at?: string
        }
        Update: {
          created_at?: string
          id?: string
          item_id?: string | null
          item_name_snapshot?: string
          owner_package_id?: string
          sessions_remaining?: number | null
          sessions_total?: number
          sessions_used?: number
          sort_order?: number
          updated_at?: string
        }
        Relationships: [
          {
            foreignKeyName: "owner_package_items_item_id_fkey"
            columns: ["item_id"]
            isOneToOne: false
            referencedRelation: "grooming_services_view"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "owner_package_items_item_id_fkey"
            columns: ["item_id"]
            isOneToOne: false
            referencedRelation: "items"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "owner_package_items_owner_package_id_fkey"
            columns: ["owner_package_id"]
            isOneToOne: false
            referencedRelation: "owner_packages"
            referencedColumns: ["id"]
          },
        ]
      }
      owner_packages: {
        Row: {
          charge_mode: Database["public"]["Enums"]["package_charge_mode"]
          clinic_id: string
          created_at: string
          created_by: string | null
          customer_id: string
          deleted_at: string | null
          deleted_by: string | null
          discount_type: string | null
          discount_value: number | null
          final_price: number
          full_price: number
          id: string
          notes: string | null
          outstanding_amount: number
          owner_id: string
          status_financeiro: Database["public"]["Enums"]["package_financial_status"]
          updated_at: string
          valid_from: string | null
          valid_until: string | null
        }
        Insert: {
          charge_mode?: Database["public"]["Enums"]["package_charge_mode"]
          clinic_id: string
          created_at?: string
          created_by?: string | null
          customer_id: string
          deleted_at?: string | null
          deleted_by?: string | null
          discount_type?: string | null
          discount_value?: number | null
          final_price?: number
          full_price?: number
          id?: string
          notes?: string | null
          outstanding_amount?: number
          owner_id: string
          status_financeiro?: Database["public"]["Enums"]["package_financial_status"]
          updated_at?: string
          valid_from?: string | null
          valid_until?: string | null
        }
        Update: {
          charge_mode?: Database["public"]["Enums"]["package_charge_mode"]
          clinic_id?: string
          created_at?: string
          created_by?: string | null
          customer_id?: string
          deleted_at?: string | null
          deleted_by?: string | null
          discount_type?: string | null
          discount_value?: number | null
          final_price?: number
          full_price?: number
          id?: string
          notes?: string | null
          outstanding_amount?: number
          owner_id?: string
          status_financeiro?: Database["public"]["Enums"]["package_financial_status"]
          updated_at?: string
          valid_from?: string | null
          valid_until?: string | null
        }
        Relationships: [
          {
            foreignKeyName: "owner_packages_clinic_id_fkey"
            columns: ["clinic_id"]
            isOneToOne: false
            referencedRelation: "clinics"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "owner_packages_created_by_fkey"
            columns: ["created_by"]
            isOneToOne: false
            referencedRelation: "profiles"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "owner_packages_customer_id_fkey"
            columns: ["customer_id"]
            isOneToOne: false
            referencedRelation: "customers"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "owner_packages_deleted_by_fkey"
            columns: ["deleted_by"]
            isOneToOne: false
            referencedRelation: "profiles"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "owner_packages_owner_id_fkey"
            columns: ["owner_id"]
            isOneToOne: false
            referencedRelation: "owners"
            referencedColumns: ["id"]
          },
        ]
      }
      owner_whatsapp_identities: {
        Row: {
          created_at: string
          id: string
          last_seen_at: string | null
          owner_id: string
          parent_user_id: string | null
          raw_payload: Json | null
          source: string | null
          updated_at: string
          user_id: string | null
          username: string | null
          wa_id: string | null
        }
        Insert: {
          created_at?: string
          id?: string
          last_seen_at?: string | null
          owner_id: string
          parent_user_id?: string | null
          raw_payload?: Json | null
          source?: string | null
          updated_at?: string
          user_id?: string | null
          username?: string | null
          wa_id?: string | null
        }
        Update: {
          created_at?: string
          id?: string
          last_seen_at?: string | null
          owner_id?: string
          parent_user_id?: string | null
          raw_payload?: Json | null
          source?: string | null
          updated_at?: string
          user_id?: string | null
          username?: string | null
          wa_id?: string | null
        }
        Relationships: [
          {
            foreignKeyName: "owner_whatsapp_identities_owner_id_fkey"
            columns: ["owner_id"]
            isOneToOne: true
            referencedRelation: "owners"
            referencedColumns: ["id"]
          },
        ]
      }
      owners: {
        Row: {
          birth_date: string | null
          created_at: string | null
          created_by: string | null
          deleted_at: string | null
          document: string | null
          document_type_id: string | null
          gender_id: string | null
          id: string
          lead_source_id: string | null
          marketing_consent: boolean | null
          name: string
          profession: string | null
          updated_at: string | null
        }
        Insert: {
          birth_date?: string | null
          created_at?: string | null
          created_by?: string | null
          deleted_at?: string | null
          document?: string | null
          document_type_id?: string | null
          gender_id?: string | null
          id?: string
          lead_source_id?: string | null
          marketing_consent?: boolean | null
          name: string
          profession?: string | null
          updated_at?: string | null
        }
        Update: {
          birth_date?: string | null
          created_at?: string | null
          created_by?: string | null
          deleted_at?: string | null
          document?: string | null
          document_type_id?: string | null
          gender_id?: string | null
          id?: string
          lead_source_id?: string | null
          marketing_consent?: boolean | null
          name?: string
          profession?: string | null
          updated_at?: string | null
        }
        Relationships: [
          {
            foreignKeyName: "owners_created_by_fkey"
            columns: ["created_by"]
            isOneToOne: false
            referencedRelation: "profiles"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "owners_document_type_id_fkey"
            columns: ["document_type_id"]
            isOneToOne: false
            referencedRelation: "document_types"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "owners_gender_id_fkey"
            columns: ["gender_id"]
            isOneToOne: false
            referencedRelation: "genders"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "owners_lead_source_id_fkey"
            columns: ["lead_source_id"]
            isOneToOne: false
            referencedRelation: "lead_sources"
            referencedColumns: ["id"]
          },
        ]
      }
      owners_addresses: {
        Row: {
          city_id: string | null
          complement: string | null
          created_at: string | null
          deleted_at: string | null
          id: string
          is_primary: boolean | null
          neighborhood: string | null
          number: string | null
          owner_id: string
          street: string | null
          updated_at: string | null
          zip_code: string | null
        }
        Insert: {
          city_id?: string | null
          complement?: string | null
          created_at?: string | null
          deleted_at?: string | null
          id?: string
          is_primary?: boolean | null
          neighborhood?: string | null
          number?: string | null
          owner_id: string
          street?: string | null
          updated_at?: string | null
          zip_code?: string | null
        }
        Update: {
          city_id?: string | null
          complement?: string | null
          created_at?: string | null
          deleted_at?: string | null
          id?: string
          is_primary?: boolean | null
          neighborhood?: string | null
          number?: string | null
          owner_id?: string
          street?: string | null
          updated_at?: string | null
          zip_code?: string | null
        }
        Relationships: [
          {
            foreignKeyName: "owners_addresses_city_id_fkey"
            columns: ["city_id"]
            isOneToOne: false
            referencedRelation: "cities"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "owners_addresses_owner_id_fkey"
            columns: ["owner_id"]
            isOneToOne: false
            referencedRelation: "owners"
            referencedColumns: ["id"]
          },
        ]
      }
      owners_consent: {
        Row: {
          collected_at: string
          collected_by_user_id: string
          collected_in_clinic_id: string
          consent_text_version: string
          consented: boolean
          created_at: string | null
          id: string
          owner_id: string
          scope: string
          updated_at: string | null
        }
        Insert: {
          collected_at: string
          collected_by_user_id: string
          collected_in_clinic_id: string
          consent_text_version: string
          consented: boolean
          created_at?: string | null
          id?: string
          owner_id: string
          scope: string
          updated_at?: string | null
        }
        Update: {
          collected_at?: string
          collected_by_user_id?: string
          collected_in_clinic_id?: string
          consent_text_version?: string
          consented?: boolean
          created_at?: string | null
          id?: string
          owner_id?: string
          scope?: string
          updated_at?: string | null
        }
        Relationships: [
          {
            foreignKeyName: "owners_consent_collected_by_user_id_fkey"
            columns: ["collected_by_user_id"]
            isOneToOne: false
            referencedRelation: "profiles"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "owners_consent_collected_in_clinic_id_fkey"
            columns: ["collected_in_clinic_id"]
            isOneToOne: false
            referencedRelation: "clinics"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "owners_consent_owner_id_fkey"
            columns: ["owner_id"]
            isOneToOne: false
            referencedRelation: "owners"
            referencedColumns: ["id"]
          },
        ]
      }
      owners_customers: {
        Row: {
          created_at: string | null
          customer_id: string
          deleted_at: string | null
          id: string
          owner_id: string
          updated_at: string | null
        }
        Insert: {
          created_at?: string | null
          customer_id: string
          deleted_at?: string | null
          id?: string
          owner_id: string
          updated_at?: string | null
        }
        Update: {
          created_at?: string | null
          customer_id?: string
          deleted_at?: string | null
          id?: string
          owner_id?: string
          updated_at?: string | null
        }
        Relationships: [
          {
            foreignKeyName: "owners_customers_customer_id_fkey"
            columns: ["customer_id"]
            isOneToOne: false
            referencedRelation: "customers"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "owners_customers_owner_id_fkey"
            columns: ["owner_id"]
            isOneToOne: false
            referencedRelation: "owners"
            referencedColumns: ["id"]
          },
        ]
      }
      owners_emails: {
        Row: {
          created_at: string | null
          deleted_at: string | null
          email: string
          id: string
          is_primary: boolean | null
          owner_id: string
          updated_at: string | null
        }
        Insert: {
          created_at?: string | null
          deleted_at?: string | null
          email: string
          id?: string
          is_primary?: boolean | null
          owner_id: string
          updated_at?: string | null
        }
        Update: {
          created_at?: string | null
          deleted_at?: string | null
          email?: string
          id?: string
          is_primary?: boolean | null
          owner_id?: string
          updated_at?: string | null
        }
        Relationships: [
          {
            foreignKeyName: "owners_emails_owner_id_fkey"
            columns: ["owner_id"]
            isOneToOne: false
            referencedRelation: "owners"
            referencedColumns: ["id"]
          },
        ]
      }
      owners_phones: {
        Row: {
          created_at: string | null
          deleted_at: string | null
          id: string
          is_primary: boolean | null
          is_whatsapp: boolean | null
          owner_id: string
          phone_number: string
          updated_at: string | null
        }
        Insert: {
          created_at?: string | null
          deleted_at?: string | null
          id?: string
          is_primary?: boolean | null
          is_whatsapp?: boolean | null
          owner_id: string
          phone_number: string
          updated_at?: string | null
        }
        Update: {
          created_at?: string | null
          deleted_at?: string | null
          id?: string
          is_primary?: boolean | null
          is_whatsapp?: boolean | null
          owner_id?: string
          phone_number?: string
          updated_at?: string | null
        }
        Relationships: [
          {
            foreignKeyName: "owners_phones_owner_id_fkey"
            columns: ["owner_id"]
            isOneToOne: false
            referencedRelation: "owners"
            referencedColumns: ["id"]
          },
        ]
      }
      package_subtypes: {
        Row: {
          created_at: string
          customer_id: string | null
          id: string
          name: string
          updated_at: string
        }
        Insert: {
          created_at?: string
          customer_id?: string | null
          id?: string
          name: string
          updated_at?: string
        }
        Update: {
          created_at?: string
          customer_id?: string | null
          id?: string
          name?: string
          updated_at?: string
        }
        Relationships: [
          {
            foreignKeyName: "package_subtypes_customer_id_fkey"
            columns: ["customer_id"]
            isOneToOne: false
            referencedRelation: "customers"
            referencedColumns: ["id"]
          },
        ]
      }
      pantanal_owner_ids: {
        Row: {
          created_at: string
          id: string
          legacy_owner_code: string
          owner_id: string
          updated_at: string
        }
        Insert: {
          created_at?: string
          id?: string
          legacy_owner_code: string
          owner_id: string
          updated_at?: string
        }
        Update: {
          created_at?: string
          id?: string
          legacy_owner_code?: string
          owner_id?: string
          updated_at?: string
        }
        Relationships: [
          {
            foreignKeyName: "pantanal_owner_ids_owner_id_fkey"
            columns: ["owner_id"]
            isOneToOne: false
            referencedRelation: "owners"
            referencedColumns: ["id"]
          },
        ]
      }
      pantanal_pet_ids: {
        Row: {
          created_at: string
          id: string
          legacy_pet_code: string
          pet_id: string
          updated_at: string
        }
        Insert: {
          created_at?: string
          id?: string
          legacy_pet_code: string
          pet_id: string
          updated_at?: string
        }
        Update: {
          created_at?: string
          id?: string
          legacy_pet_code?: string
          pet_id?: string
          updated_at?: string
        }
        Relationships: [
          {
            foreignKeyName: "pantanal_pet_ids_pet_id_fkey"
            columns: ["pet_id"]
            isOneToOne: false
            referencedRelation: "pets"
            referencedColumns: ["id"]
          },
        ]
      }
      patient_packages: {
        Row: {
          amount_paid: number
          catalog_package_id: string
          clinic_id: string
          created_at: string
          created_from_appointment_id: string | null
          created_from_stay_reservation_id: string | null
          customer_id: string
          deleted_at: string | null
          full_price: number
          id: string
          origin: string
          outstanding_amount: number
          pet_id: string
          sessions_remaining: number | null
          sessions_total: number
          sessions_used: number
          status_financeiro: Database["public"]["Enums"]["package_financial_status"]
          updated_at: string
          valid_from: string | null
          valid_until: string | null
        }
        Insert: {
          amount_paid?: number
          catalog_package_id: string
          clinic_id: string
          created_at?: string
          created_from_appointment_id?: string | null
          created_from_stay_reservation_id?: string | null
          customer_id: string
          deleted_at?: string | null
          full_price?: number
          id?: string
          origin?: string
          outstanding_amount?: number
          pet_id: string
          sessions_remaining?: number | null
          sessions_total: number
          sessions_used?: number
          status_financeiro?: Database["public"]["Enums"]["package_financial_status"]
          updated_at?: string
          valid_from?: string | null
          valid_until?: string | null
        }
        Update: {
          amount_paid?: number
          catalog_package_id?: string
          clinic_id?: string
          created_at?: string
          created_from_appointment_id?: string | null
          created_from_stay_reservation_id?: string | null
          customer_id?: string
          deleted_at?: string | null
          full_price?: number
          id?: string
          origin?: string
          outstanding_amount?: number
          pet_id?: string
          sessions_remaining?: number | null
          sessions_total?: number
          sessions_used?: number
          status_financeiro?: Database["public"]["Enums"]["package_financial_status"]
          updated_at?: string
          valid_from?: string | null
          valid_until?: string | null
        }
        Relationships: [
          {
            foreignKeyName: "patient_packages_catalog_package_id_fkey"
            columns: ["catalog_package_id"]
            isOneToOne: false
            referencedRelation: "catalog_packages"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "patient_packages_clinic_id_fkey"
            columns: ["clinic_id"]
            isOneToOne: false
            referencedRelation: "clinics"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "patient_packages_created_from_appointment_id_fkey"
            columns: ["created_from_appointment_id"]
            isOneToOne: false
            referencedRelation: "appointments"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "patient_packages_created_from_stay_reservation_id_fkey"
            columns: ["created_from_stay_reservation_id"]
            isOneToOne: false
            referencedRelation: "stay_reservations"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "patient_packages_customer_id_fkey"
            columns: ["customer_id"]
            isOneToOne: false
            referencedRelation: "customers"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "patient_packages_pet_id_fkey"
            columns: ["pet_id"]
            isOneToOne: false
            referencedRelation: "pets"
            referencedColumns: ["id"]
          },
        ]
      }
      patient_terms: {
        Row: {
          clinic_id: string | null
          created_at: string
          created_by: string
          deleted_at: string | null
          digitally_signed_access_code: string | null
          digitally_signed_at: string | null
          digitally_signed_by_user_id: string | null
          digitally_signed_pdf_sha256: string | null
          digitally_signed_storage_bucket: string | null
          digitally_signed_storage_path: string | null
          field_values_json: Json
          id: string
          medical_record_id: string | null
          pet_id: string
          printed_at: string | null
          printed_by: string | null
          rendered_content: string
          rendered_title: string
          resolved_values_json: Json
          signed_file_name: string | null
          signed_file_size: number | null
          signed_mime_type: string | null
          signed_storage_bucket: string | null
          signed_storage_path: string | null
          signed_uploaded_at: string | null
          template_id: string | null
          template_snapshot_config: Json
          template_snapshot_content: string
          template_snapshot_name: string
          title: string
          updated_at: string
        }
        Insert: {
          clinic_id?: string | null
          created_at?: string
          created_by: string
          deleted_at?: string | null
          digitally_signed_access_code?: string | null
          digitally_signed_at?: string | null
          digitally_signed_by_user_id?: string | null
          digitally_signed_pdf_sha256?: string | null
          digitally_signed_storage_bucket?: string | null
          digitally_signed_storage_path?: string | null
          field_values_json?: Json
          id?: string
          medical_record_id?: string | null
          pet_id: string
          printed_at?: string | null
          printed_by?: string | null
          rendered_content?: string
          rendered_title?: string
          resolved_values_json?: Json
          signed_file_name?: string | null
          signed_file_size?: number | null
          signed_mime_type?: string | null
          signed_storage_bucket?: string | null
          signed_storage_path?: string | null
          signed_uploaded_at?: string | null
          template_id?: string | null
          template_snapshot_config?: Json
          template_snapshot_content?: string
          template_snapshot_name?: string
          title: string
          updated_at?: string
        }
        Update: {
          clinic_id?: string | null
          created_at?: string
          created_by?: string
          deleted_at?: string | null
          digitally_signed_access_code?: string | null
          digitally_signed_at?: string | null
          digitally_signed_by_user_id?: string | null
          digitally_signed_pdf_sha256?: string | null
          digitally_signed_storage_bucket?: string | null
          digitally_signed_storage_path?: string | null
          field_values_json?: Json
          id?: string
          medical_record_id?: string | null
          pet_id?: string
          printed_at?: string | null
          printed_by?: string | null
          rendered_content?: string
          rendered_title?: string
          resolved_values_json?: Json
          signed_file_name?: string | null
          signed_file_size?: number | null
          signed_mime_type?: string | null
          signed_storage_bucket?: string | null
          signed_storage_path?: string | null
          signed_uploaded_at?: string | null
          template_id?: string | null
          template_snapshot_config?: Json
          template_snapshot_content?: string
          template_snapshot_name?: string
          title?: string
          updated_at?: string
        }
        Relationships: [
          {
            foreignKeyName: "patient_terms_clinic_id_fkey"
            columns: ["clinic_id"]
            isOneToOne: false
            referencedRelation: "clinics"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "patient_terms_created_by_fkey"
            columns: ["created_by"]
            isOneToOne: false
            referencedRelation: "profiles"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "patient_terms_digitally_signed_by_user_id_fkey"
            columns: ["digitally_signed_by_user_id"]
            isOneToOne: false
            referencedRelation: "profiles"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "patient_terms_medical_record_id_fkey"
            columns: ["medical_record_id"]
            isOneToOne: false
            referencedRelation: "medical_records"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "patient_terms_pet_id_fkey"
            columns: ["pet_id"]
            isOneToOne: false
            referencedRelation: "pets"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "patient_terms_printed_by_fkey"
            columns: ["printed_by"]
            isOneToOne: false
            referencedRelation: "profiles"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "patient_terms_template_id_fkey"
            columns: ["template_id"]
            isOneToOne: false
            referencedRelation: "customer_term_templates"
            referencedColumns: ["id"]
          },
        ]
      }
      pet_application_next_items: {
        Row: {
          created_at: string
          deleted_at: string | null
          due_date: string
          id: string
          item_id: string
          pet_application_id: string
        }
        Insert: {
          created_at?: string
          deleted_at?: string | null
          due_date: string
          id?: string
          item_id: string
          pet_application_id: string
        }
        Update: {
          created_at?: string
          deleted_at?: string | null
          due_date?: string
          id?: string
          item_id?: string
          pet_application_id?: string
        }
        Relationships: [
          {
            foreignKeyName: "pet_application_next_items_item_id_fkey"
            columns: ["item_id"]
            isOneToOne: false
            referencedRelation: "grooming_services_view"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "pet_application_next_items_item_id_fkey"
            columns: ["item_id"]
            isOneToOne: false
            referencedRelation: "items"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "pet_application_next_items_pet_application_id_fkey"
            columns: ["pet_application_id"]
            isOneToOne: false
            referencedRelation: "pet_applications"
            referencedColumns: ["id"]
          },
        ]
      }
      pet_application_plans: {
        Row: {
          appointment_id: string | null
          canceled_at: string | null
          clinic_id: string
          completed_at: string | null
          completed_pet_application_id: string | null
          created_at: string
          created_by: string | null
          deleted_at: string | null
          due_date: string
          id: string
          item_id: string
          notes: string | null
          pet_id: string
          source_pet_application_id: string | null
          source_type: string
          status: string
          updated_at: string
        }
        Insert: {
          appointment_id?: string | null
          canceled_at?: string | null
          clinic_id: string
          completed_at?: string | null
          completed_pet_application_id?: string | null
          created_at?: string
          created_by?: string | null
          deleted_at?: string | null
          due_date: string
          id?: string
          item_id: string
          notes?: string | null
          pet_id: string
          source_pet_application_id?: string | null
          source_type?: string
          status?: string
          updated_at?: string
        }
        Update: {
          appointment_id?: string | null
          canceled_at?: string | null
          clinic_id?: string
          completed_at?: string | null
          completed_pet_application_id?: string | null
          created_at?: string
          created_by?: string | null
          deleted_at?: string | null
          due_date?: string
          id?: string
          item_id?: string
          notes?: string | null
          pet_id?: string
          source_pet_application_id?: string | null
          source_type?: string
          status?: string
          updated_at?: string
        }
        Relationships: [
          {
            foreignKeyName: "pet_application_plans_appointment_id_fkey"
            columns: ["appointment_id"]
            isOneToOne: false
            referencedRelation: "appointments"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "pet_application_plans_clinic_id_fkey"
            columns: ["clinic_id"]
            isOneToOne: false
            referencedRelation: "clinics"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "pet_application_plans_completed_pet_application_id_fkey"
            columns: ["completed_pet_application_id"]
            isOneToOne: false
            referencedRelation: "pet_applications"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "pet_application_plans_created_by_fkey"
            columns: ["created_by"]
            isOneToOne: false
            referencedRelation: "profiles"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "pet_application_plans_item_id_fkey"
            columns: ["item_id"]
            isOneToOne: false
            referencedRelation: "grooming_services_view"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "pet_application_plans_item_id_fkey"
            columns: ["item_id"]
            isOneToOne: false
            referencedRelation: "items"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "pet_application_plans_pet_id_fkey"
            columns: ["pet_id"]
            isOneToOne: false
            referencedRelation: "pets"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "pet_application_plans_source_pet_application_id_fkey"
            columns: ["source_pet_application_id"]
            isOneToOne: false
            referencedRelation: "pet_applications"
            referencedColumns: ["id"]
          },
        ]
      }
      pet_applications: {
        Row: {
          adverse_reaction: string | null
          application_date: string
          appointment_id: string | null
          batch_number: string | null
          clinic_id: string
          created_at: string | null
          deleted_at: string | null
          dose_number: number
          expiry_date: string | null
          has_next_dose: boolean
          id: string
          item_id: string | null
          medical_record_id: string | null
          next_application_item_id: string | null
          next_dose_completed_at: string | null
          next_dose_completed_by_application_id: string | null
          next_dose_date: string | null
          notes: string | null
          overdue_hidden_at: string | null
          overdue_hidden_by: string | null
          pet_id: string
          updated_at: string | null
          vet_user_id: string
        }
        Insert: {
          adverse_reaction?: string | null
          application_date: string
          appointment_id?: string | null
          batch_number?: string | null
          clinic_id: string
          created_at?: string | null
          deleted_at?: string | null
          dose_number?: number
          expiry_date?: string | null
          has_next_dose?: boolean
          id?: string
          item_id?: string | null
          medical_record_id?: string | null
          next_application_item_id?: string | null
          next_dose_completed_at?: string | null
          next_dose_completed_by_application_id?: string | null
          next_dose_date?: string | null
          notes?: string | null
          overdue_hidden_at?: string | null
          overdue_hidden_by?: string | null
          pet_id: string
          updated_at?: string | null
          vet_user_id: string
        }
        Update: {
          adverse_reaction?: string | null
          application_date?: string
          appointment_id?: string | null
          batch_number?: string | null
          clinic_id?: string
          created_at?: string | null
          deleted_at?: string | null
          dose_number?: number
          expiry_date?: string | null
          has_next_dose?: boolean
          id?: string
          item_id?: string | null
          medical_record_id?: string | null
          next_application_item_id?: string | null
          next_dose_completed_at?: string | null
          next_dose_completed_by_application_id?: string | null
          next_dose_date?: string | null
          notes?: string | null
          overdue_hidden_at?: string | null
          overdue_hidden_by?: string | null
          pet_id?: string
          updated_at?: string | null
          vet_user_id?: string
        }
        Relationships: [
          {
            foreignKeyName: "pet_applications_appointment_id_fkey"
            columns: ["appointment_id"]
            isOneToOne: false
            referencedRelation: "appointments"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "pet_applications_clinic_id_fkey"
            columns: ["clinic_id"]
            isOneToOne: false
            referencedRelation: "clinics"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "pet_applications_item_id_fkey"
            columns: ["item_id"]
            isOneToOne: false
            referencedRelation: "grooming_services_view"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "pet_applications_item_id_fkey"
            columns: ["item_id"]
            isOneToOne: false
            referencedRelation: "items"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "pet_applications_medical_record_id_fkey"
            columns: ["medical_record_id"]
            isOneToOne: false
            referencedRelation: "medical_records"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "pet_applications_next_application_item_id_fkey"
            columns: ["next_application_item_id"]
            isOneToOne: false
            referencedRelation: "grooming_services_view"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "pet_applications_next_application_item_id_fkey"
            columns: ["next_application_item_id"]
            isOneToOne: false
            referencedRelation: "items"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "pet_applications_next_dose_completed_by_application_id_fkey"
            columns: ["next_dose_completed_by_application_id"]
            isOneToOne: false
            referencedRelation: "pet_applications"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "pet_applications_overdue_hidden_by_fkey"
            columns: ["overdue_hidden_by"]
            isOneToOne: false
            referencedRelation: "profiles"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "pet_applications_pet_id_fkey"
            columns: ["pet_id"]
            isOneToOne: false
            referencedRelation: "pets"
            referencedColumns: ["id"]
          },
        ]
      }
      pet_attachments: {
        Row: {
          annotations: Json
          category: string | null
          clinic_id: string | null
          created_at: string | null
          created_by: string | null
          deleted_at: string | null
          description: string | null
          exam_date: string | null
          file_name: string | null
          file_path: string
          file_size: number
          filename: string
          id: string
          medical_record_id: string | null
          metadata: Json | null
          mime_type: string
          ocr_status: string
          ocr_text: string | null
          original_name: string
          pet_id: string
          storage_bucket: string
          tags: string[] | null
          type: string | null
          updated_at: string | null
        }
        Insert: {
          annotations?: Json
          category?: string | null
          clinic_id?: string | null
          created_at?: string | null
          created_by?: string | null
          deleted_at?: string | null
          description?: string | null
          exam_date?: string | null
          file_name?: string | null
          file_path: string
          file_size: number
          filename: string
          id?: string
          medical_record_id?: string | null
          metadata?: Json | null
          mime_type: string
          ocr_status?: string
          ocr_text?: string | null
          original_name: string
          pet_id: string
          storage_bucket?: string
          tags?: string[] | null
          type?: string | null
          updated_at?: string | null
        }
        Update: {
          annotations?: Json
          category?: string | null
          clinic_id?: string | null
          created_at?: string | null
          created_by?: string | null
          deleted_at?: string | null
          description?: string | null
          exam_date?: string | null
          file_name?: string | null
          file_path?: string
          file_size?: number
          filename?: string
          id?: string
          medical_record_id?: string | null
          metadata?: Json | null
          mime_type?: string
          ocr_status?: string
          ocr_text?: string | null
          original_name?: string
          pet_id?: string
          storage_bucket?: string
          tags?: string[] | null
          type?: string | null
          updated_at?: string | null
        }
        Relationships: [
          {
            foreignKeyName: "pet_attachments_clinic_id_fkey"
            columns: ["clinic_id"]
            isOneToOne: false
            referencedRelation: "clinics"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "pet_attachments_created_by_fkey"
            columns: ["created_by"]
            isOneToOne: false
            referencedRelation: "profiles"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "pet_attachments_medical_record_id_fkey"
            columns: ["medical_record_id"]
            isOneToOne: false
            referencedRelation: "medical_records"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "pet_attachments_pet_id_fkey"
            columns: ["pet_id"]
            isOneToOne: false
            referencedRelation: "pets"
            referencedColumns: ["id"]
          },
        ]
      }
      pet_conditions: {
        Row: {
          condition_id: string
          pet_id: string
        }
        Insert: {
          condition_id: string
          pet_id: string
        }
        Update: {
          condition_id?: string
          pet_id?: string
        }
        Relationships: [
          {
            foreignKeyName: "pet_conditions_condition_id_fkey"
            columns: ["condition_id"]
            isOneToOne: false
            referencedRelation: "conditions"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "pet_conditions_pet_id_fkey"
            columns: ["pet_id"]
            isOneToOne: false
            referencedRelation: "pets"
            referencedColumns: ["id"]
          },
        ]
      }
      pet_custom_alerts: {
        Row: {
          color: string | null
          created_at: string
          customer_id: string
          icon: string | null
          id: string
          is_active: boolean
          label: string
          pet_id: string
          updated_at: string
          value: string
        }
        Insert: {
          color?: string | null
          created_at?: string
          customer_id: string
          icon?: string | null
          id?: string
          is_active?: boolean
          label: string
          pet_id: string
          updated_at?: string
          value: string
        }
        Update: {
          color?: string | null
          created_at?: string
          customer_id?: string
          icon?: string | null
          id?: string
          is_active?: boolean
          label?: string
          pet_id?: string
          updated_at?: string
          value?: string
        }
        Relationships: [
          {
            foreignKeyName: "pet_custom_alerts_customer_id_fkey"
            columns: ["customer_id"]
            isOneToOne: false
            referencedRelation: "customers"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "pet_custom_alerts_pet_id_fkey"
            columns: ["pet_id"]
            isOneToOne: false
            referencedRelation: "pets"
            referencedColumns: ["id"]
          },
        ]
      }
      pet_genders: {
        Row: {
          created_at: string | null
          id: string
          name: string
        }
        Insert: {
          created_at?: string | null
          id?: string
          name: string
        }
        Update: {
          created_at?: string | null
          id?: string
          name?: string
        }
        Relationships: []
      }
      pet_grooming_profiles: {
        Row: {
          allergies: Json | null
          coat_type: string | null
          created_at: string | null
          customer_id: string
          deleted_at: string | null
          fears: Json | null
          id: string
          pet_id: string
          preferred_style: string | null
          sensitive_areas: Json | null
          skin_issues: string | null
          special_instructions: string | null
          style_photos: Json | null
          temperament: string | null
          updated_at: string | null
        }
        Insert: {
          allergies?: Json | null
          coat_type?: string | null
          created_at?: string | null
          customer_id: string
          deleted_at?: string | null
          fears?: Json | null
          id?: string
          pet_id: string
          preferred_style?: string | null
          sensitive_areas?: Json | null
          skin_issues?: string | null
          special_instructions?: string | null
          style_photos?: Json | null
          temperament?: string | null
          updated_at?: string | null
        }
        Update: {
          allergies?: Json | null
          coat_type?: string | null
          created_at?: string | null
          customer_id?: string
          deleted_at?: string | null
          fears?: Json | null
          id?: string
          pet_id?: string
          preferred_style?: string | null
          sensitive_areas?: Json | null
          skin_issues?: string | null
          special_instructions?: string | null
          style_photos?: Json | null
          temperament?: string | null
          updated_at?: string | null
        }
        Relationships: [
          {
            foreignKeyName: "pet_grooming_profiles_customer_id_fkey"
            columns: ["customer_id"]
            isOneToOne: false
            referencedRelation: "customers"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "pet_grooming_profiles_pet_id_fkey"
            columns: ["pet_id"]
            isOneToOne: false
            referencedRelation: "pets"
            referencedColumns: ["id"]
          },
        ]
      }
      pet_photos: {
        Row: {
          created_at: string | null
          deleted_at: string | null
          file_path: string
          file_size: number
          filename: string
          id: string
          mime_type: string
          original_name: string
          pet_id: string
          updated_at: string | null
        }
        Insert: {
          created_at?: string | null
          deleted_at?: string | null
          file_path: string
          file_size: number
          filename: string
          id?: string
          mime_type: string
          original_name: string
          pet_id: string
          updated_at?: string | null
        }
        Update: {
          created_at?: string | null
          deleted_at?: string | null
          file_path?: string
          file_size?: number
          filename?: string
          id?: string
          mime_type?: string
          original_name?: string
          pet_id?: string
          updated_at?: string | null
        }
        Relationships: [
          {
            foreignKeyName: "pet_photos_pet_id_fkey"
            columns: ["pet_id"]
            isOneToOne: true
            referencedRelation: "pets"
            referencedColumns: ["id"]
          },
        ]
      }
      pet_relationship_events: {
        Row: {
          created_at: string
          description: string | null
          event_type: string
          id: string
          occurred_at: string
          pet_relationship_id: string
          recorded_by: string | null
          severity: string | null
          stay_reservation_daily_observation_id: string | null
        }
        Insert: {
          created_at?: string
          description?: string | null
          event_type: string
          id?: string
          occurred_at: string
          pet_relationship_id: string
          recorded_by?: string | null
          severity?: string | null
          stay_reservation_daily_observation_id?: string | null
        }
        Update: {
          created_at?: string
          description?: string | null
          event_type?: string
          id?: string
          occurred_at?: string
          pet_relationship_id?: string
          recorded_by?: string | null
          severity?: string | null
          stay_reservation_daily_observation_id?: string | null
        }
        Relationships: [
          {
            foreignKeyName: "pet_relationship_events_pet_relationship_id_fkey"
            columns: ["pet_relationship_id"]
            isOneToOne: false
            referencedRelation: "pet_relationships"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "pet_relationship_events_stay_reservation_daily_observation_fkey"
            columns: ["stay_reservation_daily_observation_id"]
            isOneToOne: false
            referencedRelation: "stay_reservation_daily_observations"
            referencedColumns: ["id"]
          },
        ]
      }
      pet_relationships: {
        Row: {
          created_at: string
          created_by: string | null
          customer_id: string
          description: string | null
          id: string
          pet_id: string
          related_pet_id: string
          relationship: string
        }
        Insert: {
          created_at?: string
          created_by?: string | null
          customer_id: string
          description?: string | null
          id?: string
          pet_id: string
          related_pet_id: string
          relationship: string
        }
        Update: {
          created_at?: string
          created_by?: string | null
          customer_id?: string
          description?: string | null
          id?: string
          pet_id?: string
          related_pet_id?: string
          relationship?: string
        }
        Relationships: [
          {
            foreignKeyName: "pet_relationships_customer_id_fkey"
            columns: ["customer_id"]
            isOneToOne: false
            referencedRelation: "customers"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "pet_relationships_pet_id_fkey"
            columns: ["pet_id"]
            isOneToOne: false
            referencedRelation: "pets"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "pet_relationships_related_pet_id_fkey"
            columns: ["related_pet_id"]
            isOneToOne: false
            referencedRelation: "pets"
            referencedColumns: ["id"]
          },
        ]
      }
      pet_size_categories: {
        Row: {
          created_at: string | null
          display_order: number
          id: string
          name: string
        }
        Insert: {
          created_at?: string | null
          display_order: number
          id?: string
          name: string
        }
        Update: {
          created_at?: string | null
          display_order?: number
          id?: string
          name?: string
        }
        Relationships: []
      }
      pet_statuses: {
        Row: {
          created_at: string | null
          id: string
          name: string
        }
        Insert: {
          created_at?: string | null
          id?: string
          name: string
        }
        Update: {
          created_at?: string | null
          id?: string
          name?: string
        }
        Relationships: []
      }
      pet_sterilizations: {
        Row: {
          created_at: string | null
          id: string
          name: string
        }
        Insert: {
          created_at?: string | null
          id?: string
          name: string
        }
        Update: {
          created_at?: string | null
          id?: string
          name?: string
        }
        Relationships: []
      }
      pet_stored_items: {
        Row: {
          clinic_id: string
          created_at: string
          created_by: string | null
          id: string
          is_kept: boolean
          item_name: string
          pet_id: string
          stay_reservation_id: string | null
          storage_location: string | null
          updated_at: string
          updated_by: string | null
        }
        Insert: {
          clinic_id: string
          created_at?: string
          created_by?: string | null
          id?: string
          is_kept?: boolean
          item_name: string
          pet_id: string
          stay_reservation_id?: string | null
          storage_location?: string | null
          updated_at?: string
          updated_by?: string | null
        }
        Update: {
          clinic_id?: string
          created_at?: string
          created_by?: string | null
          id?: string
          is_kept?: boolean
          item_name?: string
          pet_id?: string
          stay_reservation_id?: string | null
          storage_location?: string | null
          updated_at?: string
          updated_by?: string | null
        }
        Relationships: [
          {
            foreignKeyName: "pet_stored_items_clinic_id_fkey"
            columns: ["clinic_id"]
            isOneToOne: false
            referencedRelation: "clinics"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "pet_stored_items_pet_id_fkey"
            columns: ["pet_id"]
            isOneToOne: false
            referencedRelation: "pets"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "pet_stored_items_stay_reservation_id_fkey"
            columns: ["stay_reservation_id"]
            isOneToOne: false
            referencedRelation: "stay_reservations"
            referencedColumns: ["id"]
          },
        ]
      }
      pet_vet_demo_requests: {
        Row: {
          clinic_name: string | null
          created_at: string
          current_system: string | null
          email: string | null
          id: string
          interested_in_demo: boolean
          name: string | null
          needs: string | null
          role: string | null
          whatsapp_digits: string | null
          whatsapp_send_error: string | null
          whatsapp_send_status: string
          whatsapp_sent_at: string | null
        }
        Insert: {
          clinic_name?: string | null
          created_at?: string
          current_system?: string | null
          email?: string | null
          id?: string
          interested_in_demo?: boolean
          name?: string | null
          needs?: string | null
          role?: string | null
          whatsapp_digits?: string | null
          whatsapp_send_error?: string | null
          whatsapp_send_status?: string
          whatsapp_sent_at?: string | null
        }
        Update: {
          clinic_name?: string | null
          created_at?: string
          current_system?: string | null
          email?: string | null
          id?: string
          interested_in_demo?: boolean
          name?: string | null
          needs?: string | null
          role?: string | null
          whatsapp_digits?: string | null
          whatsapp_send_error?: string | null
          whatsapp_send_status?: string
          whatsapp_sent_at?: string | null
        }
        Relationships: []
      }
      pet_vet_research_submissions: {
        Row: {
          additional_notes: string | null
          automation_wish: string | null
          clinic_name: string | null
          clinic_size: string | null
          conversation_type: string | null
          created_at: string
          current_system: string | null
          daycare_hotel_context: string | null
          decision_maker: string | null
          home_care_context: string | null
          id: string
          interest_level: string | null
          most_time_consuming_task: string | null
          name: string | null
          pain_points: string[]
          professional_profile: string | null
          reporting_habits: string | null
          satisfaction_score: number | null
          student_context: string | null
          typical_day: string | null
        }
        Insert: {
          additional_notes?: string | null
          automation_wish?: string | null
          clinic_name?: string | null
          clinic_size?: string | null
          conversation_type?: string | null
          created_at?: string
          current_system?: string | null
          daycare_hotel_context?: string | null
          decision_maker?: string | null
          home_care_context?: string | null
          id?: string
          interest_level?: string | null
          most_time_consuming_task?: string | null
          name?: string | null
          pain_points?: string[]
          professional_profile?: string | null
          reporting_habits?: string | null
          satisfaction_score?: number | null
          student_context?: string | null
          typical_day?: string | null
        }
        Update: {
          additional_notes?: string | null
          automation_wish?: string | null
          clinic_name?: string | null
          clinic_size?: string | null
          conversation_type?: string | null
          created_at?: string
          current_system?: string | null
          daycare_hotel_context?: string | null
          decision_maker?: string | null
          home_care_context?: string | null
          id?: string
          interest_level?: string | null
          most_time_consuming_task?: string | null
          name?: string | null
          pain_points?: string[]
          professional_profile?: string | null
          reporting_habits?: string | null
          satisfaction_score?: number | null
          student_context?: string | null
          typical_day?: string | null
        }
        Relationships: []
      }
      pet_weights: {
        Row: {
          created_at: string | null
          deleted_at: string | null
          id: string
          measured_at: string | null
          medical_record_id: string | null
          pet_id: string
          source: string
          updated_at: string | null
          weight: number
        }
        Insert: {
          created_at?: string | null
          deleted_at?: string | null
          id?: string
          measured_at?: string | null
          medical_record_id?: string | null
          pet_id: string
          source?: string
          updated_at?: string | null
          weight: number
        }
        Update: {
          created_at?: string | null
          deleted_at?: string | null
          id?: string
          measured_at?: string | null
          medical_record_id?: string | null
          pet_id?: string
          source?: string
          updated_at?: string | null
          weight?: number
        }
        Relationships: [
          {
            foreignKeyName: "pet_weights_medical_record_id_fkey"
            columns: ["medical_record_id"]
            isOneToOne: false
            referencedRelation: "medical_records"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "pet_weights_pet_id_fkey"
            columns: ["pet_id"]
            isOneToOne: false
            referencedRelation: "pets"
            referencedColumns: ["id"]
          },
        ]
      }
      pets: {
        Row: {
          birth_date: string | null
          breed_id: string | null
          coat_type_id: string | null
          color_id: string | null
          created_at: string | null
          daycare_hotel_notes: string | null
          death_cause: string | null
          death_date: string | null
          deleted_at: string | null
          gender_id: string | null
          health_plan: string | null
          id: string
          microchip_number: string | null
          name: string
          owner_id: string
          pedigree_number: string | null
          record_number: string | null
          size_category_id: string | null
          species_id: string | null
          status_id: string
          sterilization_id: string | null
          updated_at: string | null
        }
        Insert: {
          birth_date?: string | null
          breed_id?: string | null
          coat_type_id?: string | null
          color_id?: string | null
          created_at?: string | null
          daycare_hotel_notes?: string | null
          death_cause?: string | null
          death_date?: string | null
          deleted_at?: string | null
          gender_id?: string | null
          health_plan?: string | null
          id?: string
          microchip_number?: string | null
          name: string
          owner_id: string
          pedigree_number?: string | null
          record_number?: string | null
          size_category_id?: string | null
          species_id?: string | null
          status_id?: string
          sterilization_id?: string | null
          updated_at?: string | null
        }
        Update: {
          birth_date?: string | null
          breed_id?: string | null
          coat_type_id?: string | null
          color_id?: string | null
          created_at?: string | null
          daycare_hotel_notes?: string | null
          death_cause?: string | null
          death_date?: string | null
          deleted_at?: string | null
          gender_id?: string | null
          health_plan?: string | null
          id?: string
          microchip_number?: string | null
          name?: string
          owner_id?: string
          pedigree_number?: string | null
          record_number?: string | null
          size_category_id?: string | null
          species_id?: string | null
          status_id?: string
          sterilization_id?: string | null
          updated_at?: string | null
        }
        Relationships: [
          {
            foreignKeyName: "pets_breed_id_fkey"
            columns: ["breed_id"]
            isOneToOne: false
            referencedRelation: "breeds"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "pets_coat_type_id_fkey"
            columns: ["coat_type_id"]
            isOneToOne: false
            referencedRelation: "coat_types"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "pets_color_id_fkey"
            columns: ["color_id"]
            isOneToOne: false
            referencedRelation: "colors"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "pets_gender_id_fkey"
            columns: ["gender_id"]
            isOneToOne: false
            referencedRelation: "pet_genders"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "pets_owner_id_fkey"
            columns: ["owner_id"]
            isOneToOne: false
            referencedRelation: "owners"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "pets_size_category_id_fkey"
            columns: ["size_category_id"]
            isOneToOne: false
            referencedRelation: "pet_size_categories"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "pets_species_id_fkey"
            columns: ["species_id"]
            isOneToOne: false
            referencedRelation: "species"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "pets_status_id_fkey"
            columns: ["status_id"]
            isOneToOne: false
            referencedRelation: "pet_statuses"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "pets_sterilization_id_fkey"
            columns: ["sterilization_id"]
            isOneToOne: false
            referencedRelation: "pet_sterilizations"
            referencedColumns: ["id"]
          },
        ]
      }
      pets_customers: {
        Row: {
          created_at: string | null
          customer_id: string
          deleted_at: string | null
          id: string
          notes: string | null
          pet_id: string
          updated_at: string | null
        }
        Insert: {
          created_at?: string | null
          customer_id: string
          deleted_at?: string | null
          id?: string
          notes?: string | null
          pet_id: string
          updated_at?: string | null
        }
        Update: {
          created_at?: string | null
          customer_id?: string
          deleted_at?: string | null
          id?: string
          notes?: string | null
          pet_id?: string
          updated_at?: string | null
        }
        Relationships: [
          {
            foreignKeyName: "pets_customers_customer_id_fkey"
            columns: ["customer_id"]
            isOneToOne: false
            referencedRelation: "customers"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "pets_customers_pet_id_fkey"
            columns: ["pet_id"]
            isOneToOne: false
            referencedRelation: "pets"
            referencedColumns: ["id"]
          },
        ]
      }
      pharmaceutical_classes: {
        Row: {
          category_id: string | null
          created_at: string | null
          description: string | null
          id: string
          is_active: boolean | null
          name: string
        }
        Insert: {
          category_id?: string | null
          created_at?: string | null
          description?: string | null
          id?: string
          is_active?: boolean | null
          name: string
        }
        Update: {
          category_id?: string | null
          created_at?: string | null
          description?: string | null
          id?: string
          is_active?: boolean | null
          name?: string
        }
        Relationships: [
          {
            foreignKeyName: "pharmaceutical_classes_category_id_fkey"
            columns: ["category_id"]
            isOneToOne: false
            referencedRelation: "categories"
            referencedColumns: ["id"]
          },
        ]
      }
      pharmaceutical_forms: {
        Row: {
          created_at: string | null
          id: string
          is_active: boolean | null
          name: string
        }
        Insert: {
          created_at?: string | null
          id?: string
          is_active?: boolean | null
          name: string
        }
        Update: {
          created_at?: string | null
          id?: string
          is_active?: boolean | null
          name?: string
        }
        Relationships: []
      }
      prescription_template_items: {
        Row: {
          administration_route: string | null
          created_at: string
          dose_amount: string | null
          dose_unit: string | null
          duration_unit: string | null
          duration_value: string | null
          free_text_posology: string | null
          frequency_unit: string | null
          frequency_value: string | null
          id: string
          medication_concentration: string | null
          medication_id: string | null
          medication_name: string
          pharmaceutical_form: string | null
          posology_mode: string
          presentation: string | null
          quantity: string | null
          template_id: string
          updated_at: string
        }
        Insert: {
          administration_route?: string | null
          created_at?: string
          dose_amount?: string | null
          dose_unit?: string | null
          duration_unit?: string | null
          duration_value?: string | null
          free_text_posology?: string | null
          frequency_unit?: string | null
          frequency_value?: string | null
          id?: string
          medication_concentration?: string | null
          medication_id?: string | null
          medication_name: string
          pharmaceutical_form?: string | null
          posology_mode: string
          presentation?: string | null
          quantity?: string | null
          template_id: string
          updated_at?: string
        }
        Update: {
          administration_route?: string | null
          created_at?: string
          dose_amount?: string | null
          dose_unit?: string | null
          duration_unit?: string | null
          duration_value?: string | null
          free_text_posology?: string | null
          frequency_unit?: string | null
          frequency_value?: string | null
          id?: string
          medication_concentration?: string | null
          medication_id?: string | null
          medication_name?: string
          pharmaceutical_form?: string | null
          posology_mode?: string
          presentation?: string | null
          quantity?: string | null
          template_id?: string
          updated_at?: string
        }
        Relationships: [
          {
            foreignKeyName: "prescription_template_items_medication_id_fkey"
            columns: ["medication_id"]
            isOneToOne: false
            referencedRelation: "medications"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "prescription_template_items_template_id_fkey"
            columns: ["template_id"]
            isOneToOne: false
            referencedRelation: "prescription_templates"
            referencedColumns: ["id"]
          },
        ]
      }
      prescription_templates: {
        Row: {
          clinic_id: string
          created_at: string
          created_by: string | null
          id: string
          manipulated_payload: Json | null
          observations: string | null
          owner_user_id: string
          template_type: string
          title: string
          updated_at: string
        }
        Insert: {
          clinic_id?: string
          created_at?: string
          created_by?: string | null
          id?: string
          manipulated_payload?: Json | null
          observations?: string | null
          owner_user_id: string
          template_type?: string
          title: string
          updated_at?: string
        }
        Update: {
          clinic_id?: string
          created_at?: string
          created_by?: string | null
          id?: string
          manipulated_payload?: Json | null
          observations?: string | null
          owner_user_id?: string
          template_type?: string
          title?: string
          updated_at?: string
        }
        Relationships: [
          {
            foreignKeyName: "prescription_templates_clinic_id_fkey"
            columns: ["clinic_id"]
            isOneToOne: false
            referencedRelation: "clinics"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "prescription_templates_created_by_fkey"
            columns: ["created_by"]
            isOneToOne: false
            referencedRelation: "profiles"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "prescription_templates_owner_user_id_fkey"
            columns: ["owner_user_id"]
            isOneToOne: false
            referencedRelation: "profiles"
            referencedColumns: ["id"]
          },
        ]
      }
      print_settings: {
        Row: {
          background_image_url: string | null
          created_at: string | null
          font_size_pt: number | null
          footer_image_url: string | null
          footer_layout: string | null
          footer_text: string | null
          footer_text_color: string | null
          header_image_url: string | null
          header_layout: string | null
          header_logo_height_px: number | null
          header_text: string | null
          header_text_color: string | null
          id: string
          line_height: number | null
          margin_bottom_mm: number | null
          margin_side_mm: number | null
          margin_top_mm: number | null
          paper_size: string
          show_issuer_block: boolean
          stamp_show_crmv: boolean
          stamp_show_mapa: boolean
          term_background_image_url: string | null
          term_font_size_pt: number | null
          term_footer_image_url: string | null
          term_footer_layout: string | null
          term_footer_text: string | null
          term_footer_text_color: string | null
          term_header_image_url: string | null
          term_header_layout: string | null
          term_header_logo_height_px: number | null
          term_header_text: string | null
          term_header_text_color: string | null
          term_line_height: number | null
          term_margin_bottom_mm: number | null
          term_margin_side_mm: number | null
          term_margin_top_mm: number | null
          term_paper_size: string
          term_show_issuer_block: boolean
          term_stamp_show_crmv: boolean
          term_stamp_show_mapa: boolean
          term_text_color: string | null
          term_text_font_family: string | null
          term_title_color: string | null
          text_color: string | null
          text_font_family: string | null
          title_color: string | null
          updated_at: string | null
          user_id: string
        }
        Insert: {
          background_image_url?: string | null
          created_at?: string | null
          font_size_pt?: number | null
          footer_image_url?: string | null
          footer_layout?: string | null
          footer_text?: string | null
          footer_text_color?: string | null
          header_image_url?: string | null
          header_layout?: string | null
          header_logo_height_px?: number | null
          header_text?: string | null
          header_text_color?: string | null
          id?: string
          line_height?: number | null
          margin_bottom_mm?: number | null
          margin_side_mm?: number | null
          margin_top_mm?: number | null
          paper_size?: string
          show_issuer_block?: boolean
          stamp_show_crmv?: boolean
          stamp_show_mapa?: boolean
          term_background_image_url?: string | null
          term_font_size_pt?: number | null
          term_footer_image_url?: string | null
          term_footer_layout?: string | null
          term_footer_text?: string | null
          term_footer_text_color?: string | null
          term_header_image_url?: string | null
          term_header_layout?: string | null
          term_header_logo_height_px?: number | null
          term_header_text?: string | null
          term_header_text_color?: string | null
          term_line_height?: number | null
          term_margin_bottom_mm?: number | null
          term_margin_side_mm?: number | null
          term_margin_top_mm?: number | null
          term_paper_size?: string
          term_show_issuer_block?: boolean
          term_stamp_show_crmv?: boolean
          term_stamp_show_mapa?: boolean
          term_text_color?: string | null
          term_text_font_family?: string | null
          term_title_color?: string | null
          text_color?: string | null
          text_font_family?: string | null
          title_color?: string | null
          updated_at?: string | null
          user_id: string
        }
        Update: {
          background_image_url?: string | null
          created_at?: string | null
          font_size_pt?: number | null
          footer_image_url?: string | null
          footer_layout?: string | null
          footer_text?: string | null
          footer_text_color?: string | null
          header_image_url?: string | null
          header_layout?: string | null
          header_logo_height_px?: number | null
          header_text?: string | null
          header_text_color?: string | null
          id?: string
          line_height?: number | null
          margin_bottom_mm?: number | null
          margin_side_mm?: number | null
          margin_top_mm?: number | null
          paper_size?: string
          show_issuer_block?: boolean
          stamp_show_crmv?: boolean
          stamp_show_mapa?: boolean
          term_background_image_url?: string | null
          term_font_size_pt?: number | null
          term_footer_image_url?: string | null
          term_footer_layout?: string | null
          term_footer_text?: string | null
          term_footer_text_color?: string | null
          term_header_image_url?: string | null
          term_header_layout?: string | null
          term_header_logo_height_px?: number | null
          term_header_text?: string | null
          term_header_text_color?: string | null
          term_line_height?: number | null
          term_margin_bottom_mm?: number | null
          term_margin_side_mm?: number | null
          term_margin_top_mm?: number | null
          term_paper_size?: string
          term_show_issuer_block?: boolean
          term_stamp_show_crmv?: boolean
          term_stamp_show_mapa?: boolean
          term_text_color?: string | null
          term_text_font_family?: string | null
          term_title_color?: string | null
          text_color?: string | null
          text_font_family?: string | null
          title_color?: string | null
          updated_at?: string | null
          user_id?: string
        }
        Relationships: [
          {
            foreignKeyName: "print_settings_user_id_fkey"
            columns: ["user_id"]
            isOneToOne: true
            referencedRelation: "profiles"
            referencedColumns: ["id"]
          },
        ]
      }
      product_stock: {
        Row: {
          clinic_id: string
          created_at: string
          deleted_at: string | null
          deleted_by: string | null
          has_expiring_items: boolean | null
          id: string
          item_id: string
          min_expiry_date: string | null
          quantity: number
          updated_at: string
        }
        Insert: {
          clinic_id: string
          created_at?: string
          deleted_at?: string | null
          deleted_by?: string | null
          has_expiring_items?: boolean | null
          id?: string
          item_id: string
          min_expiry_date?: string | null
          quantity?: number
          updated_at?: string
        }
        Update: {
          clinic_id?: string
          created_at?: string
          deleted_at?: string | null
          deleted_by?: string | null
          has_expiring_items?: boolean | null
          id?: string
          item_id?: string
          min_expiry_date?: string | null
          quantity?: number
          updated_at?: string
        }
        Relationships: [
          {
            foreignKeyName: "product_stock_clinic_id_fkey"
            columns: ["clinic_id"]
            isOneToOne: false
            referencedRelation: "clinics"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "product_stock_deleted_by_fkey"
            columns: ["deleted_by"]
            isOneToOne: false
            referencedRelation: "profiles"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "product_stock_item_id_fkey"
            columns: ["item_id"]
            isOneToOne: true
            referencedRelation: "grooming_services_view"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "product_stock_item_id_fkey"
            columns: ["item_id"]
            isOneToOne: true
            referencedRelation: "items"
            referencedColumns: ["id"]
          },
        ]
      }
      product_stock_movements: {
        Row: {
          clinic_id: string
          created_at: string
          created_by: string | null
          deleted_at: string | null
          deleted_by: string | null
          expiry_date: string | null
          id: string
          item_id: string
          quantity: number
          quantity_after: number
          quantity_before: number
          reason: string | null
          type: string
        }
        Insert: {
          clinic_id: string
          created_at?: string
          created_by?: string | null
          deleted_at?: string | null
          deleted_by?: string | null
          expiry_date?: string | null
          id?: string
          item_id: string
          quantity: number
          quantity_after: number
          quantity_before: number
          reason?: string | null
          type: string
        }
        Update: {
          clinic_id?: string
          created_at?: string
          created_by?: string | null
          deleted_at?: string | null
          deleted_by?: string | null
          expiry_date?: string | null
          id?: string
          item_id?: string
          quantity?: number
          quantity_after?: number
          quantity_before?: number
          reason?: string | null
          type?: string
        }
        Relationships: [
          {
            foreignKeyName: "product_stock_movements_clinic_id_fkey"
            columns: ["clinic_id"]
            isOneToOne: false
            referencedRelation: "clinics"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "product_stock_movements_created_by_fkey"
            columns: ["created_by"]
            isOneToOne: false
            referencedRelation: "profiles"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "product_stock_movements_deleted_by_fkey"
            columns: ["deleted_by"]
            isOneToOne: false
            referencedRelation: "profiles"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "product_stock_movements_item_id_fkey"
            columns: ["item_id"]
            isOneToOne: false
            referencedRelation: "grooming_services_view"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "product_stock_movements_item_id_fkey"
            columns: ["item_id"]
            isOneToOne: false
            referencedRelation: "items"
            referencedColumns: ["id"]
          },
        ]
      }
      product_subtypes: {
        Row: {
          created_at: string
          customer_id: string | null
          id: string
          name: string
          updated_at: string
        }
        Insert: {
          created_at?: string
          customer_id?: string | null
          id?: string
          name: string
          updated_at?: string
        }
        Update: {
          created_at?: string
          customer_id?: string | null
          id?: string
          name?: string
          updated_at?: string
        }
        Relationships: [
          {
            foreignKeyName: "product_subtypes_customer_id_fkey"
            columns: ["customer_id"]
            isOneToOne: false
            referencedRelation: "customers"
            referencedColumns: ["id"]
          },
        ]
      }
      profiles: {
        Row: {
          address: string | null
          avatar_url: string | null
          birth_date: string | null
          cpf: string | null
          created_at: string
          crmv_number: number | null
          crmv_state: string | null
          current_clinic_id: string | null
          email: string | null
          full_name: string
          id: string
          is_super_admin: boolean
          mapa_number: string | null
          phone: string | null
          updated_at: string
        }
        Insert: {
          address?: string | null
          avatar_url?: string | null
          birth_date?: string | null
          cpf?: string | null
          created_at?: string
          crmv_number?: number | null
          crmv_state?: string | null
          current_clinic_id?: string | null
          email?: string | null
          full_name: string
          id: string
          is_super_admin?: boolean
          mapa_number?: string | null
          phone?: string | null
          updated_at?: string
        }
        Update: {
          address?: string | null
          avatar_url?: string | null
          birth_date?: string | null
          cpf?: string | null
          created_at?: string
          crmv_number?: number | null
          crmv_state?: string | null
          current_clinic_id?: string | null
          email?: string | null
          full_name?: string
          id?: string
          is_super_admin?: boolean
          mapa_number?: string | null
          phone?: string | null
          updated_at?: string
        }
        Relationships: [
          {
            foreignKeyName: "profiles_current_clinic_id_fkey"
            columns: ["current_clinic_id"]
            isOneToOne: false
            referencedRelation: "clinics"
            referencedColumns: ["id"]
          },
        ]
      }
      profiles_backup: {
        Row: {
          avatar_url: string | null
          cpf: string | null
          created_at: string | null
          crmv_number: number | null
          crmv_state: string | null
          current_clinic_id: string | null
          full_name: string | null
          id: string | null
          mapa_number: string | null
          phone: string | null
          updated_at: string | null
        }
        Insert: {
          avatar_url?: string | null
          cpf?: string | null
          created_at?: string | null
          crmv_number?: number | null
          crmv_state?: string | null
          current_clinic_id?: string | null
          full_name?: string | null
          id?: string | null
          mapa_number?: string | null
          phone?: string | null
          updated_at?: string | null
        }
        Update: {
          avatar_url?: string | null
          cpf?: string | null
          created_at?: string | null
          crmv_number?: number | null
          crmv_state?: string | null
          current_clinic_id?: string | null
          full_name?: string | null
          id?: string | null
          mapa_number?: string | null
          phone?: string | null
          updated_at?: string | null
        }
        Relationships: []
      }
      prontuario_eventos: {
        Row: {
          acao: string
          created_at: string
          dados_resumidos: Json | null
          hash_ref: string | null
          id: string
          ip: string | null
          prontuario_id: string
          user_agent: string | null
          user_id: string | null
        }
        Insert: {
          acao: string
          created_at?: string
          dados_resumidos?: Json | null
          hash_ref?: string | null
          id?: string
          ip?: string | null
          prontuario_id: string
          user_agent?: string | null
          user_id?: string | null
        }
        Update: {
          acao?: string
          created_at?: string
          dados_resumidos?: Json | null
          hash_ref?: string | null
          id?: string
          ip?: string | null
          prontuario_id?: string
          user_agent?: string | null
          user_id?: string | null
        }
        Relationships: [
          {
            foreignKeyName: "prontuario_eventos_prontuario_id_fkey"
            columns: ["prontuario_id"]
            isOneToOne: false
            referencedRelation: "prontuarios"
            referencedColumns: ["id"]
          },
        ]
      }
      prontuario_export_events: {
        Row: {
          acao: string
          actor_user_id: string | null
          clinic_id: string
          created_at: string
          event_hash: string
          export_id: string
          id: string
          pdf_sha256: string
          previous_event_hash: string | null
          prontuario_id: string
          storage_object_key: string
        }
        Insert: {
          acao: string
          actor_user_id?: string | null
          clinic_id: string
          created_at?: string
          event_hash: string
          export_id: string
          id?: string
          pdf_sha256: string
          previous_event_hash?: string | null
          prontuario_id: string
          storage_object_key: string
        }
        Update: {
          acao?: string
          actor_user_id?: string | null
          clinic_id?: string
          created_at?: string
          event_hash?: string
          export_id?: string
          id?: string
          pdf_sha256?: string
          previous_event_hash?: string | null
          prontuario_id?: string
          storage_object_key?: string
        }
        Relationships: [
          {
            foreignKeyName: "prontuario_export_events_clinic_id_fkey"
            columns: ["clinic_id"]
            isOneToOne: false
            referencedRelation: "clinics"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "prontuario_export_events_export_id_fkey"
            columns: ["export_id"]
            isOneToOne: false
            referencedRelation: "prontuario_exports"
            referencedColumns: ["export_id"]
          },
          {
            foreignKeyName: "prontuario_export_events_prontuario_id_fkey"
            columns: ["prontuario_id"]
            isOneToOne: false
            referencedRelation: "prontuarios"
            referencedColumns: ["id"]
          },
        ]
      }
      prontuario_exports: {
        Row: {
          app_version: string | null
          clinic_id: string
          export_id: string
          generated_at: string
          generated_by_user_id: string | null
          ip: string | null
          medical_record_id: string
          owner_id: string | null
          pdf_pages: number
          pdf_sha256: string
          pdf_size_bytes: number
          pet_id: string
          prontuario_id: string
          signed_at: string | null
          signed_by_user_id: string | null
          signed_storage_bucket: string | null
          signed_storage_path: string | null
          source_data_version: string | null
          source_version_id: string | null
          storage_bucket: string
          storage_object_key: string
          template_version: string | null
          user_agent: string | null
        }
        Insert: {
          app_version?: string | null
          clinic_id: string
          export_id?: string
          generated_at?: string
          generated_by_user_id?: string | null
          ip?: string | null
          medical_record_id: string
          owner_id?: string | null
          pdf_pages: number
          pdf_sha256: string
          pdf_size_bytes: number
          pet_id: string
          prontuario_id: string
          signed_at?: string | null
          signed_by_user_id?: string | null
          signed_storage_bucket?: string | null
          signed_storage_path?: string | null
          source_data_version?: string | null
          source_version_id?: string | null
          storage_bucket?: string
          storage_object_key: string
          template_version?: string | null
          user_agent?: string | null
        }
        Update: {
          app_version?: string | null
          clinic_id?: string
          export_id?: string
          generated_at?: string
          generated_by_user_id?: string | null
          ip?: string | null
          medical_record_id?: string
          owner_id?: string | null
          pdf_pages?: number
          pdf_sha256?: string
          pdf_size_bytes?: number
          pet_id?: string
          prontuario_id?: string
          signed_at?: string | null
          signed_by_user_id?: string | null
          signed_storage_bucket?: string | null
          signed_storage_path?: string | null
          source_data_version?: string | null
          source_version_id?: string | null
          storage_bucket?: string
          storage_object_key?: string
          template_version?: string | null
          user_agent?: string | null
        }
        Relationships: [
          {
            foreignKeyName: "prontuario_exports_clinic_id_fkey"
            columns: ["clinic_id"]
            isOneToOne: false
            referencedRelation: "clinics"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "prontuario_exports_medical_record_id_fkey"
            columns: ["medical_record_id"]
            isOneToOne: false
            referencedRelation: "medical_records"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "prontuario_exports_owner_id_fkey"
            columns: ["owner_id"]
            isOneToOne: false
            referencedRelation: "owners"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "prontuario_exports_pet_id_fkey"
            columns: ["pet_id"]
            isOneToOne: false
            referencedRelation: "pets"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "prontuario_exports_prontuario_id_fkey"
            columns: ["prontuario_id"]
            isOneToOne: false
            referencedRelation: "prontuarios"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "prontuario_exports_source_version_id_fkey"
            columns: ["source_version_id"]
            isOneToOne: false
            referencedRelation: "prontuario_versoes"
            referencedColumns: ["id"]
          },
        ]
      }
      prontuario_versoes: {
        Row: {
          acao: string
          autor_id: string
          conteudo_snapshot: Json
          created_at: string
          hash_anterior: string | null
          hash_conteudo: string
          id: string
          ip: string | null
          metadata: Json
          prontuario_id: string
          tipo: string
          user_agent: string | null
        }
        Insert: {
          acao: string
          autor_id: string
          conteudo_snapshot: Json
          created_at?: string
          hash_anterior?: string | null
          hash_conteudo: string
          id?: string
          ip?: string | null
          metadata?: Json
          prontuario_id: string
          tipo: string
          user_agent?: string | null
        }
        Update: {
          acao?: string
          autor_id?: string
          conteudo_snapshot?: Json
          created_at?: string
          hash_anterior?: string | null
          hash_conteudo?: string
          id?: string
          ip?: string | null
          metadata?: Json
          prontuario_id?: string
          tipo?: string
          user_agent?: string | null
        }
        Relationships: [
          {
            foreignKeyName: "prontuario_versoes_prontuario_id_fkey"
            columns: ["prontuario_id"]
            isOneToOne: false
            referencedRelation: "prontuarios"
            referencedColumns: ["id"]
          },
        ]
      }
      prontuarios: {
        Row: {
          appointment_id: string | null
          clinic_id: string
          created_at: string
          created_by: string
          current_version_id: string | null
          id: string
          medical_record_id: string
          pet_id: string
        }
        Insert: {
          appointment_id?: string | null
          clinic_id: string
          created_at?: string
          created_by: string
          current_version_id?: string | null
          id?: string
          medical_record_id: string
          pet_id: string
        }
        Update: {
          appointment_id?: string | null
          clinic_id?: string
          created_at?: string
          created_by?: string
          current_version_id?: string | null
          id?: string
          medical_record_id?: string
          pet_id?: string
        }
        Relationships: [
          {
            foreignKeyName: "prontuarios_appointment_id_fkey"
            columns: ["appointment_id"]
            isOneToOne: false
            referencedRelation: "appointments"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "prontuarios_clinic_id_fkey"
            columns: ["clinic_id"]
            isOneToOne: false
            referencedRelation: "clinics"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "prontuarios_medical_record_id_fkey"
            columns: ["medical_record_id"]
            isOneToOne: true
            referencedRelation: "medical_records"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "prontuarios_pet_id_fkey"
            columns: ["pet_id"]
            isOneToOne: false
            referencedRelation: "pets"
            referencedColumns: ["id"]
          },
        ]
      }
      purchase_order_items: {
        Row: {
          batch_number: string | null
          created_at: string | null
          expiry_date: string | null
          id: string
          item_id: string | null
          po_id: string
          quantity: number
          received_quantity: number | null
          unit_cost: number
          variant_id: string | null
        }
        Insert: {
          batch_number?: string | null
          created_at?: string | null
          expiry_date?: string | null
          id?: string
          item_id?: string | null
          po_id: string
          quantity: number
          received_quantity?: number | null
          unit_cost: number
          variant_id?: string | null
        }
        Update: {
          batch_number?: string | null
          created_at?: string | null
          expiry_date?: string | null
          id?: string
          item_id?: string | null
          po_id?: string
          quantity?: number
          received_quantity?: number | null
          unit_cost?: number
          variant_id?: string | null
        }
        Relationships: [
          {
            foreignKeyName: "purchase_order_items_item_id_fkey"
            columns: ["item_id"]
            isOneToOne: false
            referencedRelation: "grooming_services_view"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "purchase_order_items_item_id_fkey"
            columns: ["item_id"]
            isOneToOne: false
            referencedRelation: "items"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "purchase_order_items_po_id_fkey"
            columns: ["po_id"]
            isOneToOne: false
            referencedRelation: "purchase_orders"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "purchase_order_items_variant_id_fkey"
            columns: ["variant_id"]
            isOneToOne: false
            referencedRelation: "item_variants"
            referencedColumns: ["id"]
          },
        ]
      }
      purchase_orders: {
        Row: {
          created_at: string | null
          created_by: string | null
          expected_date: string | null
          id: string
          location_id: string
          notes: string | null
          po_number: string
          received_date: string | null
          status: Database["public"]["Enums"]["po_status"] | null
          supplier_id: string
          total_cost: number | null
          updated_at: string | null
        }
        Insert: {
          created_at?: string | null
          created_by?: string | null
          expected_date?: string | null
          id?: string
          location_id: string
          notes?: string | null
          po_number: string
          received_date?: string | null
          status?: Database["public"]["Enums"]["po_status"] | null
          supplier_id: string
          total_cost?: number | null
          updated_at?: string | null
        }
        Update: {
          created_at?: string | null
          created_by?: string | null
          expected_date?: string | null
          id?: string
          location_id?: string
          notes?: string | null
          po_number?: string
          received_date?: string | null
          status?: Database["public"]["Enums"]["po_status"] | null
          supplier_id?: string
          total_cost?: number | null
          updated_at?: string | null
        }
        Relationships: [
          {
            foreignKeyName: "purchase_orders_location_id_fkey"
            columns: ["location_id"]
            isOneToOne: false
            referencedRelation: "stock_locations"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "purchase_orders_supplier_id_fkey"
            columns: ["supplier_id"]
            isOneToOne: false
            referencedRelation: "suppliers"
            referencedColumns: ["id"]
          },
        ]
      }
      recurrence: {
        Row: {
          active: boolean
          clinic_id: string
          created_at: string | null
          created_by_user_id: string
          deleted_at: string | null
          ends_on: string | null
          frequency: string
          id: string
          interval: number
          is_taxi_dog: boolean
          max_occurrences: number | null
          monthday: number | null
          notes: string | null
          owner_id: string
          starts_on: string
          taxi_dog_type: string | null
          timezone: string
          type: string
          updated_at: string | null
          vet_user_id: string | null
          weekdays: number[] | null
        }
        Insert: {
          active?: boolean
          clinic_id: string
          created_at?: string | null
          created_by_user_id: string
          deleted_at?: string | null
          ends_on?: string | null
          frequency: string
          id?: string
          interval?: number
          is_taxi_dog?: boolean
          max_occurrences?: number | null
          monthday?: number | null
          notes?: string | null
          owner_id: string
          starts_on: string
          taxi_dog_type?: string | null
          timezone?: string
          type: string
          updated_at?: string | null
          vet_user_id?: string | null
          weekdays?: number[] | null
        }
        Update: {
          active?: boolean
          clinic_id?: string
          created_at?: string | null
          created_by_user_id?: string
          deleted_at?: string | null
          ends_on?: string | null
          frequency?: string
          id?: string
          interval?: number
          is_taxi_dog?: boolean
          max_occurrences?: number | null
          monthday?: number | null
          notes?: string | null
          owner_id?: string
          starts_on?: string
          taxi_dog_type?: string | null
          timezone?: string
          type?: string
          updated_at?: string | null
          vet_user_id?: string | null
          weekdays?: number[] | null
        }
        Relationships: [
          {
            foreignKeyName: "recurrence_clinic_id_fkey"
            columns: ["clinic_id"]
            isOneToOne: false
            referencedRelation: "clinics"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "recurrence_created_by_user_id_fkey"
            columns: ["created_by_user_id"]
            isOneToOne: false
            referencedRelation: "profiles"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "recurrence_owner_id_fkey"
            columns: ["owner_id"]
            isOneToOne: false
            referencedRelation: "owners"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "recurrence_vet_user_id_fkey"
            columns: ["vet_user_id"]
            isOneToOne: false
            referencedRelation: "profiles"
            referencedColumns: ["id"]
          },
        ]
      }
      recurrence_items: {
        Row: {
          created_at: string | null
          id: string
          item_id: string | null
          qty: number
          recurrence_id: string
          sort_order: number
          title_snapshot: string
          updated_at: string | null
        }
        Insert: {
          created_at?: string | null
          id?: string
          item_id?: string | null
          qty?: number
          recurrence_id: string
          sort_order?: number
          title_snapshot?: string
          updated_at?: string | null
        }
        Update: {
          created_at?: string | null
          id?: string
          item_id?: string | null
          qty?: number
          recurrence_id?: string
          sort_order?: number
          title_snapshot?: string
          updated_at?: string | null
        }
        Relationships: [
          {
            foreignKeyName: "recurrence_items_item_id_fkey"
            columns: ["item_id"]
            isOneToOne: false
            referencedRelation: "grooming_services_view"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "recurrence_items_item_id_fkey"
            columns: ["item_id"]
            isOneToOne: false
            referencedRelation: "items"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "recurrence_items_recurrence_id_fkey"
            columns: ["recurrence_id"]
            isOneToOne: false
            referencedRelation: "recurrence"
            referencedColumns: ["id"]
          },
        ]
      }
      role_permission_templates: {
        Row: {
          can_create: boolean | null
          can_delete: boolean | null
          can_update: boolean | null
          can_view: boolean | null
          created_at: string | null
          customer_role_id: string
          feature_id: string
          id: string
          updated_at: string | null
        }
        Insert: {
          can_create?: boolean | null
          can_delete?: boolean | null
          can_update?: boolean | null
          can_view?: boolean | null
          created_at?: string | null
          customer_role_id: string
          feature_id: string
          id?: string
          updated_at?: string | null
        }
        Update: {
          can_create?: boolean | null
          can_delete?: boolean | null
          can_update?: boolean | null
          can_view?: boolean | null
          created_at?: string | null
          customer_role_id?: string
          feature_id?: string
          id?: string
          updated_at?: string | null
        }
        Relationships: [
          {
            foreignKeyName: "role_permission_templates_customer_role_id_fkey"
            columns: ["customer_role_id"]
            isOneToOne: false
            referencedRelation: "customer_roles"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "role_permission_templates_feature_id_fkey"
            columns: ["feature_id"]
            isOneToOne: false
            referencedRelation: "features"
            referencedColumns: ["id"]
          },
        ]
      }
      role_permission_templates_backup: {
        Row: {
          can_create: boolean | null
          can_delete: boolean | null
          can_update: boolean | null
          can_view: boolean | null
          created_at: string | null
          customer_role_id: string | null
          feature_id: string | null
          id: string | null
          updated_at: string | null
        }
        Insert: {
          can_create?: boolean | null
          can_delete?: boolean | null
          can_update?: boolean | null
          can_view?: boolean | null
          created_at?: string | null
          customer_role_id?: string | null
          feature_id?: string | null
          id?: string | null
          updated_at?: string | null
        }
        Update: {
          can_create?: boolean | null
          can_delete?: boolean | null
          can_update?: boolean | null
          can_view?: boolean | null
          created_at?: string | null
          customer_role_id?: string | null
          feature_id?: string | null
          id?: string | null
          updated_at?: string | null
        }
        Relationships: []
      }
      sale_items: {
        Row: {
          batch_number: string | null
          created_at: string | null
          discount_amount: number | null
          id: string
          item_id: string | null
          item_name: string
          line_total: number
          professional_id: string | null
          professional_name_snapshot: string | null
          quantity: number
          sale_id: string
          tax_amount: number | null
          unit_price: number
          variant_id: string | null
        }
        Insert: {
          batch_number?: string | null
          created_at?: string | null
          discount_amount?: number | null
          id?: string
          item_id?: string | null
          item_name: string
          line_total: number
          professional_id?: string | null
          professional_name_snapshot?: string | null
          quantity: number
          sale_id: string
          tax_amount?: number | null
          unit_price: number
          variant_id?: string | null
        }
        Update: {
          batch_number?: string | null
          created_at?: string | null
          discount_amount?: number | null
          id?: string
          item_id?: string | null
          item_name?: string
          line_total?: number
          professional_id?: string | null
          professional_name_snapshot?: string | null
          quantity?: number
          sale_id?: string
          tax_amount?: number | null
          unit_price?: number
          variant_id?: string | null
        }
        Relationships: [
          {
            foreignKeyName: "sale_items_item_id_fkey"
            columns: ["item_id"]
            isOneToOne: false
            referencedRelation: "grooming_services_view"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "sale_items_item_id_fkey"
            columns: ["item_id"]
            isOneToOne: false
            referencedRelation: "items"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "sale_items_sale_id_fkey"
            columns: ["sale_id"]
            isOneToOne: false
            referencedRelation: "sales"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "sale_items_variant_id_fkey"
            columns: ["variant_id"]
            isOneToOne: false
            referencedRelation: "item_variants"
            referencedColumns: ["id"]
          },
        ]
      }
      sale_payments: {
        Row: {
          amount: number
          created_at: string | null
          created_by: string | null
          id: string
          method: Database["public"]["Enums"]["payment_method"]
          received_at: string | null
          reference: string | null
          sale_id: string
        }
        Insert: {
          amount: number
          created_at?: string | null
          created_by?: string | null
          id?: string
          method: Database["public"]["Enums"]["payment_method"]
          received_at?: string | null
          reference?: string | null
          sale_id: string
        }
        Update: {
          amount?: number
          created_at?: string | null
          created_by?: string | null
          id?: string
          method?: Database["public"]["Enums"]["payment_method"]
          received_at?: string | null
          reference?: string | null
          sale_id?: string
        }
        Relationships: [
          {
            foreignKeyName: "sale_payments_sale_id_fkey"
            columns: ["sale_id"]
            isOneToOne: false
            referencedRelation: "sales"
            referencedColumns: ["id"]
          },
        ]
      }
      sale_return_items: {
        Row: {
          created_at: string
          id: string
          item_id: string
          item_name: string
          line_total: number
          quantity: number
          sale_item_id: string
          sale_return_id: string
          unit_price: number
        }
        Insert: {
          created_at?: string
          id?: string
          item_id: string
          item_name: string
          line_total?: number
          quantity: number
          sale_item_id: string
          sale_return_id: string
          unit_price?: number
        }
        Update: {
          created_at?: string
          id?: string
          item_id?: string
          item_name?: string
          line_total?: number
          quantity?: number
          sale_item_id?: string
          sale_return_id?: string
          unit_price?: number
        }
        Relationships: [
          {
            foreignKeyName: "sale_return_items_item_id_fkey"
            columns: ["item_id"]
            isOneToOne: false
            referencedRelation: "grooming_services_view"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "sale_return_items_item_id_fkey"
            columns: ["item_id"]
            isOneToOne: false
            referencedRelation: "items"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "sale_return_items_sale_item_id_fkey"
            columns: ["sale_item_id"]
            isOneToOne: false
            referencedRelation: "sale_items"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "sale_return_items_sale_return_id_fkey"
            columns: ["sale_return_id"]
            isOneToOne: false
            referencedRelation: "sale_returns"
            referencedColumns: ["id"]
          },
        ]
      }
      sale_returns: {
        Row: {
          clinic_id: string
          created_at: string
          created_by: string | null
          customer_id: string
          id: string
          reason: string
          sale_id: string
          status: string
          subtotal: number
          total: number
          updated_at: string
        }
        Insert: {
          clinic_id: string
          created_at?: string
          created_by?: string | null
          customer_id: string
          id?: string
          reason: string
          sale_id: string
          status?: string
          subtotal?: number
          total?: number
          updated_at?: string
        }
        Update: {
          clinic_id?: string
          created_at?: string
          created_by?: string | null
          customer_id?: string
          id?: string
          reason?: string
          sale_id?: string
          status?: string
          subtotal?: number
          total?: number
          updated_at?: string
        }
        Relationships: [
          {
            foreignKeyName: "sale_returns_clinic_id_fkey"
            columns: ["clinic_id"]
            isOneToOne: false
            referencedRelation: "clinics"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "sale_returns_customer_id_fkey"
            columns: ["customer_id"]
            isOneToOne: false
            referencedRelation: "customers"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "sale_returns_sale_id_fkey"
            columns: ["sale_id"]
            isOneToOne: false
            referencedRelation: "sales"
            referencedColumns: ["id"]
          },
        ]
      }
      sales: {
        Row: {
          appointment_id: string | null
          buyer_cpf: string | null
          clinic_id: string
          created_at: string | null
          created_by: string | null
          customer_id: string | null
          discount_amount: number | null
          discount_percentage: number | null
          id: string
          notes: string | null
          owner_id: string | null
          pet_id: string | null
          sale_number: string
          status: Database["public"]["Enums"]["sale_status"] | null
          stay_reservation_id: string | null
          subtotal: number | null
          tax_amount: number | null
          total: number | null
          updated_at: string | null
        }
        Insert: {
          appointment_id?: string | null
          buyer_cpf?: string | null
          clinic_id: string
          created_at?: string | null
          created_by?: string | null
          customer_id?: string | null
          discount_amount?: number | null
          discount_percentage?: number | null
          id?: string
          notes?: string | null
          owner_id?: string | null
          pet_id?: string | null
          sale_number: string
          status?: Database["public"]["Enums"]["sale_status"] | null
          stay_reservation_id?: string | null
          subtotal?: number | null
          tax_amount?: number | null
          total?: number | null
          updated_at?: string | null
        }
        Update: {
          appointment_id?: string | null
          buyer_cpf?: string | null
          clinic_id?: string
          created_at?: string | null
          created_by?: string | null
          customer_id?: string | null
          discount_amount?: number | null
          discount_percentage?: number | null
          id?: string
          notes?: string | null
          owner_id?: string | null
          pet_id?: string | null
          sale_number?: string
          status?: Database["public"]["Enums"]["sale_status"] | null
          stay_reservation_id?: string | null
          subtotal?: number | null
          tax_amount?: number | null
          total?: number | null
          updated_at?: string | null
        }
        Relationships: [
          {
            foreignKeyName: "sales_appointment_id_fkey"
            columns: ["appointment_id"]
            isOneToOne: false
            referencedRelation: "appointments"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "sales_clinic_id_fkey"
            columns: ["clinic_id"]
            isOneToOne: false
            referencedRelation: "clinics"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "sales_customer_id_fkey"
            columns: ["customer_id"]
            isOneToOne: false
            referencedRelation: "customers"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "sales_owner_id_fkey"
            columns: ["owner_id"]
            isOneToOne: false
            referencedRelation: "owners"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "sales_pet_id_fkey"
            columns: ["pet_id"]
            isOneToOne: false
            referencedRelation: "pets"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "sales_stay_reservation_id_fkey"
            columns: ["stay_reservation_id"]
            isOneToOne: false
            referencedRelation: "stay_reservations"
            referencedColumns: ["id"]
          },
        ]
      }
      service_groups: {
        Row: {
          created_at: string
          customer_id: string | null
          id: string
          name: string
          updated_at: string
        }
        Insert: {
          created_at?: string
          customer_id?: string | null
          id?: string
          name: string
          updated_at?: string
        }
        Update: {
          created_at?: string
          customer_id?: string | null
          id?: string
          name?: string
          updated_at?: string
        }
        Relationships: [
          {
            foreignKeyName: "service_groups_customer_id_fkey"
            columns: ["customer_id"]
            isOneToOne: false
            referencedRelation: "customers"
            referencedColumns: ["id"]
          },
        ]
      }
      service_price_history: {
        Row: {
          created_at: string | null
          id: string
          price: number
          service_id: string
          valid_from: string | null
        }
        Insert: {
          created_at?: string | null
          id?: string
          price: number
          service_id: string
          valid_from?: string | null
        }
        Update: {
          created_at?: string | null
          id?: string
          price?: number
          service_id?: string
          valid_from?: string | null
        }
        Relationships: [
          {
            foreignKeyName: "service_price_history_service_id_fkey"
            columns: ["service_id"]
            isOneToOne: false
            referencedRelation: "services"
            referencedColumns: ["id"]
          },
        ]
      }
      services: {
        Row: {
          base_price: number
          created_at: string | null
          customer_id: string
          description: string | null
          id: string
          is_active: boolean | null
          title: string
          type: string
          updated_at: string | null
          vaccine_item_id: string | null
        }
        Insert: {
          base_price: number
          created_at?: string | null
          customer_id: string
          description?: string | null
          id?: string
          is_active?: boolean | null
          title: string
          type: string
          updated_at?: string | null
          vaccine_item_id?: string | null
        }
        Update: {
          base_price?: number
          created_at?: string | null
          customer_id?: string
          description?: string | null
          id?: string
          is_active?: boolean | null
          title?: string
          type?: string
          updated_at?: string | null
          vaccine_item_id?: string | null
        }
        Relationships: [
          {
            foreignKeyName: "services_customer_id_fkey"
            columns: ["customer_id"]
            isOneToOne: false
            referencedRelation: "customers"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "services_vaccine_item_id_fkey"
            columns: ["vaccine_item_id"]
            isOneToOne: false
            referencedRelation: "grooming_services_view"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "services_vaccine_item_id_fkey"
            columns: ["vaccine_item_id"]
            isOneToOne: false
            referencedRelation: "items"
            referencedColumns: ["id"]
          },
        ]
      }
      species: {
        Row: {
          created_at: string | null
          id: string
          name: string
        }
        Insert: {
          created_at?: string | null
          id?: string
          name: string
        }
        Update: {
          created_at?: string | null
          id?: string
          name?: string
        }
        Relationships: []
      }
      states: {
        Row: {
          code: string
          created_at: string | null
          id: string
          name: string
        }
        Insert: {
          code: string
          created_at?: string | null
          id?: string
          name: string
        }
        Update: {
          code?: string
          created_at?: string | null
          id?: string
          name?: string
        }
        Relationships: []
      }
      stay_activities: {
        Row: {
          assigned_to: string | null
          clinic_id: string
          created_at: string
          description: string | null
          duration: string | null
          id: string
          is_active: boolean
          scheduled_date: string | null
          scheduled_time: string | null
          stay_activity_type_id: string
          target_pet_id: string | null
          target_stay_pack_id: string | null
          target_type: string
          updated_at: string
        }
        Insert: {
          assigned_to?: string | null
          clinic_id: string
          created_at?: string
          description?: string | null
          duration?: string | null
          id?: string
          is_active?: boolean
          scheduled_date?: string | null
          scheduled_time?: string | null
          stay_activity_type_id: string
          target_pet_id?: string | null
          target_stay_pack_id?: string | null
          target_type: string
          updated_at?: string
        }
        Update: {
          assigned_to?: string | null
          clinic_id?: string
          created_at?: string
          description?: string | null
          duration?: string | null
          id?: string
          is_active?: boolean
          scheduled_date?: string | null
          scheduled_time?: string | null
          stay_activity_type_id?: string
          target_pet_id?: string | null
          target_stay_pack_id?: string | null
          target_type?: string
          updated_at?: string
        }
        Relationships: [
          {
            foreignKeyName: "stay_activities_assigned_to_fkey"
            columns: ["assigned_to"]
            isOneToOne: false
            referencedRelation: "profiles"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "stay_activities_clinic_id_fkey"
            columns: ["clinic_id"]
            isOneToOne: false
            referencedRelation: "clinics"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "stay_activities_stay_activity_type_id_fkey"
            columns: ["stay_activity_type_id"]
            isOneToOne: false
            referencedRelation: "stay_activity_types"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "stay_activities_target_pet_id_fkey"
            columns: ["target_pet_id"]
            isOneToOne: false
            referencedRelation: "pets"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "stay_activities_target_stay_pack_id_fkey"
            columns: ["target_stay_pack_id"]
            isOneToOne: false
            referencedRelation: "stay_packs"
            referencedColumns: ["id"]
          },
        ]
      }
      stay_activity_completions: {
        Row: {
          completed_at: string
          completed_by: string | null
          completed_date: string
          id: string
          notes: string | null
          stay_activity_id: string
        }
        Insert: {
          completed_at?: string
          completed_by?: string | null
          completed_date: string
          id?: string
          notes?: string | null
          stay_activity_id: string
        }
        Update: {
          completed_at?: string
          completed_by?: string | null
          completed_date?: string
          id?: string
          notes?: string | null
          stay_activity_id?: string
        }
        Relationships: [
          {
            foreignKeyName: "stay_activity_completions_stay_activity_id_fkey"
            columns: ["stay_activity_id"]
            isOneToOne: false
            referencedRelation: "stay_activities"
            referencedColumns: ["id"]
          },
        ]
      }
      stay_activity_recurrence: {
        Row: {
          days_of_month: number[] | null
          days_of_week: number[] | null
          ends_on: string | null
          frequency: string
          id: string
          interval_days: number | null
          stay_activity_id: string
        }
        Insert: {
          days_of_month?: number[] | null
          days_of_week?: number[] | null
          ends_on?: string | null
          frequency: string
          id?: string
          interval_days?: number | null
          stay_activity_id: string
        }
        Update: {
          days_of_month?: number[] | null
          days_of_week?: number[] | null
          ends_on?: string | null
          frequency?: string
          id?: string
          interval_days?: number | null
          stay_activity_id?: string
        }
        Relationships: [
          {
            foreignKeyName: "stay_activity_recurrence_stay_activity_id_fkey"
            columns: ["stay_activity_id"]
            isOneToOne: true
            referencedRelation: "stay_activities"
            referencedColumns: ["id"]
          },
        ]
      }
      stay_activity_types: {
        Row: {
          clinic_id: string
          color: string | null
          created_at: string
          icon: string | null
          id: string
          is_active: boolean
          name: string
          sort_order: number
          updated_at: string
        }
        Insert: {
          clinic_id: string
          color?: string | null
          created_at?: string
          icon?: string | null
          id?: string
          is_active?: boolean
          name: string
          sort_order?: number
          updated_at?: string
        }
        Update: {
          clinic_id?: string
          color?: string | null
          created_at?: string
          icon?: string | null
          id?: string
          is_active?: boolean
          name?: string
          sort_order?: number
          updated_at?: string
        }
        Relationships: [
          {
            foreignKeyName: "stay_activity_types_clinic_id_fkey"
            columns: ["clinic_id"]
            isOneToOne: false
            referencedRelation: "clinics"
            referencedColumns: ["id"]
          },
        ]
      }
      stay_daily_rates: {
        Row: {
          clinic_id: string
          created_at: string
          daycare_daily_rate: number | null
          hotel_nightly_rate: number | null
          hotel_nightly_rate_with_daycare_plan: number | null
          id: string
          updated_at: string
        }
        Insert: {
          clinic_id: string
          created_at?: string
          daycare_daily_rate?: number | null
          hotel_nightly_rate?: number | null
          hotel_nightly_rate_with_daycare_plan?: number | null
          id?: string
          updated_at?: string
        }
        Update: {
          clinic_id?: string
          created_at?: string
          daycare_daily_rate?: number | null
          hotel_nightly_rate?: number | null
          hotel_nightly_rate_with_daycare_plan?: number | null
          id?: string
          updated_at?: string
        }
        Relationships: [
          {
            foreignKeyName: "stay_daily_rates_clinic_id_fkey"
            columns: ["clinic_id"]
            isOneToOne: true
            referencedRelation: "clinics"
            referencedColumns: ["id"]
          },
        ]
      }
      stay_incident_pets: {
        Row: {
          id: string
          pet_id: string
          role: string
          stay_reservation_daily_observation_id: string
        }
        Insert: {
          id?: string
          pet_id: string
          role: string
          stay_reservation_daily_observation_id: string
        }
        Update: {
          id?: string
          pet_id?: string
          role?: string
          stay_reservation_daily_observation_id?: string
        }
        Relationships: [
          {
            foreignKeyName: "stay_incident_pets_pet_id_fkey"
            columns: ["pet_id"]
            isOneToOne: false
            referencedRelation: "pets"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "stay_incident_pets_stay_reservation_daily_observation_id_fkey"
            columns: ["stay_reservation_daily_observation_id"]
            isOneToOne: false
            referencedRelation: "stay_reservation_daily_observations"
            referencedColumns: ["id"]
          },
        ]
      }
      stay_media_shares: {
        Row: {
          clinic_id: string
          created_at: string
          created_by: string | null
          id: string
          revoked_at: string | null
          stay_reservation_id: string
          token: string
          updated_at: string
        }
        Insert: {
          clinic_id: string
          created_at?: string
          created_by?: string | null
          id?: string
          revoked_at?: string | null
          stay_reservation_id: string
          token: string
          updated_at?: string
        }
        Update: {
          clinic_id?: string
          created_at?: string
          created_by?: string | null
          id?: string
          revoked_at?: string | null
          stay_reservation_id?: string
          token?: string
          updated_at?: string
        }
        Relationships: [
          {
            foreignKeyName: "stay_media_shares_clinic_id_fkey"
            columns: ["clinic_id"]
            isOneToOne: false
            referencedRelation: "clinics"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "stay_media_shares_stay_reservation_id_fkey"
            columns: ["stay_reservation_id"]
            isOneToOne: true
            referencedRelation: "stay_reservations"
            referencedColumns: ["id"]
          },
        ]
      }
      stay_pack_members: {
        Row: {
          added_at: string
          added_by: string | null
          id: string
          pet_id: string
          stay_pack_id: string
        }
        Insert: {
          added_at?: string
          added_by?: string | null
          id?: string
          pet_id: string
          stay_pack_id: string
        }
        Update: {
          added_at?: string
          added_by?: string | null
          id?: string
          pet_id?: string
          stay_pack_id?: string
        }
        Relationships: [
          {
            foreignKeyName: "stay_pack_members_pet_id_fkey"
            columns: ["pet_id"]
            isOneToOne: false
            referencedRelation: "pets"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "stay_pack_members_stay_pack_id_fkey"
            columns: ["stay_pack_id"]
            isOneToOne: false
            referencedRelation: "stay_packs"
            referencedColumns: ["id"]
          },
        ]
      }
      stay_pack_recurrence: {
        Row: {
          days_of_month: number[] | null
          days_of_week: number[] | null
          ends_on: string | null
          frequency: string
          id: string
          interval_days: number | null
          stay_pack_id: string
        }
        Insert: {
          days_of_month?: number[] | null
          days_of_week?: number[] | null
          ends_on?: string | null
          frequency: string
          id?: string
          interval_days?: number | null
          stay_pack_id: string
        }
        Update: {
          days_of_month?: number[] | null
          days_of_week?: number[] | null
          ends_on?: string | null
          frequency?: string
          id?: string
          interval_days?: number | null
          stay_pack_id?: string
        }
        Relationships: [
          {
            foreignKeyName: "stay_pack_recurrence_stay_pack_id_fkey"
            columns: ["stay_pack_id"]
            isOneToOne: true
            referencedRelation: "stay_packs"
            referencedColumns: ["id"]
          },
        ]
      }
      stay_package_config: {
        Row: {
          applies_to_module: string
          catalog_package_id: string
          created_at: string
          days_per_week: number | null
          id: string
          includes_overnight: boolean
          package_kind: string
          period: string | null
          size_restriction: string | null
          updated_at: string
        }
        Insert: {
          applies_to_module: string
          catalog_package_id: string
          created_at?: string
          days_per_week?: number | null
          id?: string
          includes_overnight?: boolean
          package_kind: string
          period?: string | null
          size_restriction?: string | null
          updated_at?: string
        }
        Update: {
          applies_to_module?: string
          catalog_package_id?: string
          created_at?: string
          days_per_week?: number | null
          id?: string
          includes_overnight?: boolean
          package_kind?: string
          period?: string | null
          size_restriction?: string | null
          updated_at?: string
        }
        Relationships: [
          {
            foreignKeyName: "stay_package_config_catalog_package_id_fkey"
            columns: ["catalog_package_id"]
            isOneToOne: true
            referencedRelation: "catalog_packages"
            referencedColumns: ["id"]
          },
        ]
      }
      stay_packs: {
        Row: {
          clinic_id: string
          color: string | null
          created_at: string
          id: string
          is_active: boolean
          name: string
          updated_at: string
        }
        Insert: {
          clinic_id: string
          color?: string | null
          created_at?: string
          id?: string
          is_active?: boolean
          name: string
          updated_at?: string
        }
        Update: {
          clinic_id?: string
          color?: string | null
          created_at?: string
          id?: string
          is_active?: boolean
          name?: string
          updated_at?: string
        }
        Relationships: [
          {
            foreignKeyName: "stay_packs_clinic_id_fkey"
            columns: ["clinic_id"]
            isOneToOne: false
            referencedRelation: "clinics"
            referencedColumns: ["id"]
          },
        ]
      }
      stay_pet_adaptations: {
        Row: {
          clinic_id: string
          created_at: string
          ends_at: string | null
          id: string
          is_active: boolean
          notes: string | null
          pet_id: string
          started_at: string
          updated_at: string
        }
        Insert: {
          clinic_id: string
          created_at?: string
          ends_at?: string | null
          id?: string
          is_active?: boolean
          notes?: string | null
          pet_id: string
          started_at: string
          updated_at?: string
        }
        Update: {
          clinic_id?: string
          created_at?: string
          ends_at?: string | null
          id?: string
          is_active?: boolean
          notes?: string | null
          pet_id?: string
          started_at?: string
          updated_at?: string
        }
        Relationships: [
          {
            foreignKeyName: "stay_pet_adaptations_clinic_id_fkey"
            columns: ["clinic_id"]
            isOneToOne: false
            referencedRelation: "clinics"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "stay_pet_adaptations_pet_id_fkey"
            columns: ["pet_id"]
            isOneToOne: false
            referencedRelation: "pets"
            referencedColumns: ["id"]
          },
        ]
      }
      stay_reservation_activities: {
        Row: {
          created_at: string
          created_by: string | null
          id: string
          stay_activity_id: string
          stay_reservation_id: string
        }
        Insert: {
          created_at?: string
          created_by?: string | null
          id?: string
          stay_activity_id: string
          stay_reservation_id: string
        }
        Update: {
          created_at?: string
          created_by?: string | null
          id?: string
          stay_activity_id?: string
          stay_reservation_id?: string
        }
        Relationships: [
          {
            foreignKeyName: "stay_reservation_activities_stay_activity_id_fkey"
            columns: ["stay_activity_id"]
            isOneToOne: false
            referencedRelation: "stay_activities"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "stay_reservation_activities_stay_reservation_id_fkey"
            columns: ["stay_reservation_id"]
            isOneToOne: false
            referencedRelation: "stay_reservations"
            referencedColumns: ["id"]
          },
        ]
      }
      stay_reservation_daily_observation_types: {
        Row: {
          clinic_id: string
          color: string | null
          created_at: string
          icon: string | null
          id: string
          is_active: boolean
          is_incident: boolean
          name: string
          sort_order: number
          updated_at: string
        }
        Insert: {
          clinic_id: string
          color?: string | null
          created_at?: string
          icon?: string | null
          id?: string
          is_active?: boolean
          is_incident?: boolean
          name: string
          sort_order?: number
          updated_at?: string
        }
        Update: {
          clinic_id?: string
          color?: string | null
          created_at?: string
          icon?: string | null
          id?: string
          is_active?: boolean
          is_incident?: boolean
          name?: string
          sort_order?: number
          updated_at?: string
        }
        Relationships: [
          {
            foreignKeyName: "stay_reservation_daily_observation_types_clinic_id_fkey"
            columns: ["clinic_id"]
            isOneToOne: false
            referencedRelation: "clinics"
            referencedColumns: ["id"]
          },
        ]
      }
      stay_reservation_daily_observations: {
        Row: {
          created_at: string
          created_by: string | null
          description: string | null
          id: string
          log_date: string
          logged_at: string | null
          stay_reservation_daily_observation_type_id: string
          stay_reservation_id: string
          updated_at: string
          updated_by: string | null
        }
        Insert: {
          created_at?: string
          created_by?: string | null
          description?: string | null
          id?: string
          log_date: string
          logged_at?: string | null
          stay_reservation_daily_observation_type_id: string
          stay_reservation_id: string
          updated_at?: string
          updated_by?: string | null
        }
        Update: {
          created_at?: string
          created_by?: string | null
          description?: string | null
          id?: string
          log_date?: string
          logged_at?: string | null
          stay_reservation_daily_observation_type_id?: string
          stay_reservation_id?: string
          updated_at?: string
          updated_by?: string | null
        }
        Relationships: [
          {
            foreignKeyName: "stay_reservation_daily_observ_stay_reservation_daily_obser_fkey"
            columns: ["stay_reservation_daily_observation_type_id"]
            isOneToOne: false
            referencedRelation: "stay_reservation_daily_observation_types"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "stay_reservation_daily_observations_stay_reservation_id_fkey"
            columns: ["stay_reservation_id"]
            isOneToOne: false
            referencedRelation: "stay_reservations"
            referencedColumns: ["id"]
          },
        ]
      }
      stay_reservation_daycare_plan_usages: {
        Row: {
          contract_id: string
          created_at: string
          id: string
          source: string
          stay_reservation_id: string
          units: number
          used_on: string
        }
        Insert: {
          contract_id: string
          created_at?: string
          id?: string
          source?: string
          stay_reservation_id: string
          units?: number
          used_on: string
        }
        Update: {
          contract_id?: string
          created_at?: string
          id?: string
          source?: string
          stay_reservation_id?: string
          units?: number
          used_on?: string
        }
        Relationships: [
          {
            foreignKeyName: "stay_reservation_daycare_plan_usages_contract_id_fkey"
            columns: ["contract_id"]
            isOneToOne: false
            referencedRelation: "daycare_plan_contracts"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "stay_reservation_daycare_plan_usages_stay_reservation_id_fkey"
            columns: ["stay_reservation_id"]
            isOneToOne: false
            referencedRelation: "stay_reservations"
            referencedColumns: ["id"]
          },
        ]
      }
      stay_reservation_days: {
        Row: {
          cancel_source: string | null
          check_in_time: string | null
          check_out_time: string | null
          clinic_id: string
          created_at: string
          created_by: string | null
          daily_charge_sale_item_id: string | null
          hotel_room_bed_id: string | null
          hotel_room_id: string | null
          id: string
          period: string | null
          pet_id: string
          plan_origin: string | null
          status: string
          stay_date: string
          stay_reservation_id: string
          updated_at: string
          updated_by: string | null
        }
        Insert: {
          cancel_source?: string | null
          check_in_time?: string | null
          check_out_time?: string | null
          clinic_id: string
          created_at?: string
          created_by?: string | null
          daily_charge_sale_item_id?: string | null
          hotel_room_bed_id?: string | null
          hotel_room_id?: string | null
          id?: string
          period?: string | null
          pet_id: string
          plan_origin?: string | null
          status?: string
          stay_date: string
          stay_reservation_id: string
          updated_at?: string
          updated_by?: string | null
        }
        Update: {
          cancel_source?: string | null
          check_in_time?: string | null
          check_out_time?: string | null
          clinic_id?: string
          created_at?: string
          created_by?: string | null
          daily_charge_sale_item_id?: string | null
          hotel_room_bed_id?: string | null
          hotel_room_id?: string | null
          id?: string
          period?: string | null
          pet_id?: string
          plan_origin?: string | null
          status?: string
          stay_date?: string
          stay_reservation_id?: string
          updated_at?: string
          updated_by?: string | null
        }
        Relationships: [
          {
            foreignKeyName: "stay_reservation_days_clinic_id_fkey"
            columns: ["clinic_id"]
            isOneToOne: false
            referencedRelation: "clinics"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "stay_reservation_days_daily_charge_sale_item_id_fkey"
            columns: ["daily_charge_sale_item_id"]
            isOneToOne: false
            referencedRelation: "sale_items"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "stay_reservation_days_hotel_room_bed_id_fkey"
            columns: ["hotel_room_bed_id"]
            isOneToOne: false
            referencedRelation: "hotel_room_beds"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "stay_reservation_days_hotel_room_id_fkey"
            columns: ["hotel_room_id"]
            isOneToOne: false
            referencedRelation: "hotel_rooms"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "stay_reservation_days_pet_id_fkey"
            columns: ["pet_id"]
            isOneToOne: false
            referencedRelation: "pets"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "stay_reservation_days_stay_reservation_id_fkey"
            columns: ["stay_reservation_id"]
            isOneToOne: false
            referencedRelation: "stay_reservations"
            referencedColumns: ["id"]
          },
        ]
      }
      stay_reservation_hotel_plan_usages: {
        Row: {
          contract_id: string
          created_at: string
          id: string
          source: string
          stay_reservation_id: string
          units: number
          used_on: string
        }
        Insert: {
          contract_id: string
          created_at?: string
          id?: string
          source?: string
          stay_reservation_id: string
          units?: number
          used_on: string
        }
        Update: {
          contract_id?: string
          created_at?: string
          id?: string
          source?: string
          stay_reservation_id?: string
          units?: number
          used_on?: string
        }
        Relationships: [
          {
            foreignKeyName: "stay_reservation_hotel_plan_usages_contract_id_fkey"
            columns: ["contract_id"]
            isOneToOne: false
            referencedRelation: "hotel_plan_contracts"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "stay_reservation_hotel_plan_usages_stay_reservation_id_fkey"
            columns: ["stay_reservation_id"]
            isOneToOne: false
            referencedRelation: "stay_reservations"
            referencedColumns: ["id"]
          },
        ]
      }
      stay_reservation_media: {
        Row: {
          created_at: string
          created_by: string | null
          description: string
          file_size: number
          id: string
          log_date: string
          logged_at: string
          media_kind: string
          mime_type: string
          pet_id: string
          stay_reservation_id: string
          storage_path: string
          updated_at: string
          updated_by: string | null
        }
        Insert: {
          created_at?: string
          created_by?: string | null
          description: string
          file_size: number
          id?: string
          log_date: string
          logged_at: string
          media_kind: string
          mime_type: string
          pet_id: string
          stay_reservation_id: string
          storage_path: string
          updated_at?: string
          updated_by?: string | null
        }
        Update: {
          created_at?: string
          created_by?: string | null
          description?: string
          file_size?: number
          id?: string
          log_date?: string
          logged_at?: string
          media_kind?: string
          mime_type?: string
          pet_id?: string
          stay_reservation_id?: string
          storage_path?: string
          updated_at?: string
          updated_by?: string | null
        }
        Relationships: [
          {
            foreignKeyName: "stay_reservation_media_pet_id_fkey"
            columns: ["pet_id"]
            isOneToOne: false
            referencedRelation: "pets"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "stay_reservation_media_stay_reservation_id_fkey"
            columns: ["stay_reservation_id"]
            isOneToOne: false
            referencedRelation: "stay_reservations"
            referencedColumns: ["id"]
          },
        ]
      }
      stay_reservation_packages: {
        Row: {
          billing_intent: string
          catalog_package_id: string | null
          clinic_id: string
          consumed_at: string | null
          consumption_status: Database["public"]["Enums"]["appointment_package_consumption_status"]
          created_at: string
          id: string
          mode: Database["public"]["Enums"]["appointment_package_mode"]
          patient_package_id: string | null
          pet_id: string
          sessions_to_consume: number
          stay_reservation_id: string
          suggested_charge_amount: number
          updated_at: string
        }
        Insert: {
          billing_intent?: string
          catalog_package_id?: string | null
          clinic_id: string
          consumed_at?: string | null
          consumption_status?: Database["public"]["Enums"]["appointment_package_consumption_status"]
          created_at?: string
          id?: string
          mode: Database["public"]["Enums"]["appointment_package_mode"]
          patient_package_id?: string | null
          pet_id: string
          sessions_to_consume?: number
          stay_reservation_id: string
          suggested_charge_amount?: number
          updated_at?: string
        }
        Update: {
          billing_intent?: string
          catalog_package_id?: string | null
          clinic_id?: string
          consumed_at?: string | null
          consumption_status?: Database["public"]["Enums"]["appointment_package_consumption_status"]
          created_at?: string
          id?: string
          mode?: Database["public"]["Enums"]["appointment_package_mode"]
          patient_package_id?: string | null
          pet_id?: string
          sessions_to_consume?: number
          stay_reservation_id?: string
          suggested_charge_amount?: number
          updated_at?: string
        }
        Relationships: [
          {
            foreignKeyName: "stay_reservation_packages_catalog_package_id_fkey"
            columns: ["catalog_package_id"]
            isOneToOne: false
            referencedRelation: "catalog_packages"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "stay_reservation_packages_clinic_id_fkey"
            columns: ["clinic_id"]
            isOneToOne: false
            referencedRelation: "clinics"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "stay_reservation_packages_patient_package_id_fkey"
            columns: ["patient_package_id"]
            isOneToOne: false
            referencedRelation: "patient_packages"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "stay_reservation_packages_pet_id_fkey"
            columns: ["pet_id"]
            isOneToOne: false
            referencedRelation: "pets"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "stay_reservation_packages_stay_reservation_id_fkey"
            columns: ["stay_reservation_id"]
            isOneToOne: false
            referencedRelation: "stay_reservations"
            referencedColumns: ["id"]
          },
        ]
      }
      stay_reservation_packs: {
        Row: {
          created_at: string
          id: string
          stay_pack_id: string
          stay_reservation_id: string
        }
        Insert: {
          created_at?: string
          id?: string
          stay_pack_id: string
          stay_reservation_id: string
        }
        Update: {
          created_at?: string
          id?: string
          stay_pack_id?: string
          stay_reservation_id?: string
        }
        Relationships: [
          {
            foreignKeyName: "stay_reservation_packs_stay_pack_id_fkey"
            columns: ["stay_pack_id"]
            isOneToOne: false
            referencedRelation: "stay_packs"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "stay_reservation_packs_stay_reservation_id_fkey"
            columns: ["stay_reservation_id"]
            isOneToOne: false
            referencedRelation: "stay_reservations"
            referencedColumns: ["id"]
          },
        ]
      }
      stay_reservation_photos: {
        Row: {
          arrived_injured: boolean
          created_at: string
          description: string | null
          id: string
          photo_type: string
          stay_reservation_id: string
          storage_path: string
          taken_by: string | null
        }
        Insert: {
          arrived_injured?: boolean
          created_at?: string
          description?: string | null
          id?: string
          photo_type: string
          stay_reservation_id: string
          storage_path: string
          taken_by?: string | null
        }
        Update: {
          arrived_injured?: boolean
          created_at?: string
          description?: string | null
          id?: string
          photo_type?: string
          stay_reservation_id?: string
          storage_path?: string
          taken_by?: string | null
        }
        Relationships: [
          {
            foreignKeyName: "stay_reservation_photos_stay_reservation_id_fkey"
            columns: ["stay_reservation_id"]
            isOneToOne: false
            referencedRelation: "stay_reservations"
            referencedColumns: ["id"]
          },
        ]
      }
      stay_reservation_recurrence: {
        Row: {
          days_of_month: number[] | null
          days_of_week: number[] | null
          ends_on: string | null
          frequency: string
          id: string
          interval_days: number | null
          stay_reservation_id: string
        }
        Insert: {
          days_of_month?: number[] | null
          days_of_week?: number[] | null
          ends_on?: string | null
          frequency: string
          id?: string
          interval_days?: number | null
          stay_reservation_id: string
        }
        Update: {
          days_of_month?: number[] | null
          days_of_week?: number[] | null
          ends_on?: string | null
          frequency?: string
          id?: string
          interval_days?: number | null
          stay_reservation_id?: string
        }
        Relationships: [
          {
            foreignKeyName: "stay_reservation_recurrence_stay_reservation_id_fkey"
            columns: ["stay_reservation_id"]
            isOneToOne: false
            referencedRelation: "stay_reservations"
            referencedColumns: ["id"]
          },
        ]
      }
      stay_reservations: {
        Row: {
          arrival_shift: string | null
          billing_timing: string | null
          check_in_date: string
          check_in_time: string | null
          check_out_date: string | null
          check_out_time: string | null
          clinic_id: string
          created_at: string
          created_by: string | null
          daycare_plan_contract_id: string | null
          departure_shift: string | null
          hotel_plan_contract_id: string | null
          hotel_room_bed_id: string | null
          hotel_room_id: string | null
          id: string
          is_overnight: boolean
          module_type: string
          period: string | null
          pet_id: string
          status: string
          stay_pack_id: string | null
          updated_at: string
        }
        Insert: {
          arrival_shift?: string | null
          billing_timing?: string | null
          check_in_date: string
          check_in_time?: string | null
          check_out_date?: string | null
          check_out_time?: string | null
          clinic_id: string
          created_at?: string
          created_by?: string | null
          daycare_plan_contract_id?: string | null
          departure_shift?: string | null
          hotel_plan_contract_id?: string | null
          hotel_room_bed_id?: string | null
          hotel_room_id?: string | null
          id?: string
          is_overnight?: boolean
          module_type: string
          period?: string | null
          pet_id: string
          status?: string
          stay_pack_id?: string | null
          updated_at?: string
        }
        Update: {
          arrival_shift?: string | null
          billing_timing?: string | null
          check_in_date?: string
          check_in_time?: string | null
          check_out_date?: string | null
          check_out_time?: string | null
          clinic_id?: string
          created_at?: string
          created_by?: string | null
          daycare_plan_contract_id?: string | null
          departure_shift?: string | null
          hotel_plan_contract_id?: string | null
          hotel_room_bed_id?: string | null
          hotel_room_id?: string | null
          id?: string
          is_overnight?: boolean
          module_type?: string
          period?: string | null
          pet_id?: string
          status?: string
          stay_pack_id?: string | null
          updated_at?: string
        }
        Relationships: [
          {
            foreignKeyName: "stay_reservations_clinic_id_fkey"
            columns: ["clinic_id"]
            isOneToOne: false
            referencedRelation: "clinics"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "stay_reservations_daycare_plan_contract_id_fkey"
            columns: ["daycare_plan_contract_id"]
            isOneToOne: false
            referencedRelation: "daycare_plan_contracts"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "stay_reservations_hotel_plan_contract_id_fkey"
            columns: ["hotel_plan_contract_id"]
            isOneToOne: false
            referencedRelation: "hotel_plan_contracts"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "stay_reservations_hotel_room_bed_id_fkey"
            columns: ["hotel_room_bed_id"]
            isOneToOne: false
            referencedRelation: "hotel_room_beds"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "stay_reservations_hotel_room_id_fkey"
            columns: ["hotel_room_id"]
            isOneToOne: false
            referencedRelation: "hotel_rooms"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "stay_reservations_pet_id_fkey"
            columns: ["pet_id"]
            isOneToOne: false
            referencedRelation: "pets"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "stay_reservations_stay_pack_id_fkey"
            columns: ["stay_pack_id"]
            isOneToOne: false
            referencedRelation: "stay_packs"
            referencedColumns: ["id"]
          },
        ]
      }
      stay_schedule_defaults: {
        Row: {
          clinic_id: string
          created_at: string
          daycare_check_in_from_time: string | null
          daycare_check_in_to_time: string | null
          daycare_check_out_from_time: string | null
          daycare_check_out_to_time: string | null
          daycare_evening_check_in_from_time: string | null
          daycare_evening_check_in_to_time: string | null
          daycare_evening_check_out_from_time: string | null
          daycare_evening_check_out_to_time: string | null
          daycare_shift_mode: string
          hotel_check_in_from_time: string | null
          hotel_check_in_to_time: string | null
          hotel_check_out_from_time: string | null
          hotel_check_out_to_time: string | null
          hotel_evening_check_in_from_time: string | null
          hotel_evening_check_in_to_time: string | null
          hotel_evening_check_out_from_time: string | null
          hotel_evening_check_out_to_time: string | null
          hotel_shift_mode: string
          id: string
          updated_at: string
        }
        Insert: {
          clinic_id: string
          created_at?: string
          daycare_check_in_from_time?: string | null
          daycare_check_in_to_time?: string | null
          daycare_check_out_from_time?: string | null
          daycare_check_out_to_time?: string | null
          daycare_evening_check_in_from_time?: string | null
          daycare_evening_check_in_to_time?: string | null
          daycare_evening_check_out_from_time?: string | null
          daycare_evening_check_out_to_time?: string | null
          daycare_shift_mode?: string
          hotel_check_in_from_time?: string | null
          hotel_check_in_to_time?: string | null
          hotel_check_out_from_time?: string | null
          hotel_check_out_to_time?: string | null
          hotel_evening_check_in_from_time?: string | null
          hotel_evening_check_in_to_time?: string | null
          hotel_evening_check_out_from_time?: string | null
          hotel_evening_check_out_to_time?: string | null
          hotel_shift_mode?: string
          id?: string
          updated_at?: string
        }
        Update: {
          clinic_id?: string
          created_at?: string
          daycare_check_in_from_time?: string | null
          daycare_check_in_to_time?: string | null
          daycare_check_out_from_time?: string | null
          daycare_check_out_to_time?: string | null
          daycare_evening_check_in_from_time?: string | null
          daycare_evening_check_in_to_time?: string | null
          daycare_evening_check_out_from_time?: string | null
          daycare_evening_check_out_to_time?: string | null
          daycare_shift_mode?: string
          hotel_check_in_from_time?: string | null
          hotel_check_in_to_time?: string | null
          hotel_check_out_from_time?: string | null
          hotel_check_out_to_time?: string | null
          hotel_evening_check_in_from_time?: string | null
          hotel_evening_check_in_to_time?: string | null
          hotel_evening_check_out_from_time?: string | null
          hotel_evening_check_out_to_time?: string | null
          hotel_shift_mode?: string
          id?: string
          updated_at?: string
        }
        Relationships: [
          {
            foreignKeyName: "stay_schedule_defaults_clinic_id_fkey"
            columns: ["clinic_id"]
            isOneToOne: true
            referencedRelation: "clinics"
            referencedColumns: ["id"]
          },
        ]
      }
      stock: {
        Row: {
          batch_number: string | null
          created_at: string | null
          expiry_date: string | null
          id: string
          item_id: string | null
          location_id: string
          min_quantity: number | null
          quantity: number
          reserved_quantity: number
          updated_at: string | null
          variant_id: string | null
        }
        Insert: {
          batch_number?: string | null
          created_at?: string | null
          expiry_date?: string | null
          id?: string
          item_id?: string | null
          location_id: string
          min_quantity?: number | null
          quantity?: number
          reserved_quantity?: number
          updated_at?: string | null
          variant_id?: string | null
        }
        Update: {
          batch_number?: string | null
          created_at?: string | null
          expiry_date?: string | null
          id?: string
          item_id?: string | null
          location_id?: string
          min_quantity?: number | null
          quantity?: number
          reserved_quantity?: number
          updated_at?: string | null
          variant_id?: string | null
        }
        Relationships: [
          {
            foreignKeyName: "stock_item_id_fkey"
            columns: ["item_id"]
            isOneToOne: false
            referencedRelation: "grooming_services_view"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "stock_item_id_fkey"
            columns: ["item_id"]
            isOneToOne: false
            referencedRelation: "items"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "stock_location_id_fkey"
            columns: ["location_id"]
            isOneToOne: false
            referencedRelation: "stock_locations"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "stock_variant_id_fkey"
            columns: ["variant_id"]
            isOneToOne: false
            referencedRelation: "item_variants"
            referencedColumns: ["id"]
          },
        ]
      }
      stock_balances: {
        Row: {
          batch_number: string | null
          expiry_date_text: string | null
          id: string
          item_id: string
          location_id: string
          quantity: number
          updated_at: string | null
        }
        Insert: {
          batch_number?: string | null
          expiry_date_text?: string | null
          id?: string
          item_id: string
          location_id: string
          quantity?: number
          updated_at?: string | null
        }
        Update: {
          batch_number?: string | null
          expiry_date_text?: string | null
          id?: string
          item_id?: string
          location_id?: string
          quantity?: number
          updated_at?: string | null
        }
        Relationships: [
          {
            foreignKeyName: "stock_balances_item_id_fkey"
            columns: ["item_id"]
            isOneToOne: false
            referencedRelation: "grooming_services_view"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "stock_balances_item_id_fkey"
            columns: ["item_id"]
            isOneToOne: false
            referencedRelation: "items"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "stock_balances_location_id_fkey"
            columns: ["location_id"]
            isOneToOne: false
            referencedRelation: "stock_locations"
            referencedColumns: ["id"]
          },
        ]
      }
      stock_locations: {
        Row: {
          clinic_id: string
          created_at: string | null
          id: string
          is_active: boolean | null
          is_main: boolean | null
          name: string
        }
        Insert: {
          clinic_id: string
          created_at?: string | null
          id?: string
          is_active?: boolean | null
          is_main?: boolean | null
          name: string
        }
        Update: {
          clinic_id?: string
          created_at?: string | null
          id?: string
          is_active?: boolean | null
          is_main?: boolean | null
          name?: string
        }
        Relationships: [
          {
            foreignKeyName: "stock_locations_clinic_id_fkey"
            columns: ["clinic_id"]
            isOneToOne: false
            referencedRelation: "clinics"
            referencedColumns: ["id"]
          },
        ]
      }
      stock_movements: {
        Row: {
          batch_number: string | null
          created_at: string | null
          created_by: string | null
          expiry_date: string | null
          from_location_id: string | null
          id: string
          item_id: string | null
          quantity: number
          reason: string | null
          reference_id: string | null
          reference_type: string | null
          to_location_id: string | null
          type: Database["public"]["Enums"]["movement_type"]
          unit_cost: number | null
          variant_id: string | null
        }
        Insert: {
          batch_number?: string | null
          created_at?: string | null
          created_by?: string | null
          expiry_date?: string | null
          from_location_id?: string | null
          id?: string
          item_id?: string | null
          quantity: number
          reason?: string | null
          reference_id?: string | null
          reference_type?: string | null
          to_location_id?: string | null
          type: Database["public"]["Enums"]["movement_type"]
          unit_cost?: number | null
          variant_id?: string | null
        }
        Update: {
          batch_number?: string | null
          created_at?: string | null
          created_by?: string | null
          expiry_date?: string | null
          from_location_id?: string | null
          id?: string
          item_id?: string | null
          quantity?: number
          reason?: string | null
          reference_id?: string | null
          reference_type?: string | null
          to_location_id?: string | null
          type?: Database["public"]["Enums"]["movement_type"]
          unit_cost?: number | null
          variant_id?: string | null
        }
        Relationships: [
          {
            foreignKeyName: "stock_movements_from_location_id_fkey"
            columns: ["from_location_id"]
            isOneToOne: false
            referencedRelation: "stock_locations"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "stock_movements_item_id_fkey"
            columns: ["item_id"]
            isOneToOne: false
            referencedRelation: "grooming_services_view"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "stock_movements_item_id_fkey"
            columns: ["item_id"]
            isOneToOne: false
            referencedRelation: "items"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "stock_movements_to_location_id_fkey"
            columns: ["to_location_id"]
            isOneToOne: false
            referencedRelation: "stock_locations"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "stock_movements_variant_id_fkey"
            columns: ["variant_id"]
            isOneToOne: false
            referencedRelation: "item_variants"
            referencedColumns: ["id"]
          },
        ]
      }
      suppliers: {
        Row: {
          address: string | null
          created_at: string | null
          document: string | null
          email: string | null
          id: string
          is_active: boolean | null
          name: string
          notes: string | null
          phone: string | null
          updated_at: string | null
        }
        Insert: {
          address?: string | null
          created_at?: string | null
          document?: string | null
          email?: string | null
          id?: string
          is_active?: boolean | null
          name: string
          notes?: string | null
          phone?: string | null
          updated_at?: string | null
        }
        Update: {
          address?: string | null
          created_at?: string | null
          document?: string | null
          email?: string | null
          id?: string
          is_active?: boolean | null
          name?: string
          notes?: string | null
          phone?: string | null
          updated_at?: string | null
        }
        Relationships: []
      }
      team_member_commission_item_overrides: {
        Row: {
          id: string
          item_id: string
          percent: number
          team_member_id: string
        }
        Insert: {
          id?: string
          item_id: string
          percent: number
          team_member_id: string
        }
        Update: {
          id?: string
          item_id?: string
          percent?: number
          team_member_id?: string
        }
        Relationships: [
          {
            foreignKeyName: "team_member_commission_item_overrides_item_id_fkey"
            columns: ["item_id"]
            isOneToOne: false
            referencedRelation: "grooming_services_view"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "team_member_commission_item_overrides_item_id_fkey"
            columns: ["item_id"]
            isOneToOne: false
            referencedRelation: "items"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "team_member_commission_item_overrides_team_member_id_fkey"
            columns: ["team_member_id"]
            isOneToOne: false
            referencedRelation: "clinic_team_members"
            referencedColumns: ["id"]
          },
        ]
      }
      team_member_commission_overrides: {
        Row: {
          id: string
          package_subtype_id: string | null
          percent: number
          product_subtype_id: string | null
          service_group_id: string | null
          team_member_id: string
        }
        Insert: {
          id?: string
          package_subtype_id?: string | null
          percent: number
          product_subtype_id?: string | null
          service_group_id?: string | null
          team_member_id: string
        }
        Update: {
          id?: string
          package_subtype_id?: string | null
          percent?: number
          product_subtype_id?: string | null
          service_group_id?: string | null
          team_member_id?: string
        }
        Relationships: [
          {
            foreignKeyName: "team_member_commission_overrides_package_subtype_id_fkey"
            columns: ["package_subtype_id"]
            isOneToOne: false
            referencedRelation: "package_subtypes"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "team_member_commission_overrides_product_subtype_id_fkey"
            columns: ["product_subtype_id"]
            isOneToOne: false
            referencedRelation: "product_subtypes"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "team_member_commission_overrides_service_group_id_fkey"
            columns: ["service_group_id"]
            isOneToOne: false
            referencedRelation: "service_groups"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "team_member_commission_overrides_team_member_id_fkey"
            columns: ["team_member_id"]
            isOneToOne: false
            referencedRelation: "clinic_team_members"
            referencedColumns: ["id"]
          },
        ]
      }
      term_signatories: {
        Row: {
          created_at: string
          id: string
          method: string
          order_index: number
          request_id: string
          role: string
          signed_at: string | null
          signer_cpf: string | null
          signer_crmv: string | null
          signer_email: string | null
          signer_mapa: string | null
          signer_name: string | null
          signer_user_id: string | null
          status: string
          token_expires_at: string | null
          token_hash: string | null
        }
        Insert: {
          created_at?: string
          id?: string
          method: string
          order_index?: number
          request_id: string
          role: string
          signed_at?: string | null
          signer_cpf?: string | null
          signer_crmv?: string | null
          signer_email?: string | null
          signer_mapa?: string | null
          signer_name?: string | null
          signer_user_id?: string | null
          status?: string
          token_expires_at?: string | null
          token_hash?: string | null
        }
        Update: {
          created_at?: string
          id?: string
          method?: string
          order_index?: number
          request_id?: string
          role?: string
          signed_at?: string | null
          signer_cpf?: string | null
          signer_crmv?: string | null
          signer_email?: string | null
          signer_mapa?: string | null
          signer_name?: string | null
          signer_user_id?: string | null
          status?: string
          token_expires_at?: string | null
          token_hash?: string | null
        }
        Relationships: [
          {
            foreignKeyName: "term_signatories_request_id_fkey"
            columns: ["request_id"]
            isOneToOne: false
            referencedRelation: "term_signature_requests"
            referencedColumns: ["id"]
          },
        ]
      }
      term_signature_events: {
        Row: {
          created_at: string
          event_type: string
          id: string
          ip: string | null
          metadata_json: Json
          request_id: string
          signatory_id: string | null
          user_agent: string | null
        }
        Insert: {
          created_at?: string
          event_type: string
          id?: string
          ip?: string | null
          metadata_json?: Json
          request_id: string
          signatory_id?: string | null
          user_agent?: string | null
        }
        Update: {
          created_at?: string
          event_type?: string
          id?: string
          ip?: string | null
          metadata_json?: Json
          request_id?: string
          signatory_id?: string | null
          user_agent?: string | null
        }
        Relationships: [
          {
            foreignKeyName: "term_signature_events_request_id_fkey"
            columns: ["request_id"]
            isOneToOne: false
            referencedRelation: "term_signature_requests"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "term_signature_events_signatory_id_fkey"
            columns: ["signatory_id"]
            isOneToOne: false
            referencedRelation: "term_signatories"
            referencedColumns: ["id"]
          },
        ]
      }
      term_signature_otps: {
        Row: {
          attempts: number
          channel: string
          code_hash: string
          consumed_at: string | null
          expires_at: string
          id: string
          sent_at: string
          signatory_id: string
        }
        Insert: {
          attempts?: number
          channel?: string
          code_hash: string
          consumed_at?: string | null
          expires_at: string
          id?: string
          sent_at?: string
          signatory_id: string
        }
        Update: {
          attempts?: number
          channel?: string
          code_hash?: string
          consumed_at?: string | null
          expires_at?: string
          id?: string
          sent_at?: string
          signatory_id?: string
        }
        Relationships: [
          {
            foreignKeyName: "term_signature_otps_signatory_id_fkey"
            columns: ["signatory_id"]
            isOneToOne: false
            referencedRelation: "term_signatories"
            referencedColumns: ["id"]
          },
        ]
      }
      term_signature_requests: {
        Row: {
          access_code: string | null
          clinic_id: string
          completed_at: string | null
          created_at: string
          created_by: string
          id: string
          original_pdf_sha256: string | null
          patient_term_id: string
          signed_pdf_sha256: string | null
          signed_storage_bucket: string | null
          signed_storage_path: string | null
          status: string
          updated_at: string
        }
        Insert: {
          access_code?: string | null
          clinic_id: string
          completed_at?: string | null
          created_at?: string
          created_by: string
          id?: string
          original_pdf_sha256?: string | null
          patient_term_id: string
          signed_pdf_sha256?: string | null
          signed_storage_bucket?: string | null
          signed_storage_path?: string | null
          status?: string
          updated_at?: string
        }
        Update: {
          access_code?: string | null
          clinic_id?: string
          completed_at?: string | null
          created_at?: string
          created_by?: string
          id?: string
          original_pdf_sha256?: string | null
          patient_term_id?: string
          signed_pdf_sha256?: string | null
          signed_storage_bucket?: string | null
          signed_storage_path?: string | null
          status?: string
          updated_at?: string
        }
        Relationships: [
          {
            foreignKeyName: "term_signature_requests_patient_term_id_fkey"
            columns: ["patient_term_id"]
            isOneToOne: false
            referencedRelation: "patient_terms"
            referencedColumns: ["id"]
          },
        ]
      }
      user_a1_certificates: {
        Row: {
          created_at: string
          encrypted_password: string
          id: string
          original_filename: string | null
          storage_bucket: string
          storage_path: string
          updated_at: string
          uploaded_at: string
          user_id: string
        }
        Insert: {
          created_at?: string
          encrypted_password: string
          id?: string
          original_filename?: string | null
          storage_bucket?: string
          storage_path: string
          updated_at?: string
          uploaded_at?: string
          user_id: string
        }
        Update: {
          created_at?: string
          encrypted_password?: string
          id?: string
          original_filename?: string | null
          storage_bucket?: string
          storage_path?: string
          updated_at?: string
          uploaded_at?: string
          user_id?: string
        }
        Relationships: []
      }
      user_clinic_access: {
        Row: {
          clinic_id: string
          created_at: string | null
          customer_role_id: string
          is_groomer: boolean
          is_veterinarian: boolean
          role_source: string
          user_id: string
        }
        Insert: {
          clinic_id: string
          created_at?: string | null
          customer_role_id: string
          is_groomer?: boolean
          is_veterinarian?: boolean
          role_source?: string
          user_id: string
        }
        Update: {
          clinic_id?: string
          created_at?: string | null
          customer_role_id?: string
          is_groomer?: boolean
          is_veterinarian?: boolean
          role_source?: string
          user_id?: string
        }
        Relationships: [
          {
            foreignKeyName: "user_clinic_access_clinic_id_fkey"
            columns: ["clinic_id"]
            isOneToOne: false
            referencedRelation: "clinics"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "user_clinic_access_customer_role_id_fkey"
            columns: ["customer_role_id"]
            isOneToOne: false
            referencedRelation: "customer_roles"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "user_clinic_access_user_id_fkey"
            columns: ["user_id"]
            isOneToOne: false
            referencedRelation: "profiles"
            referencedColumns: ["id"]
          },
        ]
      }
      user_customer_access: {
        Row: {
          created_at: string | null
          customer_id: string
          customer_role_id: string
          id: string
          is_groomer: boolean
          is_veterinarian: boolean
          updated_at: string | null
          user_id: string
        }
        Insert: {
          created_at?: string | null
          customer_id: string
          customer_role_id: string
          id?: string
          is_groomer?: boolean
          is_veterinarian?: boolean
          updated_at?: string | null
          user_id: string
        }
        Update: {
          created_at?: string | null
          customer_id?: string
          customer_role_id?: string
          id?: string
          is_groomer?: boolean
          is_veterinarian?: boolean
          updated_at?: string | null
          user_id?: string
        }
        Relationships: [
          {
            foreignKeyName: "user_customer_access_customer_id_fkey"
            columns: ["customer_id"]
            isOneToOne: false
            referencedRelation: "customers"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "user_customer_access_customer_role_id_fkey"
            columns: ["customer_role_id"]
            isOneToOne: false
            referencedRelation: "customer_roles"
            referencedColumns: ["id"]
          },
        ]
      }
      user_invites: {
        Row: {
          accepted_at: string | null
          cancelled_at: string | null
          clinic_id: string
          clinic_ids: Json | null
          created_at: string | null
          customer_id: string
          email: string
          expires_at: string
          id: string
          invited_by: string
          resent_count: number | null
          role: string
          token: string
          updated_at: string | null
        }
        Insert: {
          accepted_at?: string | null
          cancelled_at?: string | null
          clinic_id: string
          clinic_ids?: Json | null
          created_at?: string | null
          customer_id: string
          email: string
          expires_at: string
          id?: string
          invited_by: string
          resent_count?: number | null
          role?: string
          token: string
          updated_at?: string | null
        }
        Update: {
          accepted_at?: string | null
          cancelled_at?: string | null
          clinic_id?: string
          clinic_ids?: Json | null
          created_at?: string | null
          customer_id?: string
          email?: string
          expires_at?: string
          id?: string
          invited_by?: string
          resent_count?: number | null
          role?: string
          token?: string
          updated_at?: string | null
        }
        Relationships: [
          {
            foreignKeyName: "user_invites_clinic_id_fkey"
            columns: ["clinic_id"]
            isOneToOne: false
            referencedRelation: "clinics"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "user_invites_customer_id_fkey"
            columns: ["customer_id"]
            isOneToOne: false
            referencedRelation: "customers"
            referencedColumns: ["id"]
          },
        ]
      }
      vet_availability: {
        Row: {
          clinic_id: string
          created_at: string | null
          effective_from: string | null
          effective_to: string | null
          end_time: string
          id: string
          start_time: string
          updated_at: string | null
          vet_user_id: string
          weekday: number
        }
        Insert: {
          clinic_id: string
          created_at?: string | null
          effective_from?: string | null
          effective_to?: string | null
          end_time: string
          id?: string
          start_time: string
          updated_at?: string | null
          vet_user_id: string
          weekday: number
        }
        Update: {
          clinic_id?: string
          created_at?: string | null
          effective_from?: string | null
          effective_to?: string | null
          end_time?: string
          id?: string
          start_time?: string
          updated_at?: string | null
          vet_user_id?: string
          weekday?: number
        }
        Relationships: [
          {
            foreignKeyName: "vet_availability_clinic_id_fkey"
            columns: ["clinic_id"]
            isOneToOne: false
            referencedRelation: "clinics"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "vet_availability_vet_user_id_fkey"
            columns: ["vet_user_id"]
            isOneToOne: false
            referencedRelation: "profiles"
            referencedColumns: ["id"]
          },
        ]
      }
      vet_mapa_prescription_allocations: {
        Row: {
          allocated_at: string
          formatted_number: string
          id: string
          mapa_registration: string
          prescription_id: string
          sequence_value: number
          vet_user_id: string
          year_suffix: string
        }
        Insert: {
          allocated_at?: string
          formatted_number: string
          id?: string
          mapa_registration: string
          prescription_id: string
          sequence_value: number
          vet_user_id: string
          year_suffix: string
        }
        Update: {
          allocated_at?: string
          formatted_number?: string
          id?: string
          mapa_registration?: string
          prescription_id?: string
          sequence_value?: number
          vet_user_id?: string
          year_suffix?: string
        }
        Relationships: [
          {
            foreignKeyName: "vet_mapa_prescription_allocations_prescription_id_fkey"
            columns: ["prescription_id"]
            isOneToOne: true
            referencedRelation: "medical_prescriptions"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "vet_mapa_prescription_allocations_vet_user_id_fkey"
            columns: ["vet_user_id"]
            isOneToOne: false
            referencedRelation: "profiles"
            referencedColumns: ["id"]
          },
        ]
      }
      vet_mapa_prescription_sequence_log: {
        Row: {
          changed_by: string
          created_at: string
          id: string
          new_value: number
          old_value: number
          reason: string
          vet_user_id: string
        }
        Insert: {
          changed_by: string
          created_at?: string
          id?: string
          new_value: number
          old_value: number
          reason: string
          vet_user_id: string
        }
        Update: {
          changed_by?: string
          created_at?: string
          id?: string
          new_value?: number
          old_value?: number
          reason?: string
          vet_user_id?: string
        }
        Relationships: [
          {
            foreignKeyName: "vet_mapa_prescription_sequence_log_changed_by_fkey"
            columns: ["changed_by"]
            isOneToOne: false
            referencedRelation: "profiles"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "vet_mapa_prescription_sequence_log_vet_user_id_fkey"
            columns: ["vet_user_id"]
            isOneToOne: false
            referencedRelation: "profiles"
            referencedColumns: ["id"]
          },
        ]
      }
      vet_mapa_prescription_sequences: {
        Row: {
          created_at: string
          current_value: number
          updated_at: string
          vet_user_id: string
        }
        Insert: {
          created_at?: string
          current_value?: number
          updated_at?: string
          vet_user_id: string
        }
        Update: {
          created_at?: string
          current_value?: number
          updated_at?: string
          vet_user_id?: string
        }
        Relationships: [
          {
            foreignKeyName: "vet_mapa_prescription_sequences_vet_user_id_fkey"
            columns: ["vet_user_id"]
            isOneToOne: true
            referencedRelation: "profiles"
            referencedColumns: ["id"]
          },
        ]
      }
      vet_mapa_sequence_migration_conflicts: {
        Row: {
          detected_at: string
          id: string
          prescription_ids: string[]
          sequence_value: number
          vet_user_id: string
        }
        Insert: {
          detected_at?: string
          id?: string
          prescription_ids: string[]
          sequence_value: number
          vet_user_id: string
        }
        Update: {
          detected_at?: string
          id?: string
          prescription_ids?: string[]
          sequence_value?: number
          vet_user_id?: string
        }
        Relationships: [
          {
            foreignKeyName: "vet_mapa_sequence_migration_conflicts_vet_user_id_fkey"
            columns: ["vet_user_id"]
            isOneToOne: false
            referencedRelation: "profiles"
            referencedColumns: ["id"]
          },
        ]
      }
      vet_prescription_counter_log: {
        Row: {
          changed_by: string
          counter_id: string
          created_at: string
          id: string
          new_value: number
          old_value: number
          reason: string | null
        }
        Insert: {
          changed_by: string
          counter_id: string
          created_at?: string
          id?: string
          new_value: number
          old_value: number
          reason?: string | null
        }
        Update: {
          changed_by?: string
          counter_id?: string
          created_at?: string
          id?: string
          new_value?: number
          old_value?: number
          reason?: string | null
        }
        Relationships: [
          {
            foreignKeyName: "vet_prescription_counter_log_changed_by_fkey"
            columns: ["changed_by"]
            isOneToOne: false
            referencedRelation: "profiles"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "vet_prescription_counter_log_counter_id_fkey"
            columns: ["counter_id"]
            isOneToOne: false
            referencedRelation: "vet_prescription_counters"
            referencedColumns: ["id"]
          },
        ]
      }
      vet_prescription_counters: {
        Row: {
          created_at: string
          current_value: number
          customer_id: string
          id: string
          updated_at: string
          vet_user_id: string
        }
        Insert: {
          created_at?: string
          current_value?: number
          customer_id: string
          id?: string
          updated_at?: string
          vet_user_id: string
        }
        Update: {
          created_at?: string
          current_value?: number
          customer_id?: string
          id?: string
          updated_at?: string
          vet_user_id?: string
        }
        Relationships: [
          {
            foreignKeyName: "vet_prescription_counters_vet_user_id_fkey"
            columns: ["vet_user_id"]
            isOneToOne: false
            referencedRelation: "profiles"
            referencedColumns: ["id"]
          },
        ]
      }
      whatsapp_application_reminder_dispatches: {
        Row: {
          clinic_id: string
          created_at: string
          due_date: string
          error_message: string | null
          id: string
          pet_application_id: string | null
          pet_application_plan_id: string | null
          scheduled_send_at: string
          sent_at: string | null
          status: string
          updated_at: string
        }
        Insert: {
          clinic_id: string
          created_at?: string
          due_date: string
          error_message?: string | null
          id?: string
          pet_application_id?: string | null
          pet_application_plan_id?: string | null
          scheduled_send_at: string
          sent_at?: string | null
          status?: string
          updated_at?: string
        }
        Update: {
          clinic_id?: string
          created_at?: string
          due_date?: string
          error_message?: string | null
          id?: string
          pet_application_id?: string | null
          pet_application_plan_id?: string | null
          scheduled_send_at?: string
          sent_at?: string | null
          status?: string
          updated_at?: string
        }
        Relationships: [
          {
            foreignKeyName: "whatsapp_application_reminder_disp_pet_application_plan_id_fkey"
            columns: ["pet_application_plan_id"]
            isOneToOne: false
            referencedRelation: "pet_application_plans"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "whatsapp_application_reminder_dispatches_pet_application_id_fke"
            columns: ["pet_application_id"]
            isOneToOne: false
            referencedRelation: "pet_applications"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "whatsapp_vaccine_reminder_dispatches_clinic_id_fkey"
            columns: ["clinic_id"]
            isOneToOne: false
            referencedRelation: "clinics"
            referencedColumns: ["id"]
          },
        ]
      }
      whatsapp_message_events: {
        Row: {
          clinic_id: string
          created_at: string
          event_type: string
          id: string
          occurred_at: string | null
          owner_id: string | null
          phone_number_id: string | null
          raw_payload: Json | null
          status: string | null
          wamid: string | null
        }
        Insert: {
          clinic_id: string
          created_at?: string
          event_type: string
          id?: string
          occurred_at?: string | null
          owner_id?: string | null
          phone_number_id?: string | null
          raw_payload?: Json | null
          status?: string | null
          wamid?: string | null
        }
        Update: {
          clinic_id?: string
          created_at?: string
          event_type?: string
          id?: string
          occurred_at?: string | null
          owner_id?: string | null
          phone_number_id?: string | null
          raw_payload?: Json | null
          status?: string | null
          wamid?: string | null
        }
        Relationships: [
          {
            foreignKeyName: "whatsapp_message_events_clinic_id_fkey"
            columns: ["clinic_id"]
            isOneToOne: false
            referencedRelation: "clinics"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "whatsapp_message_events_owner_id_fkey"
            columns: ["owner_id"]
            isOneToOne: false
            referencedRelation: "owners"
            referencedColumns: ["id"]
          },
        ]
      }
      whatsapp_message_templates: {
        Row: {
          body_text: string
          buttons: Json | null
          category: string
          clinic_id: string
          created_at: string
          created_by: string | null
          deleted_at: string | null
          footer_text: string | null
          header_media_url: string | null
          header_text: string | null
          header_type: string | null
          id: string
          language: string
          meta_rejection_reason: string | null
          meta_status: string
          meta_submitted_at: string | null
          meta_synced_at: string | null
          meta_template_id: string | null
          name: string
          updated_at: string
          updated_by: string | null
          variable_mapping: Json
        }
        Insert: {
          body_text: string
          buttons?: Json | null
          category: string
          clinic_id: string
          created_at?: string
          created_by?: string | null
          deleted_at?: string | null
          footer_text?: string | null
          header_media_url?: string | null
          header_text?: string | null
          header_type?: string | null
          id?: string
          language?: string
          meta_rejection_reason?: string | null
          meta_status?: string
          meta_submitted_at?: string | null
          meta_synced_at?: string | null
          meta_template_id?: string | null
          name: string
          updated_at?: string
          updated_by?: string | null
          variable_mapping?: Json
        }
        Update: {
          body_text?: string
          buttons?: Json | null
          category?: string
          clinic_id?: string
          created_at?: string
          created_by?: string | null
          deleted_at?: string | null
          footer_text?: string | null
          header_media_url?: string | null
          header_text?: string | null
          header_type?: string | null
          id?: string
          language?: string
          meta_rejection_reason?: string | null
          meta_status?: string
          meta_submitted_at?: string | null
          meta_synced_at?: string | null
          meta_template_id?: string | null
          name?: string
          updated_at?: string
          updated_by?: string | null
          variable_mapping?: Json
        }
        Relationships: [
          {
            foreignKeyName: "whatsapp_message_templates_clinic_id_fkey"
            columns: ["clinic_id"]
            isOneToOne: false
            referencedRelation: "clinics"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "whatsapp_message_templates_created_by_fkey"
            columns: ["created_by"]
            isOneToOne: false
            referencedRelation: "profiles"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "whatsapp_message_templates_updated_by_fkey"
            columns: ["updated_by"]
            isOneToOne: false
            referencedRelation: "profiles"
            referencedColumns: ["id"]
          },
        ]
      }
    }
    Views: {
      audit_permissions_view: {
        Row: {
          action: string | null
          changed_fields: string[] | null
          created_at: string | null
          feature_id: string | null
          id: string | null
          new_values: Json | null
          old_values: Json | null
          record_id: string | null
          table_name: string | null
          target_user_id: string | null
          user_id: string | null
          user_name: string | null
        }
        Relationships: []
      }
      audit_recent_view: {
        Row: {
          action: string | null
          changed_fields: string[] | null
          created_at: string | null
          id: string | null
          num_fields_changed: number | null
          record_id: string | null
          table_name: string | null
          user_id: string | null
          user_name: string | null
        }
        Relationships: []
      }
      grooming_services_view: {
        Row: {
          base_price: number | null
          created_at: string | null
          customer_id: string | null
          description: string | null
          id: string | null
          is_active: boolean | null
          title: string | null
          type: string | null
          updated_at: string | null
        }
        Insert: {
          base_price?: number | null
          created_at?: string | null
          customer_id?: string | null
          description?: string | null
          id?: string | null
          is_active?: boolean | null
          title?: string | null
          type?: never
          updated_at?: string | null
        }
        Update: {
          base_price?: number | null
          created_at?: string | null
          customer_id?: string | null
          description?: string | null
          id?: string | null
          is_active?: boolean | null
          title?: string | null
          type?: never
          updated_at?: string | null
        }
        Relationships: [
          {
            foreignKeyName: "items_customer_id_fkey"
            columns: ["customer_id"]
            isOneToOne: false
            referencedRelation: "customers"
            referencedColumns: ["id"]
          },
        ]
      }
      vw_whatsapp_failures_by_reason: {
        Row: {
          clinic_id: string | null
          created_at: string | null
          raw_payload: Json | null
          reason: string | null
          wamid: string | null
        }
        Insert: {
          clinic_id?: string | null
          created_at?: string | null
          raw_payload?: Json | null
          reason?: never
          wamid?: string | null
        }
        Update: {
          clinic_id?: string | null
          created_at?: string | null
          raw_payload?: Json | null
          reason?: never
          wamid?: string | null
        }
        Relationships: [
          {
            foreignKeyName: "whatsapp_message_events_clinic_id_fkey"
            columns: ["clinic_id"]
            isOneToOne: false
            referencedRelation: "clinics"
            referencedColumns: ["id"]
          },
        ]
      }
      vw_whatsapp_kpis_daily: {
        Row: {
          clinic_id: string | null
          day: string | null
          delivered: number | null
          failed: number | null
          read: number | null
          send_errors: number | null
          send_requests: number | null
          send_success: number | null
        }
        Relationships: [
          {
            foreignKeyName: "whatsapp_message_events_clinic_id_fkey"
            columns: ["clinic_id"]
            isOneToOne: false
            referencedRelation: "clinics"
            referencedColumns: ["id"]
          },
        ]
      }
    }
    Functions: {
      add_months_clamped: {
        Args: { p_date: string; p_months: number }
        Returns: string
      }
      adjust_my_vet_mapa_prescription_sequence: {
        Args: { p_new_value: number; p_reason: string }
        Returns: number
      }
      apply_stay_plan_balance_adjustment: {
        Args: {
          p_charge_amount?: number
          p_contract_id: string
          p_delta: number
          p_module: string
          p_note?: string
          p_reason: string
          p_remove_charge?: boolean
          p_reverses_id?: string
        }
        Returns: string
      }
      apply_weekly_plan_removal: {
        Args: {
          p_cancel_stay_reservation_day_id?: string
          p_contract_id: string
          p_module: string
          p_note?: string
          p_reason: string
        }
        Returns: string
      }
      assign_vet_mapa_prescription_number: {
        Args: { p_prescription_id: string }
        Returns: {
          mapa_prescription_identifier: string
          mapa_registration_snapshot: string
          sequence_value: number
        }[]
      }
      backfill_daycare_hotel_plan_mirrors: {
        Args: { p_customer_id: string; p_source_clinic_id: string }
        Returns: undefined
      }
      bootstrap_my_organization: {
        Args: { p_clinic_name: string; p_full_name: string; p_phone?: string }
        Returns: string
      }
      calculate_grooming_price: {
        Args: { p_pet_id: string; p_service_id: string }
        Returns: {
          duration_minutes: number
          price: number
        }[]
      }
      calculate_item_price: {
        Args: { p_customer_id: string; p_item_id: string; p_pet_id: string }
        Returns: {
          duration_minutes: number
          price: number
          pricing_type: string
        }[]
      }
      cancel_daycare_plan_future_days: {
        Args: {
          p_contract_id: string
          p_from?: string
          p_scope?: string
          p_source?: string
        }
        Returns: number
      }
      cancel_stay_plan_contract: {
        Args: {
          p_contract_id: string
          p_future_scope?: string
          p_module: string
          p_reference?: string
        }
        Returns: undefined
      }
      check_module_access: {
        Args: { _clinic_id: string; _module_value: string; _user_id: string }
        Returns: boolean
      }
      clinic_professionals_rows: {
        Args: { p_clinic_id: string }
        Returns: {
          current_clinic_id: string
          full_name: string
          id: string
          phone: string
          role: string
        }[]
      }
      commission_accrue_item: {
        Args: { p_sale_item_id: string }
        Returns: undefined
      }
      commission_assert_group_owner: {
        Args: { p_group_id: string; p_kind: string }
        Returns: undefined
      }
      commission_assert_item_owner: {
        Args: { p_item_id: string }
        Returns: string
      }
      commission_assert_model_owner: {
        Args: { p_model_id: string }
        Returns: undefined
      }
      commission_catalog_groups: {
        Args: never
        Returns: {
          id: string
          is_system: boolean
          item_count: number
          kind: string
          name: string
        }[]
      }
      commission_catalog_items: {
        Args: never
        Returns: {
          group_id: string
          id: string
          kind: string
          name: string
        }[]
      }
      commission_clear_group_item_rates: {
        Args: { p_group_id: string; p_kind: string; p_model_id: string }
        Returns: undefined
      }
      commission_customer: { Args: never; Returns: string }
      commission_group_columns: {
        Args: { p_group_id: string; p_kind: string }
        Returns: Record<string, unknown>
      }
      commission_item_group: {
        Args: { p_item_id: string }
        Returns: {
          kind: string
          name: string
          package_subtype_id: string
          product_subtype_id: string
          service_group_id: string
        }[]
      }
      commission_item_group_id:
        | {
            Args: {
              p_package_subtype_id: string
              p_product_subtype_id: string
              p_service_group_id: string
              p_type: Database["public"]["Enums"]["item_type"]
            }
            Returns: string
          }
        | {
            Args: {
              p_package_subtype_id: string
              p_product_subtype_id: string
              p_service_group_id: string
              p_type: string
            }
            Returns: string
          }
      commission_kind_of_item_type:
        | {
            Args: { p_type: Database["public"]["Enums"]["item_type"] }
            Returns: {
              error: true
            } & "Could not choose the best candidate function between: public.commission_kind_of_item_type(p_type => text), public.commission_kind_of_item_type(p_type => item_type). Try renaming the parameters or the function itself in the database so function overloading can be resolved"
          }
        | {
            Args: { p_type: string }
            Returns: {
              error: true
            } & "Could not choose the best candidate function between: public.commission_kind_of_item_type(p_type => text), public.commission_kind_of_item_type(p_type => item_type). Try renaming the parameters or the function itself in the database so function overloading can be resolved"
          }
      commission_list_models: { Args: never; Returns: Json }
      commission_member_models: {
        Args: never
        Returns: {
          full_name: string
          is_self: boolean
          job_title: string
          model_id: string
          user_id: string
        }[]
      }
      commission_member_setup: { Args: { p_user_id: string }; Returns: Json }
      commission_professionals: {
        Args: never
        Returns: {
          full_name: string
          id: string
        }[]
      }
      commission_report: {
        Args: {
          p_from: string
          p_group_id: string
          p_kind: string
          p_professional_id: string
          p_to: string
        }
        Returns: {
          amount: number
          base_amount: number
          entry_kind: string
          group_id: string
          group_name: string
          id: string
          item_name: string
          kind_of_group: string
          occurred_at: string
          percent: number
          professional_id: string
          professional_name: string
          sale_id: string
          sale_number: string
        }[]
      }
      commission_reverse_item: {
        Args: { p_sale_item_ref: string }
        Returns: undefined
      }
      commission_reverse_return_item: {
        Args: { p_return_item_id: string }
        Returns: undefined
      }
      commission_save_model: {
        Args: {
          p_basis: string
          p_id: string
          p_is_active: boolean
          p_name: string
        }
        Returns: string
      }
      commission_set_item_override: {
        Args: { p_item_id: string; p_percent: number; p_user_id: string }
        Returns: undefined
      }
      commission_set_item_rate: {
        Args: { p_item_id: string; p_model_id: string; p_percent: number }
        Returns: undefined
      }
      commission_set_member_model: {
        Args: { p_model_id: string; p_user_id: string }
        Returns: undefined
      }
      commission_set_model_members: {
        Args: { p_model_id: string; p_user_ids: string[] }
        Returns: undefined
      }
      commission_set_override: {
        Args: {
          p_group_id: string
          p_kind: string
          p_percent: number
          p_user_id: string
        }
        Returns: undefined
      }
      commission_set_rate: {
        Args: {
          p_group_id: string
          p_kind: string
          p_model_id: string
          p_percent: number
        }
        Returns: undefined
      }
      commission_ungrouped_items: {
        Args: never
        Returns: {
          id: string
          kind: string
          name: string
        }[]
      }
      commit_appointment_patient_package: {
        Args: { p_appointment_id: string }
        Returns: undefined
      }
      commit_paid_appointment_patient_packages: {
        Args: {
          p_appointment_id: string
          p_package_charges?: Json
          p_sale_id: string
        }
        Returns: undefined
      }
      complete_pet_application_plan: {
        Args: {
          p_completed_at?: string
          p_completed_pet_application_id: string
          p_plan_id: string
        }
        Returns: string
      }
      consume_stay_plan_units: {
        Args: {
          p_contract_id: string
          p_module: string
          p_reservation_id: string
          p_source: string
          p_units: number
          p_used_on: string
        }
        Returns: Json
      }
      contract_daycare_plan_with_reservation: {
        Args: {
          p_charge?: Json
          p_contract: Json
          p_lines?: Json
          p_pack_ids?: string[]
          p_weekdays: number[]
        }
        Returns: Json
      }
      count_daycare_plan_linked_future_days: {
        Args: { p_contract_id: string }
        Returns: number
      }
      create_sale_return: {
        Args: { p_items: Json; p_reason: string; p_sale_id: string }
        Returns: string
      }
      create_stay_incident: {
        Args: {
          p_description: string
          p_log_date: string
          p_logged_at: string
          p_observation_type_id: string
          p_other_pets: Json
          p_primary_pet_role: string
          p_stay_reservation_id: string
        }
        Returns: string
      }
      customer_feature_module_active: {
        Args: { _customer_id: string; _feature_value: string }
        Returns: boolean
      }
      daycare_plan_week_is_active: {
        Args: { p_date: string; p_interval: number; p_starts_on: string }
        Returns: boolean
      }
      debug_user_permissions: {
        Args: { p_clinic_id: string; p_user_id: string }
        Returns: Json
      }
      delete_daycare_plan: { Args: { p_plan_id: string }; Returns: undefined }
      delete_hotel_plan: { Args: { p_plan_id: string }; Returns: undefined }
      disable_daycare_hotel_settings_sync: {
        Args: { p_customer_id: string }
        Returns: undefined
      }
      enable_daycare_hotel_settings_sync: {
        Args: { p_customer_id: string; p_source_clinic_id: string }
        Returns: undefined
      }
      ensure_boarding_statuses: {
        Args: { p_customer_id: string }
        Returns: undefined
      }
      ensure_clinic_appointment_statuses: {
        Args: { p_clinic_id: string }
        Returns: undefined
      }
      extract_clinic_id_from_consultation_audio_path: {
        Args: { path: string }
        Returns: string
      }
      extract_clinic_id_from_exam_path: {
        Args: { path: string }
        Returns: string
      }
      extract_pet_id_from_consultation_audio_path: {
        Args: { path: string }
        Returns: string
      }
      extract_pet_id_from_exam_path: { Args: { path: string }; Returns: string }
      extract_pet_id_from_storage_path: {
        Args: { path: string }
        Returns: string
      }
      filter_sensitive_fields: {
        Args: { data: Json; table_name: string }
        Returns: Json
      }
      financial_apply_sale_payment: {
        Args: { p_payment_id: string }
        Returns: undefined
      }
      financial_apply_sale_payment_safe: {
        Args: { p_payment_id: string }
        Returns: boolean
      }
      financial_apply_sale_return: {
        Args: { p_return_id: string }
        Returns: undefined
      }
      financial_apply_sale_return_safe: {
        Args: { p_return_id: string }
        Returns: boolean
      }
      financial_backfill_sales: {
        Args: { p_clinic_id: string; p_from: string }
        Returns: number
      }
      financial_backfill_sales_internal: {
        Args: { p_clinic_id: string; p_from: string }
        Returns: number
      }
      financial_can: {
        Args: { p_action: string; p_clinic_id: string; p_feature: string }
        Returns: boolean
      }
      financial_can_any: {
        Args: { p_action: string; p_clinic_id: string }
        Returns: boolean
      }
      financial_close_cash_session: {
        Args: { p_operator_name: string; p_session_id: string }
        Returns: undefined
      }
      financial_ensure_defaults: {
        Args: { p_clinic_id: string }
        Returns: undefined
      }
      financial_renegotiate: {
        Args: {
          p_description: string
          p_first_due: string
          p_installments: number
          p_payment_method: string
          p_title_ids: string[]
        }
        Returns: string
      }
      financial_retire_refunds: {
        Args: { p_return_id: string; p_sale_id: string }
        Returns: undefined
      }
      financial_retire_sale_entry: {
        Args: { p_entry_id: string }
        Returns: undefined
      }
      financial_sales_sync_start: {
        Args: { p_clinic_id: string }
        Returns: string
      }
      financial_settle_title: {
        Args: { p_account_id: string; p_paid_at?: string; p_title_id: string }
        Returns: string
      }
      financial_sync_sale_payment: {
        Args: { p_payment_id: string }
        Returns: undefined
      }
      financial_unsettle_title: {
        Args: { p_title_id: string }
        Returns: undefined
      }
      generate_clinic_appointment_status_name: {
        Args: { p_display_name: string; p_scope: string }
        Returns: string
      }
      get_accessible_clinic_id_for_customer: {
        Args: { target_customer_id: string }
        Returns: string
      }
      get_all_profiles: {
        Args: never
        Returns: {
          cpf: string
          crmv_number: number
          crmv_state: string
          email: string
          full_name: string
          id: string
          mapa_number: string
          phone: string
        }[]
      }
      get_application_analytics_rows: {
        Args: { p_clinic_id: string; p_end_at?: string; p_start_at?: string }
        Returns: {
          application_date: string
          application_id: string
          birth_date: string
          breed_name: string
          clinic_id: string
          consultation_date: string
          current_weight: number
          dose_number: number
          item_id: string
          item_name: string
          medical_record_id: string
          notes: string
          owner_id: string
          owner_name: string
          pet_id: string
          pet_name: string
          pet_record_number: string
          professional_name: string
          sex_name: string
          species_name: string
          subtype_name: string
        }[]
      }
      get_application_operations_rows: {
        Args: {
          p_clinic_id: string
          p_end_date?: string
          p_operational_bucket?: string
          p_start_date?: string
        }
        Returns: {
          application_date: string
          appointment_id: string
          appointment_is_overdue: boolean
          appointment_match_source: string
          appointment_starts_at: string
          appointment_status: string
          birth_date: string
          blocked_reason: string
          breed_name: string
          clinic_id: string
          current_operational_status: string
          current_weight: number
          days_overdue: number
          days_until_due: number
          death_date: string
          dose_number: number
          due_date: string
          has_active_appointment: boolean
          has_cloud_api_tracking: boolean
          has_phone_number: boolean
          has_valid_contact: boolean
          has_whatsapp_channel: boolean
          is_overdue: boolean
          item_id: string
          item_name: string
          last_contact_at: string
          last_contact_by: string
          last_contact_channel: string
          last_contact_result: string
          last_contact_source: string
          last_dispatch_status: string
          notes: string
          operational_bucket: string
          overdue_bucket: string
          overdue_reason: string
          owner_id: string
          owner_name: string
          owner_whatsapp_parent_user_id: string
          owner_whatsapp_user_id: string
          owner_whatsapp_username: string
          owner_whatsapp_wa_id: string
          pet_application_id: string
          pet_application_plan_id: string
          pet_id: string
          pet_name: string
          pet_record_number: string
          preferred_phone: string
          reference_date: string
          sex_name: string
          species_name: string
          subtype_name: string
          view_bucket: string
        }[]
      }
      get_appointment_heatmap: {
        Args: { p_clinic_id: string; p_date_from: string; p_date_to: string }
        Returns: {
          count: number
          day_of_week: number
          shift: string
        }[]
      }
      get_clinic_appointment_statuses: {
        Args: {
          p_clinic_id: string
          p_include_inactive?: boolean
          p_scope?: string
        }
        Returns: Json
      }
      get_clinic_professionals: {
        Args: { p_clinic_id: string }
        Returns: {
          current_clinic_id: string
          full_name: string
          id: string
          phone: string
          role: string
        }[]
      }
      get_current_customer_id: { Args: never; Returns: string }
      get_current_user_clinic_id: { Args: never; Returns: string }
      get_item_pricing_options: {
        Args: { p_customer_id: string; p_item_id: string }
        Returns: {
          breed_id: string
          breed_name: string
          duration_minutes: number
          is_active: boolean
          price: number
          pricing_id: string
          size_category_id: string
          size_category_name: string
        }[]
      }
      get_mapa_prescriptions_report: {
        Args: {
          p_from: string
          p_mapa_mode?: string
          p_page?: number
          p_page_size?: number
          p_search?: string
          p_sequence?: string
          p_to: string
          p_vet_id?: string
        }
        Returns: {
          identifier: string
          issued_at: string
          medical_record_id: string
          owner_id: string
          owner_name: string
          pet_id: string
          pet_name: string
          prescription_id: string
          sequence_value: number
          signed_at: string
          total_count: number
          vet_name: string
        }[]
      }
      get_mapa_report_veterinarians: {
        Args: never
        Returns: {
          full_name: string
          id: string
        }[]
      }
      get_my_clinic_role: {
        Args: { p_clinic_id: string }
        Returns: {
          is_groomer: boolean
          is_veterinarian: boolean
          role_value: string
        }[]
      }
      get_next_whatsapp_application_reminder_trigger: {
        Args: { _clinic_id: string }
        Returns: {
          due_date: string
          next_trigger_at: string
          pet_application_id: string
        }[]
      }
      get_owners_with_pets: {
        Args: {
          p_customer_id: string
          p_limit?: number
          p_offset?: number
          p_search?: string
        }
        Returns: {
          owner_created_at: string
          owner_document: string
          owner_emails: Json
          owner_id: string
          owner_name: string
          owner_phones: Json
          pet_birth_date: string
          pet_breed: Json
          pet_count: number
          pet_created_at: string
          pet_death_date: string
          pet_id: string
          pet_name: string
          pet_photo: Json
          pet_record_number: string
          pet_species: Json
          pet_status: Json
          total_count: number
        }[]
      }
      get_package_stock_components_for_application: {
        Args: { p_clinic_id: string; p_item_id: string }
        Returns: {
          item_id: string
          quantity: number
        }[]
      }
      get_pet_application_plan_rows: {
        Args: {
          p_clinic_id: string
          p_end_date?: string
          p_pet_id?: string
          p_start_date?: string
          p_statuses?: string[]
        }
        Returns: {
          appointment_id: string
          clinic_id: string
          completed_at: string
          completed_pet_application_id: string
          due_date: string
          is_overdue: boolean
          item_id: string
          item_name: string
          notes: string
          owner_id: string
          owner_name: string
          pet_id: string
          pet_name: string
          plan_id: string
          source_pet_application_id: string
          source_type: string
          status: string
        }[]
      }
      get_pet_applications_report_rows: {
        Args: {
          p_clinic_id?: string
          p_item_ids?: string[]
          p_min_application_date?: string
          p_pet_ids: string[]
        }
        Returns: {
          application_date: string
          created_at: string
          id: string
          item_id: string
          pet_id: string
        }[]
      }
      get_record_audit_history: {
        Args: { _record_id: string; _table_name: string }
        Returns: {
          action: string
          changed_at: string
          changed_by: string
          changed_fields: string[]
          new_values: Json
          old_values: Json
        }[]
      }
      get_role_priority: { Args: { _role: string }; Returns: number }
      get_stay_reservation_audit: {
        Args: { p_limit?: number; p_reservation_id: string }
        Returns: {
          action: string
          actor_id: string
          actor_name: string
          changed_fields: string[]
          log_id: string
          new_values: Json
          occurred_at: string
          old_values: Json
          record_id: string
          table_name: string
        }[]
      }
      get_user_accessible_clinics: {
        Args: never
        Returns: {
          clinic_id: string
        }[]
      }
      get_user_accessible_customers: {
        Args: never
        Returns: {
          customer_id: string
        }[]
      }
      get_user_all_permissions: {
        Args: { _clinic_id: string; _user_id: string }
        Returns: Json
      }
      get_user_audit_actions: {
        Args: { _limit?: number; _user_id: string }
        Returns: {
          action: string
          changed_fields: string[]
          created_at: string
          record_id: string
          table_name: string
        }[]
      }
      get_user_clinic_customer_ids: {
        Args: never
        Returns: {
          customer_id: string
        }[]
      }
      get_user_clinic_role: {
        Args: { _clinic_id: string; _user_id: string }
        Returns: {
          is_groomer: boolean
          is_veterinarian: boolean
          role_id: string
          role_value: string
        }[]
      }
      get_user_customer_id: { Args: never; Returns: string }
      get_user_customer_role: {
        Args: { _clinic_id: string; _user_id: string }
        Returns: {
          role_code: string
          role_id: string
          role_value: string
        }[]
      }
      get_user_emails: {
        Args: { user_ids: string[] }
        Returns: {
          email: string
          user_id: string
        }[]
      }
      get_user_feature_permission: {
        Args: {
          _action: string
          _clinic_id: string
          _feature_value: string
          _user_id: string
        }
        Returns: boolean
      }
      get_user_profile_for_permissions: {
        Args: { target_user_id: string }
        Returns: {
          customer_id: string
          full_name: string
          id: string
        }[]
      }
      get_user_role_in_clinic: {
        Args: { target_clinic_id: string }
        Returns: {
          role_id: string
          role_value: string
        }[]
      }
      get_user_role_in_customer: {
        Args: { target_customer_id: string }
        Returns: {
          role_id: string
          role_value: string
        }[]
      }
      get_users_by_customer_clinics: {
        Args: { customer_uuid: string }
        Returns: {
          current_clinic_id: string
          customer_id: string
          full_name: string
          id: string
          phone: string
        }[]
      }
      get_whatsapp_application_reminder_candidates: {
        Args: {
          _clinic_id: string
          _offset_unit?: string
          _offset_value?: number
          _send_time?: string
          _timezone?: string
          _window_end?: string
          _window_start?: string
        }
        Returns: {
          death_date: string
          due_date: string
          has_notification_signal: boolean
          item_name: string
          last_dispatch_status: string
          operational_bucket: string
          owner_id: string
          owner_name: string
          owner_whatsapp_parent_user_id: string
          owner_whatsapp_user_id: string
          owner_whatsapp_username: string
          owner_whatsapp_wa_id: string
          pet_application_id: string
          pet_application_plan_id: string
          pet_name: string
          preferred_phone: string
          scheduled_send_at: string
          whatsapp_opt_out: boolean
        }[]
      }
      get_whatsapp_application_reminder_dose_state: {
        Args: { _clinic_id: string; _pet_application_id?: string }
        Returns: {
          can_retry: boolean
          due_date: string
          is_already_sent: boolean
          latest_created_at: string
          latest_dispatch_id: string
          latest_status: string
          pet_application_id: string
        }[]
      }
      has_role: { Args: { _role: string; _user_id: string }; Returns: boolean }
      is_super_admin: { Args: never; Returns: boolean }
      log_audit_change: {
        Args: {
          p_action: string
          p_changed_fields?: string[]
          p_ip_address?: unknown
          p_metadata?: Json
          p_new_values?: Json
          p_old_values?: Json
          p_record_id: string
          p_table_name: string
          p_user_agent?: string
        }
        Returns: string
      }
      log_fiscal_document_event: {
        Args: {
          p_created_by?: string
          p_event_payload?: Json
          p_event_source?: string
          p_event_type: string
          p_fiscal_document_id: string
        }
        Returns: string
      }
      log_permission_change: {
        Args: {
          p_action: string
          p_changed_fields?: string[]
          p_ip_address?: unknown
          p_metadata?: Json
          p_new_value?: Json
          p_old_value?: Json
          p_resource_id: string
          p_resource_key?: string
          p_resource_type: string
          p_target_user_id?: string
          p_user_agent?: string
        }
        Returns: string
      }
      match_pet_application_plan: {
        Args: {
          p_application_date: string
          p_clinic_id: string
          p_item_id: string
          p_pet_id: string
          p_window_days?: number
        }
        Returns: {
          appointment_id: string
          clinic_id: string
          created_at: string
          distance_seconds: number
          due_date: string
          item_id: string
          notes: string
          pet_id: string
          plan_id: string
          source_type: string
          status: string
        }[]
      }
      materialize_active_daycare_plan_cycles: {
        Args: { p_reference?: string }
        Returns: number
      }
      materialize_daycare_plan_cycle: {
        Args: { p_contract_id: string; p_from?: string; p_revive?: boolean }
        Returns: number
      }
      materialize_stay_package_dates: {
        Args: { p_contract_id: string; p_dates: string[]; p_module: string }
        Returns: number
      }
      next_vet_prescription_sequence: {
        Args: { p_vet_user_id: string }
        Returns: number
      }
      owner_id_has_access: {
        Args: { target_owner_id: string }
        Returns: boolean
      }
      pet_id_has_access: { Args: { target_pet_id: string }; Returns: boolean }
      preview_weekly_plan_removal: {
        Args: {
          p_contract_id: string
          p_module: string
          p_reference_date?: string
        }
        Returns: Json
      }
      promote_stay_plan_hold: {
        Args: { p_module: string; p_reservation_id: string; p_used_on: string }
        Returns: number
      }
      reconcile_appointment_financial: {
        Args: { p_appointment_id: string }
        Returns: {
          appointment_id: string
          created_at: string
          is_covered_by_package: boolean
          owner_package_id: string | null
          sale_id: string | null
          source: Database["public"]["Enums"]["appointment_financial_source"]
          status: Database["public"]["Enums"]["appointment_financial_status"]
          updated_at: string
          updated_by: string | null
        }
        SetofOptions: {
          from: "*"
          to: "appointment_financials"
          isOneToOne: true
          isSetofReturn: false
        }
      }
      release_stay_plan_units: {
        Args: {
          p_module: string
          p_reservation_id: string
          p_source: string
          p_used_on: string
        }
        Returns: number
      }
      reserve_pet_record_number: { Args: never; Returns: string }
      resolve_daycare_hotel_settings_clinic_id: {
        Args: { p_clinic_id: string }
        Returns: string
      }
      reverse_weekly_plan_removal: {
        Args: {
          p_contract_id: string
          p_module: string
          p_note?: string
          p_reason?: string
          p_reverses_adjustment_id: string
        }
        Returns: string
      }
      roll_stay_plan_cycles: { Args: { p_reference?: string }; Returns: number }
      save_daycare_plan: { Args: { p_input: Json }; Returns: string }
      save_hotel_plan: { Args: { p_input: Json }; Returns: string }
      search_sales_explorer: {
        Args: {
          p_appointment_statuses?: string[]
          p_appointment_type_ids?: string[]
          p_breed_ids?: string[]
          p_category_ids?: string[]
          p_financial_status?: string
          p_from: string
          p_item_count_operator?: string
          p_item_count_scope?: string
          p_item_count_value?: number
          p_item_ids?: string[]
          p_item_types?: string[]
          p_owner_city?: string
          p_owner_neighborhood?: string
          p_owner_search?: string
          p_page?: number
          p_page_size?: number
          p_professional_ids?: string[]
          p_size_category_ids?: string[]
          p_species_ids?: string[]
          p_to: string
          p_weight_max?: number
          p_weight_min?: number
        }
        Returns: {
          average_value: number
          result_format: string
          result_rows: Json
          total_count: number
          total_quantity: number
          total_value: number
        }[]
      }
      seed_stay_activity_types: {
        Args: { p_clinic_id: string }
        Returns: undefined
      }
      set_clinic_appointment_statuses: {
        Args: { p_clinic_id: string; p_scope: string; p_statuses: Json }
        Returns: Json
      }
      set_clinic_default_appointment_durations: {
        Args: { p_clinic_id: string; p_durations: Json }
        Returns: Json
      }
      set_clinic_show_appointment_items_on_cards: {
        Args: { p_clinic_id: string; p_enabled: boolean }
        Returns: Json
      }
      set_daycare_plan_contract_days: {
        Args: { p_contract_id: string; p_weekdays: number[] }
        Returns: number
      }
      set_stay_plan_contract_paused: {
        Args: {
          p_contract_id: string
          p_future_scope?: string
          p_module: string
          p_paused: boolean
        }
        Returns: undefined
      }
      show_limit: { Args: never; Returns: number }
      show_trgm: { Args: { "": string }; Returns: string[] }
      soft_delete_appointment: {
        Args: { p_appointment_id: string }
        Returns: undefined
      }
      soft_delete_item: { Args: { p_item_id: string }; Returns: undefined }
      soft_delete_owner: { Args: { p_owner_id: string }; Returns: undefined }
      soft_delete_pet: { Args: { p_pet_id: string }; Returns: undefined }
      soft_delete_pet_application: {
        Args: { p_application_id: string; p_deleted_at?: string }
        Returns: string
      }
      soft_delete_pet_application_plan: {
        Args: { p_deleted_at?: string; p_plan_id: string }
        Returns: string
      }
      stay_plan_cycle_index: {
        Args: { p_first_due_on: string; p_reference: string }
        Returns: number
      }
      suggest_pet_record_number: { Args: never; Returns: string }
      switch_daycare_plan_contract: {
        Args: {
          p_contract_id: string
          p_new_plan_id: string
          p_starts_on?: string
          p_weekdays: number[]
        }
        Returns: Json
      }
      switch_stay_plan_contract: {
        Args: {
          p_contract_id: string
          p_module: string
          p_new_plan_id: string
          p_starts_on?: string
        }
        Returns: string
      }
      sync_pet_application_derived_plan: {
        Args: { p_pet_application_id: string }
        Returns: string
      }
      team_current_clinic: { Args: never; Returns: string }
      team_get_compensation: { Args: { p_user_id: string }; Returns: Json }
      team_get_member: { Args: { p_user_id: string }; Returns: Json }
      team_get_member_permissions: {
        Args: { p_user_id: string }
        Returns: Json
      }
      team_list_members: {
        Args: never
        Returns: {
          avatar_url: string
          cpf: string
          email: string
          full_name: string
          is_owner: boolean
          job_title: string
          phone: string
          role_value: string
          terminated_at: string
          user_id: string
        }[]
      }
      team_require: {
        Args: { p_action: string; p_feature: string }
        Returns: string
      }
      team_require_target: {
        Args: {
          p_clinic: string
          p_lock_owner: boolean
          p_lock_self: boolean
          p_user_id: string
        }
        Returns: string
      }
      team_reset_permissions: {
        Args: { p_user_id: string }
        Returns: undefined
      }
      team_set_permission: {
        Args: {
          p_action: string
          p_allowed: boolean
          p_feature: string
          p_user_id: string
        }
        Returns: undefined
      }
      team_set_role: {
        Args: { p_role_value: string; p_user_id: string }
        Returns: undefined
      }
      team_set_salary: {
        Args: {
          p_base_salary: number
          p_salary_payday: number
          p_salary_period: string
          p_user_id: string
        }
        Returns: undefined
      }
      team_update_member: {
        Args: {
          p_birth_date: string
          p_cpf: string
          p_employment_type: string
          p_full_name: string
          p_hired_at: string
          p_is_groomer: boolean
          p_is_veterinarian: boolean
          p_job_title: string
          p_phone: string
          p_terminated_at: string
          p_user_id: string
        }
        Returns: undefined
      }
      update_stay_plan_contract_terms: {
        Args: {
          p_billing_timing?: string
          p_carryover_enabled?: boolean
          p_contract_id: string
          p_module: string
          p_price?: number
          p_usage_limit?: number
        }
        Returns: undefined
      }
      upsert_application_follow_up_tracking: {
        Args: {
          p_blocked_reason?: string
          p_clinic_id: string
          p_due_date: string
          p_last_contact_at?: string
          p_last_contact_channel?: string
          p_last_contact_result?: string
          p_last_contact_source?: string
          p_notes?: string
          p_operational_status?: string
          p_pet_application_id: string
          p_pet_application_plan_id?: string
        }
        Returns: {
          blocked_reason: string | null
          clinic_id: string
          created_at: string
          due_date: string
          id: string
          last_contact_at: string | null
          last_contact_by: string | null
          last_contact_channel: string | null
          last_contact_result: string | null
          last_contact_source: string | null
          notes: string | null
          operational_status: string
          pet_application_id: string | null
          pet_application_plan_id: string | null
          updated_at: string
        }
        SetofOptions: {
          from: "*"
          to: "application_follow_up_tracking"
          isOneToOne: true
          isSetofReturn: false
        }
      }
      upsert_stay_managed_catalog_item: {
        Args: {
          p_active: boolean
          p_clinic_id: string
          p_entity_id?: string
          p_name: string
          p_price: number
          p_system_code: string
        }
        Returns: undefined
      }
      user_has_clinic_access: {
        Args: { target_clinic_id: string }
        Returns: boolean
      }
      user_has_current_customer_access: {
        Args: { target_customer_id: string }
        Returns: boolean
      }
      user_has_customer_access: {
        Args: { target_customer_id: string }
        Returns: boolean
      }
      user_has_customer_or_clinic_access: {
        Args: { target_customer_id: string }
        Returns: boolean
      }
    }
    Enums: {
      appointment_financial_source: "avulso" | "pacote" | "misto" | "manual"
      appointment_financial_status: "pendente" | "pago" | "nao_cobrado"
      appointment_package_consumption_status:
        | "planned"
        | "consumed"
        | "canceled"
      appointment_package_mode: "new" | "existing"
      hospitalization_status: "ativa" | "alta" | "obito"
      item_type: "PRODUTO" | "SERVICO" | "PACOTE"
      movement_type:
        | "ENTRADA"
        | "SAIDA"
        | "TRANSFERENCIA"
        | "AJUSTE_POSITIVO"
        | "AJUSTE_NEGATIVO"
        | "CONSUMO_INTERNO"
        | "DEVOLUCAO_CLIENTE"
        | "DEVOLUCAO_FORNECEDOR"
      package_charge_mode:
        | "antecipado"
        | "por_sessao"
        | "parcelado"
        | "no_final"
      package_financial_status: "pendente" | "parcial" | "pago"
      payment_method:
        | "DINHEIRO"
        | "CARTAO_DEBITO"
        | "CARTAO_CREDITO"
        | "PIX"
        | "A_RECEBER"
      po_status: "RASCUNHO" | "ENVIADO" | "RECEBIDO" | "CANCELADO"
      sale_status: "RASCUNHO" | "ABERTA" | "PAGA" | "CANCELADA" | "DEVOLVIDA"
      sipeagro_registration_status: "Ativo" | "Suspenso" | "Cancelado"
    }
    CompositeTypes: {
      [_ in never]: never
    }
  }
}

type DatabaseWithoutInternals = Omit<Database, "__InternalSupabase">

type DefaultSchema = DatabaseWithoutInternals[Extract<keyof Database, "public">]

export type Tables<
  DefaultSchemaTableNameOrOptions extends
    | keyof (DefaultSchema["Tables"] & DefaultSchema["Views"])
    | { schema: keyof DatabaseWithoutInternals },
  TableName extends DefaultSchemaTableNameOrOptions extends {
    schema: keyof DatabaseWithoutInternals
  }
    ? keyof (DatabaseWithoutInternals[DefaultSchemaTableNameOrOptions["schema"]]["Tables"] &
        DatabaseWithoutInternals[DefaultSchemaTableNameOrOptions["schema"]]["Views"])
    : never = never,
> = DefaultSchemaTableNameOrOptions extends {
  schema: keyof DatabaseWithoutInternals
}
  ? (DatabaseWithoutInternals[DefaultSchemaTableNameOrOptions["schema"]]["Tables"] &
      DatabaseWithoutInternals[DefaultSchemaTableNameOrOptions["schema"]]["Views"])[TableName] extends {
      Row: infer R
    }
    ? R
    : never
  : DefaultSchemaTableNameOrOptions extends keyof (DefaultSchema["Tables"] &
        DefaultSchema["Views"])
    ? (DefaultSchema["Tables"] &
        DefaultSchema["Views"])[DefaultSchemaTableNameOrOptions] extends {
        Row: infer R
      }
      ? R
      : never
    : never

export type TablesInsert<
  DefaultSchemaTableNameOrOptions extends
    | keyof DefaultSchema["Tables"]
    | { schema: keyof DatabaseWithoutInternals },
  TableName extends DefaultSchemaTableNameOrOptions extends {
    schema: keyof DatabaseWithoutInternals
  }
    ? keyof DatabaseWithoutInternals[DefaultSchemaTableNameOrOptions["schema"]]["Tables"]
    : never = never,
> = DefaultSchemaTableNameOrOptions extends {
  schema: keyof DatabaseWithoutInternals
}
  ? DatabaseWithoutInternals[DefaultSchemaTableNameOrOptions["schema"]]["Tables"][TableName] extends {
      Insert: infer I
    }
    ? I
    : never
  : DefaultSchemaTableNameOrOptions extends keyof DefaultSchema["Tables"]
    ? DefaultSchema["Tables"][DefaultSchemaTableNameOrOptions] extends {
        Insert: infer I
      }
      ? I
      : never
    : never

export type TablesUpdate<
  DefaultSchemaTableNameOrOptions extends
    | keyof DefaultSchema["Tables"]
    | { schema: keyof DatabaseWithoutInternals },
  TableName extends DefaultSchemaTableNameOrOptions extends {
    schema: keyof DatabaseWithoutInternals
  }
    ? keyof DatabaseWithoutInternals[DefaultSchemaTableNameOrOptions["schema"]]["Tables"]
    : never = never,
> = DefaultSchemaTableNameOrOptions extends {
  schema: keyof DatabaseWithoutInternals
}
  ? DatabaseWithoutInternals[DefaultSchemaTableNameOrOptions["schema"]]["Tables"][TableName] extends {
      Update: infer U
    }
    ? U
    : never
  : DefaultSchemaTableNameOrOptions extends keyof DefaultSchema["Tables"]
    ? DefaultSchema["Tables"][DefaultSchemaTableNameOrOptions] extends {
        Update: infer U
      }
      ? U
      : never
    : never

export type Enums<
  DefaultSchemaEnumNameOrOptions extends
    | keyof DefaultSchema["Enums"]
    | { schema: keyof DatabaseWithoutInternals },
  EnumName extends DefaultSchemaEnumNameOrOptions extends {
    schema: keyof DatabaseWithoutInternals
  }
    ? keyof DatabaseWithoutInternals[DefaultSchemaEnumNameOrOptions["schema"]]["Enums"]
    : never = never,
> = DefaultSchemaEnumNameOrOptions extends {
  schema: keyof DatabaseWithoutInternals
}
  ? DatabaseWithoutInternals[DefaultSchemaEnumNameOrOptions["schema"]]["Enums"][EnumName]
  : DefaultSchemaEnumNameOrOptions extends keyof DefaultSchema["Enums"]
    ? DefaultSchema["Enums"][DefaultSchemaEnumNameOrOptions]
    : never

export type CompositeTypes<
  PublicCompositeTypeNameOrOptions extends
    | keyof DefaultSchema["CompositeTypes"]
    | { schema: keyof DatabaseWithoutInternals },
  CompositeTypeName extends PublicCompositeTypeNameOrOptions extends {
    schema: keyof DatabaseWithoutInternals
  }
    ? keyof DatabaseWithoutInternals[PublicCompositeTypeNameOrOptions["schema"]]["CompositeTypes"]
    : never = never,
> = PublicCompositeTypeNameOrOptions extends {
  schema: keyof DatabaseWithoutInternals
}
  ? DatabaseWithoutInternals[PublicCompositeTypeNameOrOptions["schema"]]["CompositeTypes"][CompositeTypeName]
  : PublicCompositeTypeNameOrOptions extends keyof DefaultSchema["CompositeTypes"]
    ? DefaultSchema["CompositeTypes"][PublicCompositeTypeNameOrOptions]
    : never

export const Constants = {
  graphql_public: {
    Enums: {},
  },
  public: {
    Enums: {
      appointment_financial_source: ["avulso", "pacote", "misto", "manual"],
      appointment_financial_status: ["pendente", "pago", "nao_cobrado"],
      appointment_package_consumption_status: [
        "planned",
        "consumed",
        "canceled",
      ],
      appointment_package_mode: ["new", "existing"],
      hospitalization_status: ["ativa", "alta", "obito"],
      item_type: ["PRODUTO", "SERVICO", "PACOTE"],
      movement_type: [
        "ENTRADA",
        "SAIDA",
        "TRANSFERENCIA",
        "AJUSTE_POSITIVO",
        "AJUSTE_NEGATIVO",
        "CONSUMO_INTERNO",
        "DEVOLUCAO_CLIENTE",
        "DEVOLUCAO_FORNECEDOR",
      ],
      package_charge_mode: [
        "antecipado",
        "por_sessao",
        "parcelado",
        "no_final",
      ],
      package_financial_status: ["pendente", "parcial", "pago"],
      payment_method: [
        "DINHEIRO",
        "CARTAO_DEBITO",
        "CARTAO_CREDITO",
        "PIX",
        "A_RECEBER",
      ],
      po_status: ["RASCUNHO", "ENVIADO", "RECEBIDO", "CANCELADO"],
      sale_status: ["RASCUNHO", "ABERTA", "PAGA", "CANCELADA", "DEVOLVIDA"],
      sipeagro_registration_status: ["Ativo", "Suspenso", "Cancelado"],
    },
  },
} as const

